var _rect, _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagMex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -256,
    y: -149.35,
    rx: 0,
    ry: 0,
    width: 512,
    height: 298.7,
    transform: "matrix(1.9509 0 0 2.4519 499.43 500.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#2e6a4a",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -85.2,
    y: -149.35,
    rx: 0,
    ry: 0,
    width: 170.4,
    height: 298.7,
    transform: "matrix(1.9509 0 0 2.4519 167.582 500.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#bd1f34",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -85.2,
    y: -149.35,
    rx: 0,
    ry: 0,
    width: 170.4,
    height: 298.7,
    transform: "matrix(1.9509 0 0 2.4519 832.644 500.126)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.6 222.6s-3.1.3-5.2-.1-1.7-5.8-1.7-6c-.1-.2-1.3-1.5-1.1-2.7.2-1.2 4.1-4.4 4.7-4.6.4-.1 1.1.2 1.1.2s1-1 1.3-1c.3 0 .7.6.6.8-.1.2-1.5 1-1.6 1.6-.1.6 0 1.2-.4 1.8-.4.6-1.1 1.4-1.2 1.9-.1.5-.3.9.1 1.1.4.2 1.7 0 2.8-.5 1.1-.5 1.6-1.2 1.7-1.1.2.1-.6 1.4-1.9 1.9-1.2.5-2 1.1-2.6 1 0 0-.7 1.6 1.4 1.7 2.1.1 3.2-.5 3.2-.5l-1.2 4.5zM216.7 235.4s1.6.6 1.6 2.4-1.8 3.3-1.7 6.4c0 3.2.5 3.2 4.7 6.6.1.1 1 1 1.3 2 .2 1 1 7.1 5 7.1s4.6-2.6 4.6-2.6l-1.7-2.5s-1.4.4-2.2.2c-.8-.2-1.4-.7-1.9-1.7-.4-1-.6-3.3-1.3-4.3-1.7-2.5-4.7-3-4.7-5.6 0-2.7 1.9-2.9 1.3-6.1-.5-3.2-4.3-4.7-4.3-4.7l-1.5-.6-.5 3.2 1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#e4a530",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M227.8 213.3c1.3-.3.6-3.8.6-3.8l-.9.8s.6.8.6 1.6c-.1.7-.3 1.4-.3 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M230.2 248.4s-.6-.5-.7-.6c-.5-.3-2.6-2-2.3-7.1.4-5.7 8.7-8.8 9.3-11 .6-2.5 2.5-3.6-4.1-8.8l-1.6 1.8 2.7 2s.6-.3.6.4c0 .8-.7 1.4-.9 2-.2.6-4.3 3.4-4.6 3.7-.3.3-2.4 1.9-2.4 1.9s-1.1 1.1-2.1 3.3c-1 2.2-.5 5.1-.5 5.1s.1 6.1 6.6 7.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m226.2 251.6.5 2.2-1.3.5h-.6l-.4.2-1 1-.3-.1s-.2 0-.2-.6-.1-1.2-.1-1.2l1.3.5h.4l.3-.1.5-1.2.9-1.2zM222.3 252s-.4-.5-.6-.8c-.2-.3-.3-.3-.7-.7l.9-.5h1l-.1 1.2-.5.8zM224.5 248.5s.6.3.8.8c.2.5.5 1 .5 1l-1.6-.1-1.2-.4.8-1.1.7-.2zM223.9 258s-.3-.2-.5-.7c-.2-.5-.3-1.3-.3-1.3l1-.2 1.2.5h.3l-.3.6-1.2 1-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228 254.8s-.9-.3-1.1-.7c-.1-.5-.3-.4-.3-.4l-.3 1.2-.3 1.1.1.2.9-.2c.1 0 .7-.7.7-.7.1-.1.3-.5.3-.5M224.2 258.6s.4.2 1.1.6c.6.4 1 .4 1 .4l.5-.5.5-1 .1-.1-2.5.2-.7.4zM227.7 257.6l2.1-1.3.1-1.1-.4-.3h-1.2l-.4 1.4-.2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M226.2 259.6s1.5.6 4-.3c1.1-.4 1.4-1 1.4-1l-1-.4-1 .9-3.4.8zM224.2 243.4s-.1-.5-.3-1.1c-.1-.6-.1-.9-.1-.9l.7.4 1.1.8-.8.6-.6.2zM226 246.4s-.4-.4-.7-.8c-.3-.5-.5-.9-.5-.9l.8.2.9.4-.4 1.2-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c3c6a4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M221.3 212.8c-.1.5-.3 1.4.4 1.6.4.1 1.9 0 3.6-2 .8-.9.8-1.9.8-1.9l.3-1.1s-.7-.5-1.8.2c-.9.7-3.3 3.2-3.3 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#242933",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M226 209.7c.2 0 .3.1.3.3 0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3 0-.1.1-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M223.8 210.4c-.7.6-1.4 1.3-1.4 1.3s1.2-.3 2.1-1.2c.5-.5 1.6-.7 2.1-.5.3.1.2-.3.1-.4-.3-.2-1.2-.4-1.3-.2-.1 0-.9.4-1.6 1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M227.3 242.8s0-.2-.1-.9v-.9l-.7.6-.7.9 1 .4.5-.1zM223.7 240.7s-.1-.9 0-1.8c0-.9.4-2.5.4-2.5l.4 1.1 1.3 2 .4.3-1.1.8-1.1.3-.3-.2zM227.3 240.2s.1-.4.2-.9c.1-.4.4-1 .4-1v.1l-1.1.9-.5.4.6.5h.4M224.4 235.6s.2-.6.7-1.3c.6-.7 1.1-1.4 1.1-1.4l.5 1.9.3 1.6v.3s-.4.2-.5.2c-.2 0-1.3-.1-1.5-.3-.1-.2-.6-1-.6-1M228.2 237.8l.7-.7c.3-.3.8-.9.8-.9l-2.6.5.4.9.7.2zM226.7 232.5s.2-.1.9-.8c.7-.7 1-.6 1-.6l.3 2.8-1.4-.4-.8-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.3 1.15 1.6-1.6-2.6-.7.5 1.8z",
    transform: "matrix(1.9509 0 0 2.4519 448.902 448.39)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m230.9 232 .2-2.7s-.5.3-1.2.8c-.7.6-1 .7-1 .7l.3.5.9.6.8.1zM233.2 229.4v-2.1h-.1s-.4.6-.8.9l-.6.6.7.4.8.2zM234.2 232.2s.7-.6 1.3-1c.8-.6 1.2-1.3 1.2-1.3l-3.3-.3.1 1.3.7 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-1.4 1.1h2.8L.7.2l-.8-.5-.8-.8-.4.8z",
    transform: "matrix(1.9509 0 0 2.4519 444.22 415.413)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.8 234.2c.1-.1.9-.6 1.2-1 .4-.4 1-.8 1-.8l-2.6-.3v1.7l.4.4zM236.8 229.4s.3-1.1.3-2.1-.2-1.5-.2-1.5l-2 1.3.3 1 .8.8.8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.4 227s.6-.7.6-1.1v-.3h1.6l.9.1.1.1-.7.8-1 .6-1.2.1-.3-.3zM236.6 225.4s-.6-1-.9-1.6c-.3-.6-.7-.9-.7-.9l-.8 2.3-.1.2h2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m217.3 240.9-.3.6s1-.5 1.8-.5 1.7 1 1.7 1l.2-.7s-1.1-1-1.8-1.1c-.6 0-1.6.7-1.6.7m.5-4.6s.2.3.3.3c0 .1.1-.8 1.1-1.2 1.1-.4 1.6-.1 1.6-.1s-.2-.6-.7-.7c-.5-.1-.9 0-1.5.4-.5.3-.8 1.3-.8 1.3m3.6 3.5s-.5-1-1.3-1.3c-.9-.2-1.9.4-1.9.4l-.2.6s1.2-.7 2-.3c.9.3 1.2 1.3 1.2 1.3l.2-.7zm-4-4.1c0 .2.3.4.3.4s-.1-1.1.4-1.7c.5-.6.9-.8.9-.8l-.5-.2s-.7.5-.9 1c-.3.4-.3 1.1-.2 1.3m-.5-1.9c.2-.6 1-.8 1-.8l-.2-.2c-.2-.1-.3 0-.3 0s-.5.2-.7.9c-.3.6-.2 1.5-.2 1.5l.4.2c-.1.1-.2-1 0-1.6m6.3-15.2c.7-.4 1.1-.3 1.1-.3s-1 1-.5 2.3c-.6 1.1-.7 1.9-.7 1.9h.5s.2-.8.4-1.5c.6 1.1 1.5 1.7 1.5 1.7h.8s0-1.1.4-2l.1.1c.9.9 1.6 1.1 1.6 1.1v-.3s-.9-.5-1.4-1.2v-.1c.6-1 1.5-1.3 1.5-1.3l.6.5.1-.2-.4-.5h-.5s-.9.7-1.4 1.3c-.4-.6-.6-1.3-.6-1.3l-.3-.1s-.9.1-1.6 1.3c-.1-.9 1-1.9 1-1.9l-.1-.4s-1.1.2-1.9.4c-.8.2-1.3 1-1.3 1v.6c-.3.1.5-.8 1.1-1.1m1.2 1.7c.5-.7 1.6-1.2 1.6-1.2s0 .6.6 1.3c-.4.7-.6 1.8-.6 1.8s-.8-.5-1.6-1.6c0-.1-.1-.2-.1-.2s0-.1.1-.1m-6.1 16.9v.6s.6-.7 1.6-.7c.9 0 1.8.7 1.8.7s0-.8-.1-.9c-.1-.1-.9-.5-1.6-.5-.8 0-1.7.8-1.7.8m17.1-9-.4-.8c.1-.1.3-.1.4-.2.8-.6 1.4-1.3 1.4-1.3l-.3-.5h-1.3c-.3 0-.8-.1-1.1-.1 0-.2.2-.8.4-1.3.2-.7.4-1.1.4-1.1l-.4-.4s.1.4-.7.5c-.8.1-2.2-.6-2.2-.6v.3s1.3.4 2 .5c.4.1.8-.1 1-.2-.1.2-.3.7-.4 1.1-.1.3-.2.6-.2.7 0 .1.1.2.1.2l-.1.7s.8.1 1.1.1c.4 0 1.3.1 1.3.1s-.7.8-1.4 1.1c-.1 0-.2.1-.3.1 0-.1-.8-1.3-.8-1.3l-.1.4s.6.8.6.9c-.5.1-1.2-.1-1.2-.1l-.3.3v2c-.7-.2-1.4-.5-1.4-.5l-.3.2-.4.3s-.3 1.2-.2 2.5v.1c-1.3-.3-1.9-1.1-1.9-1.1l-.3.3s-.2 1.2.1 2.6c-1.1-.2-2-1.2-2-1.2l-.4.3s.2 2.3.5 3.5c0 .1.1.2.1.3h-.6c-1.1 0-1.8-1.1-1.8-1.1l-.3.8s.4 2.2 1.6 3.1c.1.1.2.2.3.2-1 .8-2.3 1-2.3 1l.1.7s.7.6 1.5 1.1c.1 0 .2.1.2.1-.6.5-1.3.7-1.3.7l.2.5s1-.7 1.4-1c.6.3 1.5.4 1.5.4v-.4l-1.2-.2.1-.1c.4-.3 1.1-1.4 1.1-1.4l.1-.8s-.5-.1-.9-.5c1.5-1 1.5-1.5 1.5-1.5l.3-.5s-.5-.2-.9-.9c1-.2 2.3-.5 2.3-.6 0-.1.2-.2.2-.2s-.6-.9-.8-2.1c1.2.3 2.4.5 2.4.5l.4-.3s-.3-.9-.4-2c1.4.1 2.6.2 2.6.2l.2-.3s-.8-1.5-.8-2.3v-.1c.3 0 .5.1.8.1h2.4l.2-.4c0 .1-1.1-.6-1.4-1.1m-8.4 12.4s-.4.7-1.1 1.6l-.2.2c-.1 0-.3-.1-.4-.2-.9-.5-1.1-1.1-1.1-1.1s.5-.2 2-1.2c.8.6.8.7.8.7m.7-2.5-1.5 1.5c-.1-.1-.2-.2-.3-.4-.7-.9-1.6-1.7-1.5-3 0 0 .5 1 1.7.8.2 0 .5-.1.8-.1.3.8.8 1.2.8 1.2m1.6-2.1s-1.1.4-2.1.5c0-.1-.1-.2-.1-.3-.4-1.3-.4-3.2-.4-3.2s.9.6 2.1.9c.3 1.5.5 2.1.5 2.1m-.3-2.3c-.2-1.2 0-2.3 0-2.3s.6.6 1.9.8c.1 1.1.2 1.6.2 1.6s-.9.1-2.1-.1m4.6-1.8s-.8.3-2.3.1v-.4c-.1-1.3.1-2.4.1-2.4.2.1 1 .4 1.7.6v.1c.2 1.1.5 2 .5 2m-.1-2.5v-2.1s.7.2 1.3.1c.1.4 0 .5.4 1 .4.6.9 1 .9 1s-1.8.2-2.6 0m-6 14.9-.1-.4s-.7.5-.9 1.1h-.2c-.5-.2-1.6-.6-1.6-.6l.2.3s1.2.5 1.5.6h.1c-.2.5-.4 1.1-.4 1.1l.2.3s.1-.8.4-1.4c.4 0 1 .1 1 .1s-.1.3-.2.7c-.1.3-.3 1.2-.3 1.2l.4.2h1.6l-.3-.3s0-.1-.6-.1c-.5 0-.9.1-.9.1s.1-.3.3-1c.2-.7.2-.6.2-.6l-.2-.6s-.5.2-.9.1c.3-.6.7-.8.7-.8m-9-1c1 0 1.9.7 1.9.7v-.5s-.8-1.1-1.7-1.1c-.9 0-2 .9-2 .9v1c-.1 0 .8-1 1.8-1m10.6 15.5c-1 .4-2.2.4-2.2.4s.3-.4.6-1.2c2-.6 2.4-1.9 2.4-1.9l-.1-.5s-.5 1.2-2.1 1.9c.3-1 .6-2.6.6-2.6l-.6-.1s-.8 1-1.6 1.3c.5-1 .6-2.2.6-2.2l-.3-.4s-.5.5-1.4.6h-.4c.5-.7 1.4-2.6 1.4-2.6l-.2-.3s-.7 1.7-1.4 2.5l-.3.3c-.7-.2-1.7-.8-1.7-.8l.1.3s.6.4 1.4.7c-.5.5-1.1 1-1.1 1l.1.8s1.3.3 2.4.4c-.9 1.2-1.6 1.6-1.6 1.6l.3.5s1.1 0 3-.5c-.6 1-1 1.5-1 1.5s1.8.1 3-.5 1.6-1.2 1.6-1.2l-.3-.4c.1.1-.1 1-1.2 1.4m-5.5-3.3s.5-.6 1-1.1c1.2.3 1.6-.1 1.6-.1s.2.7-.5 1.9c-.9-.1-2.1-.7-2.1-.7m1.1 2.5 1.1-1.3c.1-.1.1-.2.2-.3 1.2 0 1.9-1 1.9-1s.1 1-.4 2.2c-1.5.6-2.8.4-2.8.4m-1.5-7.9c1.1.1 2.6.6 2.6.6l-.2-.6s-1.4-.3-2.3-.5c.4-.9 1.3-1.3 1.3-1.3l-.4-.2s-.5.1-1.1 1.2c0 .1-.1.2-.1.3h-.2c-1 0-1.9.6-1.9.6l.2.3s.9-.4 1.8-.4c-.3.9-.6 1.9-.6 1.9l.2.5c-.1.1.4-1.4.7-2.4zm-2.4-4.9-.3-.6s-1.2-.4-2.2 0c-.9.4-1.6 1.5-1.6 1.5l.4.7s.6-1.2 1.5-1.5c.9-.2 2.2-.1 2.2-.1m2.4 1.9-.8-.4s-1.3.4-1.8.9-.9 1.7-.7 2c.1.3.5.6.5.6s.2-1.3.9-1.9c.6-.7 1.9-1.2 1.9-1.2m-3.1-.4c.5-.5 1.5-.7 1.5-.7l-.5-.4s-1.2.1-1.8.7c-.6.6-1.4 1.7-1.4 1.7l.7.7c0-.1 1-1.5 1.5-2m4.1-35.8c.7-.9 1.3-.9 1.5-.8h.6c-.2.3-.5 1.2-.6 1.9-.2.9-.6 1-.9 1.6-.3.6-.9 1.5-.9 2.3 0 .8.2 1.2.4 1.3.2.1.6-.3.6-.5 0-.3-.2 0-.4 0s-.1-.3-.2-.7c-.1-.5.6-1.8.8-2.2.2-.4.7-.9.8-1.6.1-.6.6-2 .6-2s-.3-.1-1-.2c-.5 0-1.2.4-1.5.9-.3.5-1.3.9-1.3.9s.9-.1 1.5-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M1-.75h-2l.5 1.5z",
    transform: "matrix(1.9509 0 0 2.4519 443.244 410.631)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M225.8 218.7s-.3-.2-.4-.3c-.1-.2-.2-.2-.2-.2l-.7.5-.5 1.3.2.2 1.6-1.5zM225.5 222.7l-1.5-2.1-.8 1.8.4.1s.4 0 1 .1c.7.1.9.1.9.1M231.5 258.5s-.1 0 0 0c-.4.3-1.9 1.2-3.8 1.2-.9 0-1.8-.2-2.8-.8-.6-.3-.9-.8-1.2-1.4-.4-.9-.6-2-.8-3.1-.2-1.1-.4-2.2-.9-2.9-.6-1-1.9-1.7-3-2.6-1.1-.9-2.1-2.1-2.3-4.2v-.6c0-1.4.4-2.6.9-3.6.5-1.1.9-1.9.9-2.8v-.4c-.2-.6-.7-1.2-1.2-1.5-.5-.4-.9-.6-.9-.6l-.8-.2-.1.2.8.2v-.1l-.1.1h.1c.2.1.6.3 1 .7.4.4.8.8.9 1.3v.3c0 .7-.4 1.6-.9 2.7-.4 1.1-.9 2.3-.9 3.7v.6c.2 2.2 1.3 3.4 2.4 4.4 1.1.9 2.3 1.6 2.9 2.6.6.9.8 2.5 1 4 .1.7.3 1.5.6 2.1.3.6.7 1.2 1.3 1.5 1 .6 2 .8 2.9.8 2.2 0 4-1.3 4-1.3v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M229.7 254.5c-.1.1-.5.3-1 .3-.4 0-.9-.1-1.4-.6-.6-.6-.8-1.1-.9-1.8-.1-.7-.3-1.6-.7-2.6-.5-1.1-1.7-2.1-2.8-2.9-1.1-.9-2.2-1.8-2.3-2.7v-.5c0-.8.3-1.6.7-2.5.4-.9.7-1.9.7-3.2v-.6c-.2-1.6-1.4-2.8-2.5-3.6-1.2-.8-2.3-1.2-2.3-1.2l-.1.2s.1 0 .2.1c.4.2 1.5.6 2.5 1.4 1 .7 1.9 1.8 2 3.1v.6c0 1.2-.3 2.2-.7 3.1-.4.9-.7 1.8-.7 2.6 0 .2 0 .4.1.6.2 1.1 1.3 2 2.4 2.9 1.1.9 2.3 1.8 2.7 2.8.5 1.1.6 1.9.7 2.6.2.7.4 1.3 1 2 .5.5 1.1.7 1.6.7.7 0 1.2-.3 1.2-.3l-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.1 248.4s1.4.3 1.3 1.5c0 1.1-.7 2.7-.7 2.7l-1.9-1.7 1.1-.9.4-.6-.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M213.1 234.8s-1.4.5-1.7-.1c-.3-.6-.2-1.1-.2-1.2 0-.1-.8-.2-.8-1 .1-.8 1.1-.7 1.3-.7.2 0 .3-1.2 1-1.2.7.1 1 .9 1 .9l-.6 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M213.1 234.8c0-.1-.1-.1-.1-.1-.2 0-.5.1-.9.1-.1 0-.3 0-.4-.1-.1 0-.2-.1-.2-.2-.2-.3-.2-.6-.2-.8v-.4c0-.1 0-.1-.1-.1 0 0-.1-.1-.2-.1s-.2-.1-.3-.2c-.1-.1-.2-.2-.2-.4v-.1c0-.3.2-.4.4-.5.2-.1.5-.1.7-.1h.1c.1 0 .1-.1.2-.1.1-.1.1-.2.1-.3.1-.2.1-.4.2-.5.1-.2.2-.3.4-.3.3 0 .5.2.7.4.1.1.1.2.2.3v.1h.1-.1l-.4 3.4h.1l.7-3.4s-.1-.2-.3-.4c-.2-.2-.5-.5-.9-.5-.2 0-.4.1-.5.2-.2.2-.3.4-.3.6 0 .1-.1.2-.1.3h-.1c-.2 0-.5 0-.7.1-.3.1-.5.3-.6.7v.1c0 .4.2.6.4.7.1.1.2.1.3.1h.1v.3c0 .2 0 .5.2.9l.3.3c.1.1.3.1.4.1.5.2 1 0 1-.1h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M214.6 235.2s-1.2.6-1.5 0c-.4-.6 0-1.3-.1-1.5-.1-.1-.8-.4-.7-1 .1-.7.9-.5 1.1-.6.3-.1.4-1.2 1.2-1 .7.2.9.8.9.8s-.7 2.7-.9 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M214.6 235.2c0-.1-.1-.1-.1-.1-.2.1-.6.2-.9.2-.2 0-.4-.1-.4-.2-.1-.2-.2-.4-.2-.6 0-.3.1-.5.1-.7 0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1l-.3-.3c-.1-.1-.2-.3-.2-.4v-.1c0-.1.1-.2.2-.3.1-.1.3-.1.4-.1.2 0 .3 0 .5-.1.1 0 .2-.1.2-.2.1-.2.2-.3.3-.5.1-.1.3-.2.4-.2h.1c.3.1.5.3.6.4 0 .1.1.1.1.2v.1h.1-.1s-.1.7-.3 1.4c0 .6-.2 1.5-.2 1.8.2-.3.4-1.1.6-1.8.2-.7.3-1.4.3-1.4s0-.2-.2-.3c-.1-.2-.4-.4-.8-.5h-.2c-.2 0-.3.1-.4.2-.2.1-.3.3-.4.5 0 .1-.1.2-.1.2 0 .1-.1.1-.1.1h-.2c-.2 0-.3 0-.5.1s-.3.2-.4.5v.2c0 .3.2.6.4.7.1.1.2.1.3.2.1 0 .1.1.1.1 0 .1-.1.4-.1.7 0 .2 0 .5.2.7.1.2.4.3.6.3.4-.1 1-.4.9-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M216.6 235.4s-.3.7-1.2.6c-.8-.2-.6-1.4-.7-1.6-.1-.2-.7-.4-.6-1.1.1-.8.9-.7 1.1-.8.3-.1.6-1.3 1.1-1.1.5.2 1.1.9 1 1.2 0 0-1.2.4-1.3 1.2-.1.8.6 1.6.6 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M216.6 235.4c-.1 0-.2.1-.3.2-.1.1-.3.3-.6.3h-.2c-.2 0-.3-.1-.4-.2-.1-.2-.2-.4-.2-.7v-.6c-.1-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.6v-.2c0-.2.1-.3.2-.4.1-.1.3-.2.4-.2.2 0 .3 0 .5-.1.1 0 .2-.1.3-.3.1-.2.2-.4.4-.6.1-.1.1-.2.2-.2s.1-.1.2-.1h.1c.2.1.5.3.6.4.2.2.3.4.3.6h.1v-.1s-.3.1-.6.3c-.3.2-.7.5-.8.9v.3c-.3 1 .3 1.7.4 1.6l.1-.1c-.1-.1-.6-.7-.6-1.3v-.2c.1-.3.4-.6.7-.8.1-.1.3-.2.4-.2h.1v-.1c0-.2-.1-.5-.3-.7-.2-.2-.4-.4-.7-.5h-.1c-.2 0-.3.1-.4.2-.2.2-.3.4-.4.6-.1.1-.1.2-.2.3 0 .1-.1.1-.1.1-.1 0-.2 0-.3.1-.2 0-.4.1-.6.2-.2.1-.3.3-.4.6v.2c0 .3.1.6.3.7.2.1.3.2.3.3v.1c0 .2 0 .5.1.8 0 .2.1.3.2.5.1.1.3.2.5.3h.3c.4 0 .6-.2.8-.3.3-.6.4-.7.3-.8h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a47031",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235 248.2s-1-1.1-1.8-2.1c-.7-1-1.9-2.2-1.9-2.2l-1.8-.9-1.1-1.9-.1-2.2.5-1.3.7-1s-3.7 1.3-1.8 8.4c.8 3 2.8 3.5 2.8 3.5l3.4-.2 1.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#7d6d31",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.3 224.5c.3 0 .5.1.6.3.1.2.1.3.1.5V225.6h.1-.1c-1.2 2.7-3.8 4-6.1 5.7-1.2.8-2.2 1.8-3.1 3.1-.8 1.3-1.3 3-1.3 5.2v.3c.1 4.1 1.6 6.3 3.3 7.4 1.7 1.1 3.5 1.3 4.2 1.3h.3s.5-.1 1.2-.1c.7-.1 1.6-.1 2.4-.1.5 0 1 0 1.4.1.4.1.7.2.8.3.1.1.2.3.2.4 0 .3-.2.7-.5.9-.3.3-.6.5-.7.6l.1.2c.2-.1.5-.3.8-.6.3-.3.6-.7.6-1.1 0-.2-.1-.4-.2-.6-.2-.2-.5-.3-.9-.4s-.9-.1-1.4-.1c-1.7 0-3.6.2-3.6.2v.1-.1H231.2c-.7 0-2.4-.1-4.1-1.2-1.6-1.1-3.1-3.2-3.2-7.2v-.3c0-2.2.5-3.8 1.3-5 1.2-1.9 3-3 4.7-4.2 1.8-1.2 3.5-2.4 4.5-4.5v-.4c0-.2 0-.5-.2-.7-.1-.2-.4-.4-.8-.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M238.3 249.3s-.9 1.6-1.1 1.6c0 0 .8.3 1 .6l-.2.4s-1-.7-1.6-.7l-.1-.6s.5-.2.9-.5c.3-.3.7-1.2.7-1.4l.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca48",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m241.7 250.4-2.2.6-1.1-.7s.1-.9-.4-1.3-.8-.5-1.3-.7c-.4-.2-2-.2-2-.2l-3.9-4.3 1.5.2 2.3-.3 2.2-.2 1.1.2 1.2.4.6.5.7.6.7 1.1.4 1.2.2 1.3v1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a47031",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.7 250.2s-.8.2-1.8.2-1.6-.2-1.6-.2.1.1-.2.7c-.2.6-.4 1.1-.4 1.1v2.6l2.1.4 1.1-.4.6-2.8.2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca48",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.25-.6.1 1 .4.2v-.9z",
    transform: "matrix(1.9509 0 0 2.4519 471.045 484.556)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca48",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m239.2 225.2-.2-1.7-.7-1.2-.9-1.2-.9-1-.5-.5-.2-.3-2.3.1-1.2 1.4s3.1 2.2 4.3 4.6c1 .3 1.8.9 2.2 1.4l.1-.2.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a47031",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237 227.1c0 1.8-.3 2.6-.6 3l1.4-1.6 1-1.8c-.4-.4-1.2-1.1-2.2-1.4.2.7.4 1.3.4 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#7d6d31",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.2 253.5s-.6-.8-1.1-1.3c-.5-.5-1.1-.7-1.1-.7l-.1.2h.1c.2.1.6.3.9.6.2.2.5.5.7.8.2.3.4.5.4.5l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#6c5c2b",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.6 251.6s-.2.8-1 1.5-1.8 1.2-1.8 1.2l2.2.8 1.5-1.4-.9-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#434520",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.1-1.2.4.7v.4L.4.1.2.4l-.4.4-.3.4z",
    transform: "matrix(1.9509 0 0 2.4519 471.142 493.383)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.8-1.7.2 3.6L.8 1-.3-1.9z",
    transform: "matrix(1.9509 0 0 2.4519 556.787 599.06)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-.8-1.7h-.1l.2 3.8 1.6-1-1.1-3.2-.7.4h.1l.1.1.4-.2L.6 1l-1.1.7-.2-3.4h-.1l.1.1z",
    transform: "matrix(1.9509 0 0 2.4519 556.787 599.06)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M285.7 293.8c0 .6-.5 1.1-1.2 1.1-.6 0-1.2-.5-1.2-1.1 0-.6.5-1.1 1.2-1.1.6-.1 1.2.4 1.2 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M285.7 293.8c-.1.6-.6 1-1.2 1s-1.1-.5-1.1-1 .5-1 1.1-1c.6-.1 1.1.4 1.2 1 .1-.7-.5-1.2-1.2-1.2s-1.3.5-1.3 1.2.6 1.2 1.3 1.2c.7 0 1.2-.6 1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M285.3 295s-.2.1-.3.4c-.1.2-.2.7-.2.7v-1.2l.4-.2.1.3zM285.4 294.3s-.3.5-.9.4c-.6 0-.9-.3-1-.7-.1-.3-.1-.6.1-.9.2-.4-.3.4-.3.4v.7l.5.6.4.1h.4l.5-.2.3-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M1.9 1-.7-1.5l-1.2 1 3.6 2z",
    transform: "matrix(1.9509 0 0 2.4519 559.908 606.17)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m1.95.95.1-.1-2.7-2.5-1.4 1.1 3.8 2.2.3-.7v-.1l-.1.1h-.1l-.2.4-3.3-2 1-.8 2.6 2.5v-.1h-.1z",
    transform: "matrix(1.9509 0 0 2.4519 559.81 606.293)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M288.7 301.7c-.4-.5-.2-1.2.3-1.6.5-.4 1.2-.3 1.6.2.4.5.3 1.2-.3 1.6-.5.4-1.2.3-1.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M288.7 301.7c0-.2-.1-.4-.1-.6 0-.3.1-.7.4-.9.2-.2.4-.2.7-.2.3 0 .6.1.8.4.1.2.2.4.2.6 0 .3-.2.7-.4.9-.2.2-.4.2-.7.2-.4 0-.7-.2-.9-.4.2.4.5.5.9.5.3 0 .6-.1.8-.3.3-.3.5-.6.5-1 0-.2-.1-.5-.2-.7-.2-.3-.6-.5-.9-.5-.3 0-.6.1-.8.3-.3.3-.5.6-.5 1-.1.3 0 .6.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M288.8 300.2s-.3.2-.6.1c-1.5-.5-2.8-1.4-2.8-1.4l3 1.9.4-.6zM290.7 301s0 .5-.6.8c-.6.3-1 .1-1.2-.1-.2-.3-.3-.5-.3-.9s-.1.5-.1.5l.3.6.7.3.4-.1.4-.2.4-.4.2-.4-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-1.5-1.2 2.6 2.7.4-1.3L-1-1.5z",
    transform: "matrix(1.9509 0 0 2.4519 605.95 519.618)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-1.45-1.25-.1.1 2.8 2.8.4-1.6-2.6-1.7-.7.4.1.1.1-.1v.1l.5-.3 2.3 1.6-.2 1.1-2.6-2.5v.1z",
    transform: "matrix(1.9509 0 0 2.4519 605.852 519.741)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M309.8 262.1c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M309.8 262.1c-.1.6-.6 1-1.1 1-.6 0-1-.5-1-1 0-.6.5-1 1-1 .6 0 1 .5 1.1 1 .1-.7-.4-1.2-1.1-1.2-.7 0-1.2.6-1.2 1.2 0 .7.5 1.2 1.2 1.2.7.1 1.2-.5 1.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M310.1 263s-.1.1-.1.3v.6l-.7-.7.3-.4.5.2zM309.8 262c0 .5-.7 1.3-1.3 1-.6-.2-1-.8-.7-1.4.3-.6-.2.2-.2.2l.1.9.5.5h.7l.5-.3.3-.6.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m2.05-.35-4.1 1.2.4-1.4 3.5-.3z",
    transform: "matrix(1.9509 0 0 2.4519 612.68 521.457)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M2-.4v-.1L-1.9.7l.2-1.2 3.4-.3.2.5.1-.1v-.1.1h.1L1.9-1l-3.7.3-.4 1.7L2.2-.3l-.1-.1z",
    transform: "matrix(1.9509 0 0 2.4519 612.778 521.58)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M317.9 263.9c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M317.9 263.9c-.1.6-.5 1-1.1 1-.6 0-1-.5-1-1 0-.6.4-1 1-1 .5 0 1 .4 1.1 1 .1-.7-.4-1.2-1.1-1.2-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2c.6 0 1.2-.6 1.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M317.8 263.4s-.1-.3 0 0c0 .4-.5 1.3-1.1 1.3-.6-.1-.9-.6-.8-1.1.1-.5-.1.2-.1.2l.1.7.3.3.5.3.5-.1.5-.3.2-.5v-.3l-.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M315 264s0 .3-.3.5c-.4.2-1.1.6-1.1.6l2.3-.7-.2-.6-.7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.95 2.05-2.6-3.9.4-.2 2.9 3.3z",
    transform: "matrix(1.9509 0 0 2.4519 588.099 565.346)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.95 2.1V2l-2.4-3.8.2-.1 2.7 3.2-.6.7.1.1V2v.1l.8-.8-2.9-3.5-.6.3 2.6 4.1.1-.1z",
    transform: "matrix(1.9509 0 0 2.4519 588.099 565.224)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M299.6 278.7c.6 0 1.2.5 1.2 1.2 0 .6-.5 1.2-1.2 1.2-.6 0-1.2-.5-1.2-1.2s.6-1.2 1.2-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M300.8 279.9c-.1.6-.6 1.1-1.2 1.1s-1.1-.5-1.1-1.1c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.2 1.1.1-.7-.5-1.3-1.2-1.3s-1.3.6-1.3 1.3c0 .7.6 1.3 1.3 1.3.7-.1 1.2-.6 1.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M301.4 281.9s-.1.1-.1.4c0 .3.1.6.1.6l-1.3-2 .4-.2.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M300.7 280.1c-.2.5-1.2.9-1.6.6-.4-.3-.8-1.2-.3-1.6l-.3.3-.1.5.2.6.4.5.4.1.6-.1.5-.4c.1-.1.4-1.1.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-1.65.2 3.2.5.1-.4-2.7-1z",
    transform: "matrix(1.9509 0 0 2.4519 593.366 570.128)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-1.6.2v.1l3.3.6.1-.7L-1-.9-1.8.2l.2.1V.2h.1l.6-.8 2.5 1-.1.2-3.1-.5v.1h.1z",
    transform: "matrix(1.9509 0 0 2.4519 593.269 570.128)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M307.8 285.4c0 .6-.5 1.2-1.1 1.2-.6 0-1.1-.5-1.1-1.2 0-.6.5-1.2 1.1-1.2.6 0 1.1.5 1.1 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M307.8 285.4c-.1.6-.6 1.1-1.1 1.1-.6 0-1-.5-1-1.1s.5-1.1 1-1.1 1 .5 1.1 1.1c.1-.7-.5-1.3-1.1-1.3-.7 0-1.2.6-1.2 1.3 0 .7.6 1.3 1.2 1.3.6-.1 1.2-.6 1.1-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M305.1 284.7s0 .2-.4.2h-1.3l2.1.4.1-.4-.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M307.7 285.1c.2.7-.4 1.4-1.2 1.1-.8-.2-1-1-.8-1.5l-.2.5.1.7.5.4.5.1.5-.1.5-.5.1-.6v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#999f69",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M319.9 255.3c-.2 3.1-3.3 4.6-4.8 5.8-1.6 1.1-2.4 2.6-2.4 2.6l-.5 1.8-.3 1.1v.4c.1.3.2.9.3 1.7 0 1.4-.1 3.4-.1 3.4l2.1-1.5 1.6-.6.5-.1s-1.7 1.7-2.4 3.5-1.9 5.8-4.3 7c-2.3 1.3-3.8.7-4.6 1.4-.8.7-.8.9-.8.9l-1 1.4-.8 1-.7.5-.5.4c0 .4-.1.9-.2 1.3-.3.9-.6 1.9-.6 1.9s.5-.3 1-.4c.6-.1 1.1-.1 1.1-.1s-.4.5-.6 1.1c-.2.5.1 3.7-2.9 5.6-3 1.9-10.7 1.6-10.7 1.6l-1.5.6-1.4 1-1.3 1.4-.1.4s-.9 1.2-1.6 1.6c-.7.5-2.2 1.5-2.2 1.5s1.3 0 1.8.1c.4.2 2.8 1.2 2.8 1.2s-1.7 0-2.9.4c-1.2.5-6.5 3.5-9.1 3.4-2.6-.1-6.3-3.9-6.3-3.9l-1.7-1.2-2.8-.5-3.4-.2v-.5l.1-.6s1.2-.1 3.1.1c1.6.2 2.1.7 3.5.9 1.3.2 2.3 0 2.8-.3.5-.2 4.7-3.8 4.7-3.8l4.7-1.6 1.8.3.8.2.7.2s-.3.4-.8.9-1.2.8-1.2.8l.6.5 3-.5 1 .3s.1 0 .3.1c0-.2.2-.6.4-1 .4-.5 2-1.8 2.7-2.3.7-.5.9-.5 1.1-.8.2-.3 1.2-2.7 1.2-2.7l.1-1.3 3.3-3.1 2.2-2.4.9-2.7-.1-.5s.8.8.6 2.5c-.1 1.7-.5 2.2-.5 2.2s2.2-1.5 3.4-2.1c1-.4 1.7-.4 1.9-.4.3-.2 1.2-.7 1.7-1.5.6-.9.8-1.2.8-1.6 0-.4.1-2.2.1-2.2l-.2-5.7 1.9-4.3 2.8-2.5.5-.3s-.2.6-.3 1v1.1s1.4-1.9 2.1-2.3c.2-.1.3-.2.4-.2.2-.3.4-.8.6-1.6.2-1.1.3-2.5.3-2.5v-2.3l-.5-1.8-1.3-3.5v-4.6l-1-1.3s.9-.1 2.1 1.6c1.1 1.6 1.5 4 1.5 4l2.7-8.1s.7.9 1.2 2.6c.5 1.6.7 2.7.7 2.7l1-2.3s0 .2.1.8c.4.9 2 1.8 1.8 4.9m-53.9 52s-.5-1.3-3.1-2.5c-2.5-1.3-4.4-1.5-4.4-1.5v.9l4 1.7 2 1.6 1.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#707937",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M284.3 299.7c.3-.3 2.4-2.2 3.5-2.8 1.1-.6 2.6-.7 2.6-.7 1.5-.3 1.8 0 5.3-2 3.5-1.9 4.3-4.2 5-4.7.7-.5 1.9-.7 1.9-.7s-1.5 1.7-2.7 3.1c-1.3 1.4-2.7 2.3-4.6 3.6-2 1.3-6.1 1.4-6.1 1.4-1.7.4-2.3.8-3.3 1.7-1 .8-1.6 1.8-1.6 1.8s-.2-.4 0-.7m9.7-10.2c-3.2 3-4.3 5.7-4.3 5.7s2.9-2.5 4.4-3.9c1.5-1.4 3.6-2.1 4.5-3 .9-.9 1-1.6 1.6-2.2.6-.6 1-.8 1-.8s-1.5-1-7.2 4.2m-6.9 6.9s1.4-.6 1.9-1.9c.4-.9.2-1.2.8-2.2 0 0 3.4-3.3 4.6-4.7 2.1-2.5 1.2-4.6 1.2-4.6s.2 1.1-.6 2.2c-.9 1.1-5.2 4.1-5.8 5.8-.5 1.7-.2 1.8-.5 2.7-.6 2.1-1.6 2.7-1.6 2.7m-2.2 8.4s-1.7-1.1-3.6-1c-3.9.2-7.2 2.6-9.7 2.7-2.6.1-3.6-1.2-5.5-2.6-2.1-1.4-7.3-1.2-7.3-1.2v.2s3.6 0 5.1.5c2.9.8 4.5 3.8 7.8 3.7 4.3-.3 7.9-2.9 9.6-2.9 2.9 0 3.6.6 3.6.6m-19.3-2s3 .5 5.4-1.2c2.3-1.7 5.1-4 6.6-4.1 1.5-.1 3.1.3 3.1.3s-1.9-.9-3.5-.8c-1.6 0-3.1.2-4.6 1.1-1.5.9-2.2 2.5-3.7 3.5-1.5.9-3.3 1.2-3.3 1.2m-.5 4.1c-.4 0-.9.3-1 .2s-1.1-1-2.4-1.7c-1.3-.7-3.2-1.1-3.2-1.1s-.2.1.2.2 2 .7 3 1.2 2 1.6 2.1 1.7c.1.2.5.7 1.2.6.8 0 1.1-.5 1-.7 0-.3-.5-.4-.9-.4m2.1-2.9s1.2.7 3.2.6c4.2-.1 6.9-3 9.6-4 2.8-1.1 4.2-.1 4.2-.1s.1-.1 0-.2c-.4-.3-1.7-1-3.1-1-4.6.1-8.9 3-10.8 3.8-1.9.7-3.1.9-3.1.9m44.8-31.9c-1.4 1.5-3.5 6.1-4.5 7.4-.9 1.3-2.1 1.7-2.6 2.2-.4.5-2.1 2.7-2.5 3.3-.4.6-.5.4-.8.6-.3.2-.4.3 0 .1.5-.1.6-.4 1.3-1.2.7-.8.7-1.2 1.8-2.2 1.1-1 3.1-2.1 4.1-3.4 1-1.2 3-6 4.1-7.2 1.2-1.3 3.2-2 3.2-2s-1.5-.3-4.1 2.4m-7.2 8.9s-.1-.8 1-2.1c1-1.3 1.4-1.1 2.2-2.9.8-1.8 1.2-3.6 1.9-5.5s1.8-3.8 1.8-3.8-1.1.1-2.2 1.6-2.9 4.2-3.8 6.9c-.9 2.7-.9 5.8-.9 5.8m-1.4 1.7s.4-.2.4-2.5-.1-5.6.5-7.3c.7-1.6 4.3-5.6 4.3-5.6s-1.5.4-3.6 2c-2.1 1.7-3 3.7-2.9 5.3.1 1.6 1 3.4 1.1 4.9.2 1.7.2 3.2.2 3.2m8.5-16.1s.9-3.2 1.3-4c.4-.8.4-1.2 2.2-3.2 1-1.2 2-1.9 2.5-3.5.4-1.6.4-6.1.4-6.1s-.5.4-.9 1.2c-.4.8-.1 3.7-.8 5.1-.7 1.4-2.2 4.5-3 5.2 0 0-.2-2.3.1-4.6.3-2.3 1.1-3 1.4-4.5.3-1.5.1-5.4.1-5.4s-1.2 1.3-1.8 2.7c-.6 1.5-1 4.1-1 6 0 2 .4 3.6.5 4.7.1 1.1.2 1.7-.3 2.9-.4 1.2-.2.4-.5 1.6-.3 1.2-.6 2.1-.6 2.1l.4-.2zm-2.8-17.3s1.1 1.3.9 2.9c-.2 1.5-.8 3.6-.2 5.2.6 1.6 1.5 1.8 1.7 2.7.3.9.3 2.7.3 2.7s.5-3.5.2-4.4c-.3-.9-.5-.5-1-1.5s0-3.7-.4-5.3c-.4-1.6-1.5-2.3-1.5-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M227.7 293.6c0 .6-.4.9-.8.9s-.7-.4-.7-1 .3-1 .7-1c.4.1.8.6.8 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M227.7 293.6c-.1.2-.2.5-.3.6-.1.1-.3.2-.5.2s-.3-.1-.5-.3c-.1-.2-.2-.4-.2-.6 0-.3.1-.5.2-.6.1-.2.3-.3.5-.3s.4.1.5.3c.1.2.2.5.3.7.1-.3 0-.6-.2-.8-.2-.2-.4-.3-.6-.3-.2 0-.5.1-.6.3-.1.2-.2.5-.2.8 0 .3.1.6.2.8.1.2.4.3.6.3.4 0 .9-.5.8-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.05-2 .7 4-.9-.4-.4-3.4z",
    transform: "matrix(1.9509 0 0 2.4519 444.317 601.512)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-.1-2.05h-.1l.7 3.9-.7-.3-.4-3.4.5-.1v-.1h-.1.1v-.1l-.7.2.4 3.6 1.2.5-.8-4.3h-.1z",
    transform: "matrix(1.9509 0 0 2.4519 444.415 601.634)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.6 294.1c.5.6-.3 1.5-1.2 1.8-.8.2-1.9-.2-1.9-.9 0-.9 1.2-.4 1.6-.5.5-.3 1-1.1 1.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.6 294.1v.4c0 .2-.1.5-.4.7-.2.2-.5.4-.9.5-.2 0-.3.1-.5.1-.3 0-.7-.1-.9-.3-.2-.2-.4-.4-.4-.6 0-.2.1-.3.2-.4.1-.1.3-.1.4-.1H227l.6-.3c.2-.1.3-.2.5-.2s.3 0 .5.2c-.1-.3-.2-.3-.4-.3s-.4.1-.6.3c-.2.1-.4.3-.5.3H226.3c-.2 0-.4 0-.5.1-.2.1-.3.3-.3.5 0 .3.2.6.5.8.3.2.6.3 1 .3.2 0 .4 0 .5-.1.3-.1.7-.3.9-.6.3-.3.4-.6.4-.9 0-.2 0-.4-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.5 294.1c.2.2-.1 1.2-1 1.5-.9.4-1.4 0-1.6-.3-.2-.3-.2-.6-.2-.6l-.1.2.1.5.5.4.8.2.6-.1.6-.3.3-.3.3-.4v-.5l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M227.7 296.1s-.2 0-.3.3c-.1.2-.2.6-.2.6l-.1-1.1.5-.3.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M222.8 300.2c0 .5-.6.9-1.3.9s-1.3-.4-1.3-.9.6-.9 1.3-.9 1.3.4 1.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M222.8 300.2c-.1.2-.2.4-.4.6-.2.1-.5.3-.8.3-.3 0-.6-.1-.8-.3-.2-.2-.3-.3-.3-.6 0-.2.1-.4.3-.6.2-.2.5-.3.8-.3.3 0 .6.1.8.3.2.2.4.4.4.6.1-.3-.1-.5-.3-.7-.2-.2-.6-.3-.9-.3-.4 0-.7.1-.9.3-.2.2-.4.4-.4.7s.2.5.4.7c.3.2.6.3.9.3.4 0 .7-.1.9-.3.3-.2.4-.4.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-1.95.5 3.9-.2-.7-.8-3.1.4z",
    transform: "matrix(1.9509 0 0 2.4519 440.22 606.66)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-2 .5v.1L2.1.4l-.9-1-3.3.4v.8h.1V.5h.1V0l3.1-.4.4.6-3.6.2v.1h.1z",
    transform: "matrix(1.9509 0 0 2.4519 440.318 606.66)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M224 299.5c.3 1 .3 2.3-.7 2.2-1.1-.1-.9-1.1-1-1.5-.2-.7-.8-1.3-.1-2 .6-.6 1.5.4 1.8 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M224 299.5c0 .4.1.8.1 1.1 0 .3 0 .5-.2.7-.1.2-.3.3-.5.3h-.1c-.3 0-.4-.1-.6-.2-.2-.2-.2-.4-.3-.6 0-.2 0-.4-.1-.6-.1-.5-.4-.9-.4-1.3 0-.2.1-.4.3-.6.1-.1.3-.2.4-.2.2 0 .5.2.7.4.3.3.5.7.7 1 0-.4-.3-.8-.5-1.1-.3-.3-.6-.5-.9-.5-.2 0-.4.1-.5.3-.2.2-.3.5-.3.7 0 .5.3.9.4 1.3 0 .2 0 .5.1.8 0 .2.1.3.3.5l.6.3h.2c.3 0 .6-.1.7-.4.1-.2.2-.5.2-.8 0-.3-.1-.7-.3-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M224.7 299.3s-.1.2.2.3c.3.1.8.3.8.3h-1.5l-.2-.6h.7zM224.2 300.2v.2c0 .1 0 .2-.1.4-.2.4-.2.8-.8.7-.5-.1-.8-.5-.8-.9 0-.3-.2-.5-.2-.5v.5l.3.8.5.3h.5l.4-.1.2-.5.1-.4-.1-.5zM220.4 300.1s.2.7.9.7c.8 0 .9-.2.9-.2l.1.3-.3.1-.7.1-.6-.1-.3-.2-.2-.4.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M211.5 277.4c.4 0 .7.5.7 1.1s-.3 1.2-.7 1.2c-.4 0-.8-.5-.8-1.2s.4-1.1.8-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M212.3 278.5c-.1.3-.2.6-.3.8-.1.2-.3.3-.4.3-.2 0-.3-.1-.5-.3-.1-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.2.3-.3.5-.3s.3.1.4.3c.1.3.2.5.3.8.1-.3 0-.6-.1-.9-.1-.2-.4-.4-.6-.4-.3 0-.5.2-.6.4-.1.2-.2.5-.2.9 0 .3.1.6.2.9.1.2.4.4.6.4.2 0 .5-.1.6-.4.1-.2.2-.5.1-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.4-1.75.1 3.7-1-.9.1-3z",
    transform: "matrix(1.9509 0 0 2.4519 411.835 565.837)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.4-1.8H.3l.1 3.5-.8-.7.1-2.8.7.1v-.1H.3h.1v-.1l-.9-.2-.1 3.2 1.2 1-.1-4H.4z",
    transform: "matrix(1.9509 0 0 2.4519 411.835 565.96)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M213 279.9c.2.9-1.1 1.3-1.9 1.2-.9-.2-1.5-.6-1.4-1.4.1-.8 1.2-.6 1.6-.4.3.2 1.4-.6 1.7.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M213 279.9c-.1.1-.1.1-.1.2 0 .3-.2.5-.5.7-.3.2-.7.3-1 .3h-.3c-.4-.1-.7-.2-.9-.4-.2-.2-.4-.4-.4-.7v-.2c0-.2.1-.3.2-.4.1-.1.3-.1.5-.1.3 0 .6.1.7.2h.2c.2 0 .6-.1.8-.1.2 0 .3 0 .4.1.1 0 .2.2.4.4 0-.3-.1-.5-.2-.6-.2-.1-.3-.2-.5-.2-.3 0-.6.1-.8.1h-.1c-.2-.1-.5-.2-.8-.2-.2 0-.4 0-.6.1-.2.1-.3.3-.3.5v.2c0 .4.2.7.4.9.3.2.6.3 1 .4h.4c.4 0 .8-.1 1.1-.3.3-.2.6-.5.6-.8-.1 0-.1 0-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M212.9 279.8v.3c-.1.2-.5.8-1.4.9-.9 0-1.2-.3-1.5-.6-.2-.3-.3-.7-.3-.7v.4l.3.5.9.4h.8l.8-.3.4-.4.1-.4-.1-.1zM211.5 281.6s-.3 0-.5.2c-.2.1-.3.3-.3.3v-1h.8v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M206.2 284.3c0 .3-.6.6-1.3.6-.7 0-1.3-.3-1.3-.6s.6-.6 1.3-.6c.8.1 1.3.3 1.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m206.2 284.3-.2.2c-.2.2-.6.3-1.1.3-.3 0-.7-.1-.9-.2-.1 0-.2-.1-.3-.2 0-.1-.1-.1-.1-.2 0 0 0-.1.1-.2.2-.2.6-.3 1.1-.3.3 0 .7.1.9.2.1 0 .2.1.3.2.1.1.1.2.2.2.1-.1 0-.2 0-.3-.2-.3-.7-.4-1.3-.4-.4 0-.7.1-.9.2-.1.1-.2.1-.3.2-.1.1-.1.2-.1.3 0 .1.1.2.1.3.2.2.7.4 1.3.4.4 0 .7-.1 1-.2.1-.1.2-.1.3-.2 0 0 0-.1-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-2.05-.25 2.9-.2 1.3.9-4.3-.1z",
    transform: "matrix(1.9509 0 0 2.4519 408.42 570.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-2.15-.25v.1l2.9-.2.9.7-3.8-.1.1-.5h-.1v.1-.1h-.1l-.1.7 4.7.1-1.6-1.1-3 .2v.1z",
    transform: "matrix(1.9509 0 0 2.4519 408.616 570.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M206.2 282.8c.8 0 1.3.9 1.2 1.8-.1.9-.8 1.7-1.6 1.6-.7-.1-.7-.7-.7-.9 0-.2.4-.5.5-.8 0-.3-.2-.9-.1-1.3.2-.4.4-.4.7-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M206.2 282.8c.3.1.6.3.8.5.2.3.3.6.3 1v.2c-.1.8-.7 1.5-1.3 1.5h-.1c-.3 0-.4-.2-.5-.3-.1-.1-.1-.3-.1-.4v-.1s0-.1.1-.1c.1-.1.1-.2.2-.3.1-.1.2-.2.2-.4v-.1c0-.3-.1-.7-.1-1v-.1c0-.1.1-.2.2-.3 0 0 .1 0 .3-.1-.2-.1-.4-.1-.5 0-.1.1-.2.2-.2.3v.2c0 .3.1.8.1 1v.1c0 .1-.1.3-.2.4l-.2.2c0 .1-.1.1-.1.2v.2c0 .1 0 .3.1.5s.3.3.6.4h.1c.8 0 1.4-.8 1.5-1.6v-.3c0-.4-.1-.8-.4-1.1-.1-.4-.4-.6-.8-.5zM207.8 284.4s-.1.1.4.3c.4.2 2.5.4 2.5.4l-3.3-.1.1-.6h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M207.4 284.4s0 .1-.2.5c-.2.3-.6 1.2-1.3 1.1-.7-.1-.6-.6-.6-.7v-.3l-.1.5.2.3.3.2.6.1.4-.2.4-.4.2-.4.2-.5-.1-.2zM205.6 284.5s0 .2-.6.2-1.3-.2-1.3-.2l.3.3.5.1h1l.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M203.8 260.1c-.3.5-.9.9-1.3.7-.3-.2-.2-.9.1-1.4.3-.5.8-.8 1.2-.6.4.2.4.8 0 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M203.8 260.1c-.2.1-.4.3-.6.5-.2.1-.4.2-.5.2h-.1c-.1 0-.1-.2-.1-.4 0-.3.1-.6.3-.9.2-.4.6-.6.8-.6.1 0 .1 0 .2.1s.2.2.2.4c0 .1-.1.4-.2.7.3-.2.3-.5.3-.8 0-.3-.1-.5-.3-.6-.1 0-.2-.1-.3-.1-.3 0-.7.3-1 .7-.2.3-.3.7-.3 1 0 .2.1.4.2.6.1 0 .2.1.2.1.2 0 .4-.1.6-.2.4-.2.6-.4.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.55 2.05 1.6-3.9-.2-.2-1.9 2.7z",
    transform: "matrix(1.9509 0 0 2.4519 392.424 519.496)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-.55 1.95h.1l1.6-3.9-.3-.3-2 2.8.6 1.7.1-.3h-.1l.1-.1-.5-1.3 1.8-2.5h.1l-1.6 3.8.1.1.1-.1z",
    transform: "matrix(1.9509 0 0 2.4519 392.424 519.741)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M201.9 262.1c-.8-.6-1-1.2-.7-1.8.3-.6.9-.2.9-.2s.4.4.7.6c.3.2.8 0 1.1.4.3.5.1 1-.1 1.1-.4.2-1.2.4-1.9-.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M201.9 262.1c-.5-.5-.7-.9-.7-1.3 0-.2 0-.3.1-.5s.2-.3.4-.3c.1 0 .2 0 .2.1h.1v-.1l-.1.1s.4.4.7.6c.2.1.4.1.6.1.2 0 .4.1.5.3.1.2.2.3.2.5s-.1.4-.3.5c-.1.1-.4.1-.8.1-.2.1-.5.1-.9-.1.3.3.6.4 1 .4s.7-.1.9-.2c.2-.1.4-.3.4-.7 0-.2-.1-.4-.2-.6-.2-.3-.4-.3-.6-.4-.2 0-.4 0-.5-.1-.1-.1-.3-.2-.4-.3l-.2-.2s-.2-.1-.5-.1c-.2 0-.4.1-.5.4-.1.2-.1.4-.1.5-.2.5.1 1 .7 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M203.9 261.4s.1.3-.2.6c-.3.2-1 .4-1.4.1-.4-.3-1.2-1-1.2-1l.4.7.6.5.8.2.8-.1.3-.3.1-.3-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M201.6 262.5v.4c0 .4-.2.9-.2.9l.7-1.6-.3-.2-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M195.1 261.6c.6.3.9.9.7 1.3-.2.4-.8.4-1.4.1-.6-.3-.9-.9-.7-1.3.2-.4.9-.4 1.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M195.1 261.6c.4.3.7.7.6 1v.2c-.1.2-.3.2-.5.2s-.5-.1-.8-.2c-.4-.3-.7-.6-.7-.9v-.2c.1-.2.3-.2.5-.2.4 0 .6.1.9.1-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.7.3-.1.1-.1.2-.1.3 0 .4.3.8.8 1.1.3.2.6.2.8.2.3 0 .6-.1.7-.3 0-.1.1-.2.1-.3.1-.4-.2-.8-.8-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-1.35-1.6 3 1.8v1.4l-3.3-2.8z",
    transform: "matrix(1.9509 0 0 2.4519 386.57 521.825)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-1.3-1.7v.1L1.6.2v1.1l-3.1-2.6.3-.3-.1-.1v.1-.1l-.5.5 3.6 3V.1l-3.1-1.9v.1z",
    transform: "matrix(1.9509 0 0 2.4519 386.473 522.07)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M196.8 263.6c-.7.7-1.3.9-1.8.5-.6-.3-.1-.9-.1-.9s.5-.3.7-.6c.2-.3 0-.8.6-1.1.5-.3 1 0 1.1.3-.1.3.1 1.2-.5 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M196.8 263.6c-.5.4-.9.6-1.2.6-.2 0-.4-.1-.6-.2-.2-.1-.2-.2-.2-.4 0-.1 0-.2.1-.3 0 0 0-.1.1-.1l-.1-.1v.1s.5-.3.7-.7c.1-.2.1-.4.2-.6 0-.2.1-.3.4-.5.1-.1.3-.1.4-.1.3 0 .5.2.5.3 0 .1.1.3.1.6-.1.6-.2 1-.4 1.4.4-.3.5-.8.5-1.2 0-.3 0-.5-.1-.6-.1-.3-.3-.5-.7-.5-.2 0-.3 0-.5.1-.3.2-.4.4-.4.6 0 .2-.1.4-.1.5-.1.1-.2.3-.4.4-.1.1-.3.2-.3.2s-.2.2-.2.5c0 .2.1.4.3.5.2.1.4.2.6.2.5.1.9-.1 1.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M197.3 263.7s-.1-.1.1.3c.2.5 1.9 2.1 1.9 2.1l-2.7-2.3.3-.4.4.3zM196.4 263.9s-.3.2-.7.2c-.3 0-.8 0-.9-.4-.1-.4.1-.5.1-.5l-.2.5.1.3.4.2.6.1.5-.3.1-.1zM195.3 262.8s0 .1-.5 0-1.1-.6-1.1-.6l.4.6.9.3.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#999f69",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.4 307.1s.3-.9 2.5-2 5.5-2.5 5.8-2.3c.3.2-.2 1.4-.2 1.4l-2.1.6-1.7 1-2 1.3h-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#999f69",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M250.9 301.3c-2.8.1-4.3.8-4.8.9-.2 0-.6.3-.9.2-.6-.3-1.2-1.2-1.2-1.2l-.6-.5-.1 2-4.1-3.5-.4 2.3-.5 1.1-4-3.8.2 3-1.1.1c-.1 0-2.9-2-2.9-2l-.9.3.9 1.7-3.6.3s-.3.2-.8.6c-.5.5-.8.9-.8.9s-.1.2 0 .3c.1.1 1.1.1 1.4 0 .3-.1.5-.6.6-.4.1.2.2 1 .7.9.5-.1 2.2-1.4 3.4-.8 1.3.6-1.7 1.5-1.4 2.5s2.5.5 3.1.2c.6-.3 2.2-2.4 2.9-1.6 1 1.1-2 2-1.5 3.1s2.2.8 3 .4c.8-.5 2.7-3.3 3.1-2.7.7 1.1-1.6 2.1-1 2.9.6.8 1.9 0 2.7-.6.8-.6 1.2-2 2.4-2.7 1.2-.6 1.1-.4 1.4-.4.3 0 1.2-.9 1.2-.9l2.7-1.2 1.3.1.7.3 1.4.2.2-1.2c0-.1-1.6-.8-2.7-.8m-22 0 .6-1-.3-.5s-1-.6-1.9-1.4c-.9-.9-1.2-1.1-1.6-1.3-.4-.2-1.8-1.1-1.8-1.1l-.6-2.3-.4-.7-1 .4-1.4-4.9-.3-.9h-.6l-1.1 3-1.3-1.9-.3-4-.8.9-1 1-1.8-3.7s-.1-.1-.2.2c-.1.3-.2 1.4-.1 2.1-.5-.3-1.3-.9-2.4-1.8-1.8-1.6-2.3-2.4-2.3-2.4l-.9-1.9.8-1.7.4-2-1.8.7-.3-4.6-.3-1.4-2.1 3s-.8-1.2-.8-1.3v-2.9l-.6-.2-.9 1.6s-.8-1.7-1.2-2c.1-.6.2-2.3-.2-3.6-.5-1.6-1.1-2.5-.9-3.8.2-1.3.7-1.5.7-2-.1-.6-.9.4-.6-.4.3-.8 3.1-2.5 2.5-3.5-.6-.9-3.3 1.5-2.6-.1.6-1.6 3.2-1.6 3.3-3.9.1-1.4-2.4.9-2.7.2-.2-.7 1.6-2.1 1.5-3 0-.9.3-1-.2-1.5s-2 1.9-2 1.9l-1.7-.6-.6 2.4-.5 2-2.1-1.2.6 2.5.5 2.4-2.2-.5 1.1 2.1 1.5 1.5.9 1.3.7.4.9.9.3 1.3.5 1.5c0 .1.1 1.4.1 1.4v3.1c-.4 0-1.1-.6-1.3-.2-.3.5 1.2 1.6 1 1.9-.3.3-2.5-.4-2.6.3-.1.7.2 1.7 1.5 2 1.3.3 4.2 1 3.7 1.6-.5.6-3.7-1.8-3.6 0 .1 1.7 1.2 2.4 2.1 2.7.8.3 4.1-.1 3.9.7-.2.8-2.6-.2-2.9.9-.2 1.1 1.7 1.3 2.1 1.3.4 0 1.8 0 2.3.3.5.4 2.3 2.3 3.5 3.3 1 .8 3.1 2.3 3.7 2.7-.6-.1-1.9-.2-2.1.3-.3.6 4.9 2.4 3.4 3-1.5.6-3.1-1.6-3.5-.3-.4 1.3 1 2.4 1.8 2.9s5.4.1 4.5 1.1c-.9 1-4.2-.7-4.2.5s2.2 3.2 3.3 3.1c1.1 0 2.4-1.9 2.9-.9.5 1-.9 1.4.2 1.6 1.1.3 1.9-1.1 3.2-.9 1.3.3 3.3 1.1 4.4 2.1s2.2 2.2 2.2 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#707937",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.7 306.5c.8 0 .9.4 1 .4.1 0 1.4-1.1 2.7-1.8 1.3-.7 3.1-1.1 3.1-1.1l.1.2s-2.2.6-3.3 1.3c-1.4.9-2.4 1.5-2.5 1.7-.1.2-.6.5-1.3.5-.8 0-1.1-.4-1.1-.7 0-.2.5-.5 1.3-.5m6.8-3.5s-.7.1-1.1-.3c-.4-.3-1.2-.6-2-.6s-2.1.4-3.1 1.4c-.1.1-.3.5-1.2 1 .3.1.9-.3 1.6-.9.9-.8 2.1-1 2.9-1.1.8-.1 1.4.3 1.7.6.4.3 1.2.2 1.2.2v-.3zm-40.4-16.5c.1 0 .1-.2 0-.5-.1 0-.6-.3-1.8-.9-1.3-.8-4.1-3-4.1-3s1.1 1.1 2.3 2.1c1.1 1 3.2 2.3 3.2 2.3.3 0 .4.1.4 0m28.5 20.2s.4-.6 1.2-1.7c.7-1.2 1.4-1.6 1.5-1.7.1-.1-.3-.7-.5-1.2-.2-.4-.2-.9-.2-1 0 0 .3.7.8 1.1.6.4.9.8.9.8s1.1-.1 1.1-.4c0-.2 0-.4-.2-.4-.2-.1-.4.2-.9-.1-1-.4-1.4-2-2.1-2-.6-.1-.2 1.6-.4 1.7-.9.1-1.7-3.5-4-3.6-1.6-.1-1.9.2-2 .6-.1.3 1.9 2.5 1.3 2.8-.7.3-2.8-3.3-4.4-3.4-1.6 0-1.7.6-1.6.9.1.3 1.7.6 1.3 1.8-.4 1.1-1.9-1.7-3.4-1.5-1.4.2-1.6.3-1.7.7-.1.4.5 1 .3 1.2-.2.1-1.1.1-1.8.6s-1.7 1.9-1.7 1.9.9-1.3 2.2-1.5c1.3-.1 4.4 0 4.4 0s-.4-.3-.9-.7c-.5-.4-.9-1.3-.9-1.3s.7.7 1.4 1.2c.7.6 1.5 1 1.5 1s1.3.1 1.4.3c.1.2 0 .5-.6 1.1-.6.6-1.4 1.3-1.4 1.3s1.3-1 1.6-1.3c.3-.2 1.2-.9 1.2-.9s1 .1 1.1.1c.1 0 0-.4-.6-1.3-.7-1-1.3-2-1.3-2s.8.7 1.6 1.8.7 1.6 1 1.6c.3.1.9.1 1.1.1.3 0 .3.5-.3 1.3-.6.9-.9 2-.9 2s.6-.9 1.2-1.6c.6-.6.9-1.4 1.2-1.4.2 0 1.1.1 1.2 0 .1-.1-.2-.4-.6-1.3-.4-.9-.6-2.1-.6-2.1s.4 1.2 1.1 2c.7.8.9 1.5 1.1 1.5.2 0 .7-.1 1-.1.2 0 .2 0 .2.1.1.4-.1.6-.5 1.4-.1.8-.4 1.6-.4 1.6m-17.2-10c1 .3 1.3.3 1.3.3s-1.3-.8-1.7-1.9c-.3-1.1 0-3.5-.6-3.5s-.9 1.7-1.5 1.4c-.6-.3.2-3.5-.4-4.8-.6-1.3-2.1-2.3-2.4-1.8-.3.5-.3 3.4-1.2 2.8-.9-.6.1-3.1-.2-4.2-.3-1.1-1-1.9-1.5-1.7-.5.3.2 2.4-.6 2.4s-.7-1.5-1-1.6c-.3-.1-.5.3-.7 0-.2-.3-.1-1.4-.5-1.3-.4.1-.3.9-.2 1.4.1.5.4 1.1.6 1.4.2.3.8.7.8.9 0 .3-.4.5-.8.5h-1.4s1.1.3 1.5.4c.4 0 1.2-.2 1.4.2.2.4 1.1 1.6 1.1 1.6s.2-.7.3-1.8c.1-1.2.1-2.2.1-2.2s.3 1.3.3 2.1-.3 2.4-.3 2.4.9.7.6.9c-.3.2-1.2.2-2.3.2-1.1 0-2.6-.4-2.6-.4s1.4.7 2.3.8c1 .2 3.1.2 3.1.2l1.4 1.6s.7-1.2.8-2.3c.1-1.2 0-2.5 0-2.5s.3 1.2.3 2.3c.1 1-.3 2.9-.5 3-.1.2-.9.6-1.5.8-.9.2-2.8.5-2.8.5s1.7.2 3-.1c1.3-.3 1.4-.6 1.8-.4.3.2.7.6.7.6s.8.6 1.1.7c0 .1-.6.4-.9.6-.3.2-1.2.6-1.2.6s1.2-.5 1.8-.6l.9-.3.4.2s0-.3-.1-1-.3-1.4-.3-1.4.4.7.6 1.3c.1.6.1 1.3.1 1.3s-.1.1.9.4m-24.9-28.5s.3-1.3.3-2.9c0-1.6-1.1-3.9-1.3-4.2-.2-.2-.3-.5-.3-.5l.7-1.1-.9.7s-.5-.1-1-.4c-.4-.3-.7-.7-.7-.7s.5.3.9.5c.5.2.6.1.6.1l-.4-1.6s-.5-.2-1.5-.8c-1.1-.6-2-1.5-2-1.5s1.4.9 2.2 1.2c.8.3 1.3.4 1.3.4s.9-.3 1.3-.5c.4-.3 1.3-.9 1.3-.9s-.9.5-1.4.6c-.6.1-1.3.2-1.3.2l-.3-1.9s-.2 0-.9-.9-1.3-2.2-1.3-2.2.7.9 1.3 1.4c.6.4 1.1 1.2 1.1 1.2s.7-.4 1.3-.8c.6-.4 2.2-1.6 2.2-1.6s-.9.5-2.2 1.1c-1.3.6-1.3.5-1.3.5s-.1-.8.1-1.2c.2-.3.6-.9.5-1.3-.1-.4-.3-.2-.4-.5-.1-.3.3-2.1.3-2.1s.1.6.1 1c0 .3-.2.8.3.8.4 0 2.6-2.2 2.9-2.6.3-.4.7-1.5-.5-1-1.1.4-.9 1.4-1.8 1.3-.3 0-.6-1.2-.9-.9-.4.3-1.1 1-1.3 1.9-.1.8.2 2.1-.3 2.5-.5.4-.9-1.5-1.8-1.2-.9.3-1.1 1.5-1 2 .1.5 2.2 2.9 1.5 3.2-.6.3-2.2-2-3.1-.4-.9 1.6 2.7 3.2 3.1 3.5.4.4 0 .5.7 1.3.6.8 1.5 1 1.9 1.5.4.5 1.7 3 1.7 4.7s.3 2.1.3 2.1m9.4 13.7s-.9-1-.6-2.7c.3-1.7 1.4-4.6 1-5-.4-.4-1.6 1.8-1.9 1.3-.3-.5.7-3.4.2-4.6-.5-1.2-.6-2-1.6-1.9-1 .1-1.5 3.5-2 2.9-.5-.6.3-2.1-.1-3-.3-.8-.5-1.1-1-1-.5.1-.8 1.7-1.1 1.7-.4 0-1-1.9-1.7-1.6-.8.3 1.8 3.6 1.8 3.6s.5-.4.7-1c.2-.6.5-1.2.5-1.2s.2 1.1 0 1.5c-.2.4-.3 1.4-.3 1.4s-.6.2-1.6 0-1.9-.6-1.9-.6.7.5 1.7.7c1 .3 2.2.6 2.2.6s.3.3.7 1c.5.6.9 1.1.9 1.1s.3-.6.6-1.7c.3-1 1-2.8 1-2.8s-.2 2.1-.5 3.1c-.2 1-.5 2.4-.5 2.4s-.9-.1-2.1-.3c-1.2-.2-2.9-.6-2.9-.6s1.5.6 2.9.9c1.4.4 2.3.6 2.3.6l1.1 1.5s.3-.5.7-1.2c.4-.6.8-1.5.8-1.5s-.2 1.1-.5 1.8-.6 1.1-.6 1.1-.7.2-1.4.2h-2s1.1.4 2 .5c.9.1 1.6.2 1.6.2s.1.4.5 1.1c.5 1.2 1.1 1.5 1.1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.6 311.8s-.5-.5-1.2-.9c-.7-.3-.9-.2-.9-.2l-.3-.1.6-1.5 4.4-4.2.7-4.3H257.7v5.8l.8.4 5 3v1.3s-.3.1-.7.3c-.5.2-.6.3-.6.3l-1.9.2-3.3-2.4-1.4-1.4-2.5 3.1-1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#2e6a4b",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M255 300.5s-.1.2-.1.9c0 .6 0 4.1-.1 4.6-.2.5-2.6 1.5-3.9 2.6-1.4 1.2-1.4 2.1-1.4 2.1s-.4 0-1.3.3c-.8.3-1.2.8-1.2.8s.5-2.1 2.7-4.1c2.2-2 3.3-2.1 3.5-2.5.3-.3 0-4.1.1-4.4 0-.3.3-.3.5-.3h1.2M260.7 313.1s.3-.7.6-.9c.2-.2.8-.6.8-.6s.1-.1-1.1-.6c-1.2-.5-1.8-.3-2.7-1-.9-.6-1.7-1.7-1.7-1.7l-1.2 1s.7 1 1.3 1.6c.7.6 2.2.8 2.8 1.2l1.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#bb1f35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M257.2 300.5s1.3-.1 1.5.1c.2.2.2.4.2.5 0 .1.1 3.2-.2 4.2-.2 1.1-.8 2.2-1.1 2.5s-2.3 2-3.2 2.9c-.9.9-1.9 2.2-1.9 2.2s-.3-.4-.6-.7c-.3-.4-.6-.5-.5-.7.1-.2 1.1-1.7 2.6-2.8 1.6-1 2.9-2.2 3.2-3.9.2-1.7 0-4.3 0-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#bb1f35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266 311.2s-.3-.3-1.4-.3c-1.1 0-1.2.2-1.2.2s-.6-.8-1.6-1.4c-1-.6-1.7-.6-2.8-1.3-1.1-.7-1.6-1.7-1.6-1.7l.8-1.6s.9 1.3 1.9 2c.9.7 3 1.4 3.7 1.9.6.5 2.2 2.2 2.2 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#61c0da",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M276 292.3s-2.8-1.1-2.6-2.1c.2-1 6.6-2.7 6.6-2.7l.1-1.7s-.9-.1-2.5.5c-1.6.5-4.1 1.2-6.9 1.2-1.7 0-2.6-.2-3-.3-.3-.1-22.5-1.4-23.3-1.4h-1.2c-3-.2-4.9-4.7-4.9-4.7l-1.4.2s.4 2.2-.3 2.4c-1.5.4-11.1-4.8-11.1-4.8l-.5 2.1s5.9 3.2 5.7 4.3c-.2 1.2-1.9 1.1-1.9 1.1l.7 1.4c.3 0 9.7.5 9.9 3.3.1 1.1-2.3 1.8-2.3 1.8l.8 1v.5s5.3 0 6.7.8c1.5.8 2.2 2 4 3 1.8 1 13.9.8 15.8.2 2.1-.6 3.4-3 6.9-4.1 3.5-1 4.6-1.1 4.6-1.1l.1-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3972a4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m276 292.3.1-.2h-.1c-.2-.1-.9-.4-1.4-.7-.3-.2-.5-.4-.7-.5-.2-.2-.3-.4-.3-.5v-.1l.1-.1c.1-.1.3-.2.5-.4.8-.5 2.3-1 3.6-1.4.6-.2 1.2-.4 1.6-.5.4-.1.7-.2.7-.2h.1l.1-2.1H280c-.3 0-1.2 0-2.5.5-1.6.5-4.1 1.2-6.8 1.2-1.7 0-2.5-.2-3-.3h-.1c-.1 0-.6 0-1.3-.1-2.4-.2-7.7-.5-12.5-.8-2.4-.1-4.7-.3-6.4-.4-.9 0-1.6-.1-2.1-.1h-1v.2-.2h-1.1c-.7 0-1.3-.3-1.9-.8-.9-.6-1.6-1.6-2-2.4-.2-.4-.4-.8-.6-1-.1-.1-.1-.2-.1-.3v-.1l-.1-.2-1.8.3V281.4c0 .2.1.7.1 1.1 0 .3 0 .5-.1.7 0 .1-.1.2-.1.2l-.1.1h-.1c-.2 0-.6-.1-1-.2-1.5-.5-4-1.6-6-2.6-1-.5-2-1-2.7-1.4-.7-.4-1.1-.6-1.1-.6l-.2-.1-.6 2.5.1.1s.1 0 .2.1c.5.3 1.9 1.1 3.1 1.9.6.4 1.2.8 1.6 1.2l.5.5c.1.2.1.3.1.3 0 .2-.1.4-.2.5-.2.2-.5.3-.7.4-.3.1-.5.1-.6.1h-.5l1 1.8h.6c1 .1 3.3.3 5.4.8 1 .2 2 .6 2.7 1 .3.2.6.4.8.6.2.2.3.5.3.7 0 .2-.1.4-.3.6-.3.3-.8.6-1.2.7-.2.1-.4.2-.5.2h-.2l-.3.1.9 1.2V294.5h1c.8 0 2 .1 3.1.2.6.1 1.1.1 1.6.2s.9.2 1.1.4c.7.4 1.2.9 1.8 1.4.6.5 1.2 1.1 2.1 1.6.3.2.7.3 1.2.3 1.5.3 4.1.4 6.7.4 1.8 0 3.5 0 4.9-.1.7 0 1.4-.1 1.9-.1.5-.1.9-.1 1.2-.2 1.1-.3 2-1.1 3-1.9 1-.8 2.2-1.7 3.9-2.2 1.7-.5 2.9-.8 3.6-.9.3-.1.6-.1.7-.1h.4l.3-1.4-.2-.1.1.3-.2-.1-.3 1.1h.2v-.2s-1.2.1-4.6 1.1c-1.8.5-3 1.4-4 2.2-1 .8-1.9 1.6-2.9 1.8-.2.1-.6.1-1.1.2-1.5.2-4.2.3-6.8.3-1.7 0-3.4 0-4.9-.2-.7-.1-1.3-.1-1.8-.2s-.9-.2-1-.3c-.9-.5-1.5-1-2.1-1.6-.6-.5-1.2-1-1.9-1.5-.4-.2-1-.4-1.7-.5-2.1-.4-5.1-.4-5.1-.4v.2h.2v-.6l-.8-1-.2.1.1.2s.6-.2 1.2-.5c.3-.2.6-.3.8-.6.2-.2.4-.5.4-.9s-.2-.8-.5-1.1c-.5-.5-1.4-.9-2.3-1.3-1.5-.5-3.2-.8-4.6-.9-.7-.1-1.3-.1-1.8-.2-.5 0-.8-.1-.8-.1v.2l.2-.1-.7-1.4-.2.1v.2h.1c.2 0 .6 0 1.1-.2.2-.1.4-.2.6-.4.2-.2.3-.4.4-.7v-.1c0-.2-.1-.4-.3-.7-.3-.4-.8-.8-1.4-1.2-1.7-1.3-4.2-2.6-4.2-2.6l-.1.2h.2l.5-2.1h-.2l-.1.2s2.2 1.2 4.7 2.4c1.3.6 2.5 1.2 3.7 1.7.6.2 1.1.4 1.5.5.4.1.8.2 1.1.2h.2c.1 0 .2-.1.3-.2.1-.1.2-.3.2-.5v-.6c0-.6-.1-1.3-.1-1.3h-.2v.2l1.4-.3v-.2l-.2.1s.5 1.2 1.3 2.3c.4.6 1 1.2 1.6 1.7.6.5 1.3.8 2.1.9H244.2v-.1.1-.1.1c.1 0 .5 0 1.2.1 2.4.1 7.9.4 12.7.7 2.4.2 4.7.3 6.4.4.9.1 1.6.1 2 .1h.8v-.1.1-.1.1c.5.1 1.4.3 3.1.3 2.8 0 5.3-.7 7-1.2 1.3-.4 2.2-.5 2.4-.5v-.2h-.2l-.1 1.7h.2l-.1-.2s-1.6.4-3.2 1c-.8.3-1.6.6-2.3.9-.3.2-.6.3-.8.5-.1.1-.2.1-.3.2-.1.1-.1.2-.2.3v.1c0 .2.1.3.1.5.1.2.4.5.7.7.8.6 2 1 2 1l.4.3-.2-.1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M229.3 287.7c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.7-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3972a4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M229.3 287.7h-.4c0 .7-.6 1.3-1.2 1.3-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.2.6 1.2 1.3h.8c0-1.2-.9-2.1-2.1-2.1-1.2 0-2.1.9-2.1 2.1 0 1.2.9 2.1 2.1 2.1 1.1 0 2.1-.9 2.1-2.1h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M238.8 279.9c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7s1.7.8 1.7 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3972a4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M238.8 279.9h-.4c0 .7-.6 1.3-1.2 1.3-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3c.7 0 1.2.6 1.2 1.3h.8c0-1.2-.9-2.1-2.1-2.1-1.2 0-2.1.9-2.1 2.1 0 1.2.9 2.1 2.1 2.1 1.1 0 2.1-.9 2.1-2.1h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M278.9 292.4c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-1 .8-1.7 1.7-1.7 1 0 1.7.8 1.7 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3972a4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M278.9 292.4h-.4c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3h.8c0-1.2-.9-2.2-2.1-2.2-1.2 0-2.1 1-2.1 2.2 0 1.2.9 2.2 2.1 2.2 1.2 0 2.1-1 2.1-2.2h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M220.1 277.4c-.6 1.3 1.6 3.7 3.1 3.9 1.5.3 2.3-.1 2.6-.8.3-.7.1-1.6-.3-2-.9-1.3-4.9-2.3-5.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M224.9 279.3c0-.8-1.3-1.5-2.1-1.5s-1.6 0-1.5.4c.1.4 2.2 1 2.3 1.2 0 .2-.6.5-.3.8.3.3.8.1 1.1-.2.3-.1.5-.2.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M238.2 293.8c.3 1.1-.5 1.7-1.6 2.2-1.1.5-3.4.2-3.9-.7-.5-.9.8-2.4 2.2-2.7 1.3-.4 2.9.2 3.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.8 294.4c.4-.1.4.7.8.6.4 0 .7-.7.6-1.1-.1-.4-.8-1-1.5-.9-.6 0-2.5 1.6-2.3 2 .2.4.6.4 1 .2.5-.1 1-.7 1.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M279.4 288c1 1.3 2.8.1 3.3-.4s2-1.4 1.4-2.3c-.6-.9-1.6-.8-2.3-.8-.7 0-2.1 1.1-2.4 1.5-.3.6-.5 1.4 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M279.7 287.1s.1-1.5 1.5-1.5c.8 0 .8.2 1.4.6.6.3.8-.4.8-.4s0 1-.9 1.1c-.9 0-.6-.4-1.5-.6-.9-.2-1.3.8-1.3.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eca757",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m257.5 284.3-.7-.4s-1.4-.1-2.3 0c-.9 0-2.7.1-2.7.1l2.7 7.9 3.2 4.7 1.3.4 2.5-.2.4-1.2-.9-7.6-3.5-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m257.5 284.3.1-.2-.7-.4h-2.4c-.9 0-2.7.1-2.7.1-.1 0-.1 0-.2.1v.2l2.7 7.9 3.2 4.7.1.1 1.2.4h.1l2.5-.2c.1 0 .2-.1.2-.1l.4-1.2v-.1l-1-7.6s0-.1-.1-.1l-3.5-3.6h.1l-.2.2 3.5 3.6.9 7.5-.4 1.1-2.4.2-1.1-.4-3.2-4.6-2.7-7.9-.2.1v.2h1c.6 0 1.3 0 1.7-.1h2.2v-.2l-.1.2.7.4.3-.3-.2.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eca757",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m248.5 284.8.1-.9s.6-.1 1.5-.1 1.6.1 1.7.1c.1.1 1.9 2.3 2.5 3.7.6 1.5 1.3 3.9 2.2 5.3.8 1.5 2.5 3.9 2.5 3.9s-.9.1-1.6.1h-1.6l-1.5-.6-4.6-7.1-1.2-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M248.5 284.8h.2l.1-.9h-.2v.2h.1c.2 0 .7-.1 1.3-.1h1.6v-.1l-.1.1v-.1l-.1.1.1-.1-.1.1.1-.1-.1.1s0 .1.1.1c.4.5 1.8 2.3 2.3 3.5.3.7.6 1.7 1 2.7.4 1 .7 1.9 1.2 2.7.8 1.5 2.6 4 2.6 4l.2-.1v-.2h-3.2v.2l.1-.2-1.4-.5-4.5-7-1.2-4.5-.1.1h.2-.2l-.2.1 1.2 4.5v.1l4.6 7.1.1.1 1.5.6H259c.1 0 .1 0 .2-.1v-.2s-.1-.2-.3-.4c-.5-.8-1.6-2.4-2.2-3.5-.4-.7-.8-1.7-1.1-2.7-.4-1-.7-1.9-1-2.7-.3-.8-.9-1.7-1.5-2.4-.3-.4-.5-.7-.7-.9-.1-.1-.2-.2-.2-.3l-.1-.1h-.1c-.1 0-.3-.1-.5-.1h-1.1c-.9 0-1.5.1-1.5.1-.1 0-.2.1-.2.2l-.1.9v.1l-.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eca757",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.6 283.8s1.9 0 2 .1c.2.1 2.2 1.9 3.1 4.2.8 2.3.4 2.6 1.5 5s2.6 3.9 2.6 3.9-3.1.2-4.9-.1c-1.8-.3-2.4-.3-2.8-.8-.4-.5-1.4-1.1-1.4-1.1h-1.8l.4-2.5-.5-5.5.1-2.8 1.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.6 283.8v.2H248.5v-.1.1-.1.1s.1 0 .1.1c.5.5 2.2 2.1 2.8 4 .4 1.1.5 1.8.6 2.4.1.7.3 1.4.9 2.5 1.1 2.4 2.6 4 2.6 4l.1-.1v-.2h-2c-1 0-2.1 0-2.9-.2-.9-.2-1.5-.2-1.9-.3-.2 0-.4-.1-.5-.2-.1-.1-.2-.1-.3-.2-.2-.3-.6-.6-.9-.8-.3-.2-.5-.4-.5-.4H245l.4-2.2-.5-5.5.1-2.7 1.5-.3.1-.1v.2-.4l-1.6.4c-.1 0-.2.1-.2.2l-.1 2.8.5 5.5-.4 2.4v.2s.1.1.2.1h1.8v-.2l-.1.2s.1 0 .2.1c.3.2.9.6 1.2.9.1.1.3.3.4.3.5.2 1.2.3 2.5.5.9.1 2 .2 3 .2h1.9c.1 0 .2-.1.2-.1v-.2l-.1-.1c-.3-.3-1.5-1.8-2.5-3.8-.5-1.2-.7-1.8-.8-2.5-.1-.6-.2-1.3-.7-2.5-.4-1.2-1.2-2.2-1.8-3-.3-.4-.6-.7-.9-.9l-.3-.3-.1-.1-.1-.1h-2.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eca757",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m265.3 285.3-3-1.2-5.5-.3s.2 1.5.4 2.8c.2 1.4 1.2 4.6 2.1 6.2.9 1.6 1.8 3.5 2.3 4 .5.5 3.7-.9 3.7-.9l2.1-.3-.3-2.3-.3-.7.5-6.4-.4-1-1.6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m265.3 285.3.1-.2-3-1.2h-.1l-5.5-.3c-.1 0-.1 0-.2.1 0 0-.1.1 0 .2 0 0 .2 1.5.4 2.8.2 1.4 1.2 4.6 2.1 6.3.4.8.9 1.7 1.3 2.4.2.4.4.7.6 1 .2.3.3.5.5.6.1.1.2.1.3.1h.3c.3 0 .6-.1 1-.2 1.1-.3 2.4-.8 2.4-.8l-.1-.2v.2l2.1-.3c.1 0 .2-.1.2-.2l-.3-2.3v-.1l-.3-.6.5-6.4v-.1l-.5-1c0-.1-.1-.1-.2-.1l-1.5.1-.1.2.1-.2-.1.2v.2l1.3-.1.4.8-.5 6.4v.1l.3.7.3 2-1.9.3s-.1.1-.4.1c-.3.1-.9.3-1.4.5-.5.2-1.1.3-1.4.3H261.7c-.1-.1-.2-.3-.4-.6-.5-.8-1.2-2.2-1.9-3.4-.9-1.5-1.9-4.8-2.1-6.1-.1-.7-.2-1.4-.3-1.9-.1-.5-.1-.9-.1-.9h-.2v.2l5.5.3 2.9 1.2h.1l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eca757",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.7 285.3c0 .7.7.7.9.7.2 0 .8-.3.8-1.2 0-.9-.6-1.7-1.7-1.8-1.2-.1-2 1.4-2 2.4s1 1.5 1 1.9c0 0-1 .9-.9 2.5 0 1.6 1.3 2.8 1.3 2.8s-1.4 1.1-1.4 2.2 1.1 1.8 2 1.8c1 0 2.2-.6 2.2-1.5 0-.8-.7-1.3-1.4-1.3-.6 0-.9.4-.9.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.5 285.3c0 .2 0 .3.1.5s.3.3.4.4c.2.1.3.1.5.1h.2c.1 0 .4-.1.6-.3.2-.2.4-.6.4-1.1 0-.5-.2-1-.5-1.3-.3-.4-.8-.6-1.4-.6h-.1c-.6 0-1.2.4-1.6.9-.4.5-.6 1.1-.6 1.7 0 .6.3 1 .5 1.3.1.2.3.3.3.4l.1.1h.2l-.1-.2s-.3.3-.5.7c-.3.4-.5 1.1-.5 1.9v.1c0 .9.4 1.6.7 2.1.3.5.7.9.7.9l.1-.1-.1-.2s-.4.3-.7.7c-.4.4-.7 1-.7 1.7 0 .6.3 1.1.7 1.5.4.4 1 .6 1.5.6s1.1-.2 1.6-.4c.2-.1.4-.3.6-.5.2-.2.3-.5.3-.7 0-.5-.2-.9-.5-1.2-.3-.3-.7-.4-1-.4-.4 0-.6.1-.8.3-.2.2-.3.4-.3.6 0 .1.1.2.2.2s.2-.1.2-.2 0-.2.1-.3c.1-.1.3-.2.5-.2.3 0 .6.1.8.3.2.2.4.5.4.8 0 .2-.1.3-.2.5-.2.2-.5.4-.8.6-.3.1-.7.2-1.1.2-.4 0-.9-.2-1.3-.5-.3-.3-.6-.7-.6-1.2s.3-1 .6-1.4c.2-.2.3-.4.5-.5.1-.1.1-.1.2-.1 0 0 .1-.1.1-.2s0-.1-.1-.2-1.2-1.3-1.3-2.7v-.1c0-.7.2-1.3.4-1.7.1-.2.2-.3.3-.4l.1-.1.1-.1c0-.1 0-.2-.1-.3-.1-.2-.4-.4-.6-.7-.2-.3-.4-.6-.4-.9 0-.4.2-1 .5-1.4.3-.4.8-.7 1.2-.7h.1c.5 0 .9.2 1.2.5.3.3.4.6.4 1.1 0 .4-.1.7-.3.8-.1.1-.3.2-.4.2h-.1c-.1 0-.3 0-.4-.1-.1 0-.1-.1-.1-.1v-.3c0-.1-.1-.2-.2-.2.1-.3 0-.2 0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eca757",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266.2 285.7c0 .7-.4.7-.8.7s-.9-.2-.9-1.1c0-.9 1.1-1.3 1.9-1.3.7 0 2 1 2 2.2 0 1.2-.9 2-.9 2s.5.3.5 1.8-1 2.6-1 2.6 1.3.5 1.3 2.1-1.1 2.1-1.8 2.1c-.8 0-2.1-.4-2.1-1.5s.7-1.5 1.2-1.5 1 .6 1 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266 285.7v.3c0 .1-.1.1-.2.2h-.4c-.2 0-.3 0-.5-.2-.1-.1-.2-.3-.2-.7 0-.2.1-.3.2-.5s.4-.4.7-.5c.3-.1.6-.2.8-.2.1 0 .3.1.5.2.3.2.6.4.9.7.2.3.4.7.4 1.1 0 .6-.2 1-.4 1.4-.1.2-.2.3-.3.4l-.1.1s-.1.1-.1.2 0 .1.1.2v-.1.1-.1.1c.1.1.4.4.4 1.6 0 .7-.2 1.3-.5 1.8-.1.2-.2.4-.3.5 0 .1-.1.1-.1.1s-.1.1 0 .2c0 .1.1.1.1.1s.3.1.6.4c.3.3.6.7.6 1.5 0 .7-.3 1.2-.6 1.5-.3.3-.7.4-1.1.4-.3 0-.8-.1-1.2-.3-.2-.1-.3-.3-.5-.4-.1-.2-.2-.3-.2-.6 0-.5.2-.8.3-1 .2-.2.4-.3.6-.3.2 0 .4.1.6.3.2.2.3.5.3.7 0 .1.1.2.2.2s.2-.1.2-.2c0-.4-.1-.7-.4-1-.2-.3-.5-.4-.9-.4-.3 0-.6.1-.9.4-.3.3-.5.7-.5 1.3 0 .3.1.6.3.8.2.3.6.6 1 .7.4.1.7.2 1.1.2.4 0 .9-.1 1.3-.5s.7-1 .7-1.8c0-.9-.3-1.4-.7-1.8-.4-.4-.7-.5-.7-.5l-.1.2.2.1s1-1.2 1-2.8c0-.8-.1-1.3-.3-1.6-.2-.3-.3-.4-.4-.4l-.1.2.1.2s.2-.2.5-.6c.2-.4.5-.9.5-1.6 0-.7-.3-1.3-.8-1.7-.2-.2-.5-.4-.7-.5-.2-.1-.5-.2-.7-.2-.4 0-.9.1-1.3.4-.2.1-.4.3-.5.5-.1.2-.2.4-.2.7 0 .5.2.8.4 1 .2.2.5.3.7.3.2 0 .4 0 .7-.1l.3-.3c.1-.1.1-.3.1-.5 0-.1-.1-.2-.2-.2-.2.1-.3.2-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#893329",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M247.6 294.1s.2.1.3.4c.1.3.3.8.6 1.1.7.6 5.8.8 7.4.8 1.6 0 6.2.2 7.1-.3.9-.5 1-1.4 1.5-1.8.5-.4.7-.4.7-.4l-.7.6v1.1l.4.6s-.1.3-.6.6-1 .5-1.8.5c-.7.1-10.6.1-12.2-.2-1.6-.3-1.5-.2-1.9-.6-.5-.3-.7-.7-.7-.7l.2-.7-.3-1zM263.6 284.7l.9.4s-.7.2-1.3 1.8c-.6 1.6-.1 2.1-.5 2.2-.4.2-4.6 0-4.6 0l-.7-1.8 6.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M277.2 284s-.7-.3-1.1-.9c-.3-.6-.6-1.4-.4-1.5.3-.2.8.4.8.8-.1.6.7 1.6.7 1.6M285.5 281.7s.5.9.7 1l1 .5s-1.2 0-1.5-.3c-.4-.3-.9-1.2-.9-1.2h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M288 282.5s-.7.4-1.3.2c-.6-.2-1.1-.6-.8-.8.2-.3.4-.2.7.2.3.3 1.4.4 1.4.4M292.2 278.9s-.6.5-1 .5-1.3-.2-1.3-.3c0-.2 1.1-.3 1.3-.3.2 0 1 .1 1 .1M285.9 270.5s-.9.3-1.2.8c-.3.5-.2 1 .2 1s.5-.6.5-.7c-.1-.2.5-1.1.5-1.1M281.7 272.8s-.7.4-.9.8c-.2.4-.3 1.2.1 1.3.4 0 .5-.6.6-1 0-.3.2-1.1.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m274.2 277.9-2.3 2.4s5.3 2.9 9.3 2.8c4.1-.1 8.7-3.3 9-3.9.3-.7 0-3.5-.5-4.4-.5-.9-3.3-3.1-4.4-3-1.1.1-2.9 1.5-4.7 3.2-1.7 1.7-1.6 3.1-4 3-2.3-.1-2.4-.1-2.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m274.2 277.9-.1-.1-2.5 2.6.2.1s1.3.7 3 1.4c1.8.7 4.1 1.4 6.1 1.4h.3c2.1-.1 4.3-.9 6-1.8.9-.4 1.6-.9 2.2-1.3.3-.2.5-.4.7-.5l.4-.4c.1-.1.1-.3.1-.5v-.7c0-.6-.1-1.3-.2-1.9-.1-.6-.3-1.2-.5-1.6-.1-.3-.4-.6-.8-.9-.5-.5-1.2-1-1.9-1.5-.3-.2-.7-.4-1-.5s-.6-.2-.8-.2h-.1c-.6.1-1.3.5-2.2 1-.8.6-1.7 1.4-2.6 2.2-.9.8-1.3 1.6-1.7 2.1-.2.3-.4.5-.7.6-.3.1-.6.2-1.1.2h-.3c-2.4-.1-2.5-.1-2.5-.1h-.1l-.1.1.2.3v.2s.4 0 2.5.1h.3c.5 0 1-.1 1.3-.3.5-.3.9-.7 1.2-1.2.3-.5.7-1 1.3-1.6.9-.8 1.8-1.6 2.6-2.2.8-.6 1.5-.9 2-1h.1c.2 0 .6.1 1 .3.6.3 1.3.8 1.9 1.3.3.2.6.5.8.7.2.2.4.4.5.6.2.3.3.8.4 1.4.1.6.2 1.3.2 1.8v.6c0 .2 0 .3-.1.4l-.3.3c-.6.5-1.8 1.4-3.4 2.1s-3.4 1.4-5.2 1.4h-.3c-2 0-4.2-.7-6-1.4-.9-.3-1.6-.7-2.2-1-.3-.1-.5-.2-.6-.3-.1-.1-.2-.1-.2-.1l-.1.2.2.1 2.3-2.4h-.2v.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3c8487",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M273.6 278.8s5.7.8 7.3-.6c1.6-1.4 3.4-4.2 4.5-4.9 1.1-.6 1.7-.6 1.7-.6s.8.5 1.2.9c.4.3 1.4 1.2 1.4 1.2l.5 2.7v1.5l-1.8 1.4-3.2 1.5-3.1 1-2.6-.1-5.3-1.6-1.4-.9-.3-.3 1.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M282.2 275.6c0-.5.3-.5.7-.5.4 0 .9.1.9.6s-.5 1.2-.9 1.2c-.3 0-.7-.8-.7-1.3M284.5 277c0-.4.3-.7.9-.7s1 .6 1 1-.4.8-.9.8-1-.7-1-1.1M283.7 280.4c0-.5.3-.6.8-.6s.8.2.8.8c0 .5-.4 1-.9 1-.4-.1-.7-.7-.7-1.2M280.7 279.3c0-.6.6-.8 1-.8.5 0 .8.5.8 1 0 .6-.4 1-.8 1-.4.2-1-.6-1-1.2M276 279.9c0-.6.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 .6-.5 1.1-1.2 1.1s-1.2-.4-1.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M284.5 277c0-.4.5-.7.9-.7s.6.3.6.7c0 .4-.3.7-.6.7s-.9-.3-.9-.7M283.7 280.3c0-.5.4-.6.9-.6s.8.2.8.6c0 .4-.4.8-.9.8-.4 0-.8-.4-.8-.8M280.8 279.3c0-.5.8-.7 1.2-.7.3 0 .3.3.3.8s-.3.9-.6.9c-.5 0-.9-.5-.9-1M282.2 275.5c0-.4.3-.5.6-.5s.5.1.5.6c0 .4-.2.8-.5.8-.3.1-.6-.4-.6-.9M276 279.6c0-.5.5-1 1.1-1 .7 0 1.3.2 1.3.8 0 .5-.8 1.4-1.5 1.4-.6-.1-.9-.7-.9-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M278.2 278.7s-.8.1-1.2.5c-.4.4-.5.8-.2 1 .2.1.5-.3.6-.5 0-.2.8-1 .8-1M281.9 277.8s-.8.5-.8 1.1c-.1.5 0 .8.2.8s.3-.7.3-.9c-.1-.3.3-1 .3-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M282.6 278.6s-.5 0-.8.3c-.3.3-.6.7-.4.7.2 0 .6-.2.6-.4-.1-.1.6-.6.6-.6M283.4 274.3s-.4.3-.6.5c-.2.2-.5.7-.2.8.3.1.4-.1.6-.5.2-.3.2-.8.2-.8M286.2 276.1s-.7.1-1 .4c-.2.3-.4.7-.1.7s.4-.2.5-.5l.6-.6M285.7 279.5s-.2.5-.6.7c-.4.2-.6.4-.8.1-.2-.3 0-.5.3-.6.3 0 1.1-.2 1.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M290.3 277.2s.3 1.6-1 2.3c-1.3.8-5.1 3.5-8.7 3.1-3.6-.3-7.7-2.4-7.7-2.4l-.6.3.9.4 2.8 1.2 3.2.9 2 .1 1.7-.2 3.2-1.1 2.7-1.4 1.4-1.1.4-.5v-1.5l-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M219.9 256.9s.8.7.8 1.3c-.1.6-.3.8-.5.7-.2-.1-.2-.7-.2-1 0-.2-.1-1-.1-1M226 262.6s-.2 1-.6 1.2c-.4.1-.7-.3-.6-.5.1-.2.4 0 .6-.2.1-.2.6-.5.6-.5M212.7 263.5s.3.6.8.7c.5.1.8-.3.7-.4-.1-.2-.3-.1-.6-.1-.2-.1-.9-.2-.9-.2M215.1 268.2s.5.6 1.2.7c.7.1 1-.5 1.1-.6.1-.2-.8-.1-1 .1-.4.1-1.3-.2-1.3-.2M219.3 271.8s1.1-.2 1.3-.5c.2-.3.5-.8.2-1.1-.2-.3-.4.4-.6.7-.1.3-.9.9-.9.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M226.1 268.9s.7-4.9-3.2-8.3c-4-3.5-6.5-2.6-7.9-1.3-1.3 1.3-2.5 5.4 1.7 9 4.2 3.6 9.4 2.5 9.4 2.5v-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M226.1 268.9h.2v-1c0-1.6-.4-5-3.3-7.5-2.1-1.8-3.8-2.5-5.2-2.5-1.3 0-2.2.5-2.9 1.2-.7.6-1.3 2-1.3 3.6 0 1.8.8 3.9 3 5.8 2.6 2.3 5.6 2.7 7.5 2.7 1.2 0 2-.2 2-.2h.2l.1-2-.3-.1h.2-.4l-.1 1.9h.2v-.2c-.1 0-.8.2-1.9.2-1.9 0-4.7-.4-7.3-2.6-2.1-1.9-2.8-3.8-2.8-5.5 0-1.5.6-2.7 1.2-3.2.6-.6 1.5-1 2.6-1.1 1.3 0 2.9.6 5 2.4 2.8 2.5 3.2 5.7 3.2 7.2V269l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3c8487",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M214.1 263.7s-.1-2.7 1.2-3.5c1.3-.8 5.4-1.5 7.5 2.5 2.1 4 2.1 5.9 1.6 7.9h-2.2l-3.4-1.4-2.8-2.1-1.9-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M225.6 269.6s-.7.8-2.1.7c-1.4-.1-8-1.8-9.7-7.7l.1 1.3.1.4.4 1.2 1.4 2 1.7 1.5 2.2 1.1 1.6.5 2.1.4h1.2l1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M222.1 267.9c0-.5.3-.5.7-.5.4 0 .7-.2.7.3s-.3 1.3-.7 1.3c-.4 0-.7-.6-.7-1.1M222.4 264.8c0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.6-.7.6-.4 0-.7-.3-.7-.6M219.4 268.2c0-.3.4-.5.8-.5.5 0 .8.2.8.5s-.8.7-1.3.7c-.4 0-.3-.4-.3-.7M219.1 264.5c0-.5.2-.3.6-.3.4 0 .9.1.9.6s-.5 1.1-.9 1.1c-.3 0-.6-.9-.6-1.4M216.4 265.1c0-.4.3-.9.8-.9s1 .6 1 .9c0 .4-.4.7-.9.7s-.9-.3-.9-.7M216.9 261.9c0-.4.3-.4.8-.4s.9.2.9.6c0 .4-.6.9-1.1.9-.6 0-.6-.7-.6-1.1M219.9 261.5c0-.4.3-.3.8-.3s.9.3.9.7c0 .4-.6.8-1.1.8-.5.1-.6-.8-.6-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M216.9 261.8c.1-.3.3-.5.6-.5.4 0 .7.1.7.5s-.3.7-.6.7c-.4 0-.8-.3-.7-.7M216.3 265c0-.4.2-.8.6-.8.4 0 .7 0 .7.4s-.3.9-.8.9c-.3 0-.5-.1-.5-.5M219.9 261.6c0-.3.3-.3.6-.3.4 0 .6.1.6.4s-.3.6-.7.6c-.3-.1-.5-.4-.5-.7M219.2 264.7c0 .4.3.8.7.8.4 0 .8-.3.8-.8s-.4-.8-.8-.8c-.4-.1-.7.3-.7.8M222.5 264.2c0 .4.3.7.8.7.4 0 .8-.3.8-.7 0-.4-.3-.7-.8-.7-.4 0-.8.3-.8.7M219.3 268.2c0-.3.4-.7.7-.7.4 0 .7.2.7.6 0 .3-.6.8-1 .8-.3 0-.4-.4-.4-.7M222.2 267.7c0-.4.3-.5.8-.5.4 0 .6 0 .6.5 0 .4-.3.8-.8.8-.5-.1-.6-.4-.6-.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M222.9 262.7s.4.5.5 1c.1.4.1.9-.1.9-.2.1-.4-.3-.5-.6 0-.4.1-1.3.1-1.3M220.4 260s.3.4.3.8 0 .8-.3.8c-.2 0-.2-.4-.2-.7 0-.2.2-.9.2-.9M217.5 260.4s.3.4.3.8 0 .8-.3.8c-.2 0-.2-.4-.2-.7 0-.2.2-.9.2-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M216.4 261s.4.1.7.4c.3.3.5.6.3.7-.1.2-.4-.1-.5-.3 0-.1-.5-.8-.5-.8M218.7 264.1s.6 0 .9.3c.3.3.6.5.4.7-.2.2-.6-.2-.8-.4-.2-.1-.5-.6-.5-.6M215.9 264s.5.1.8.3c.3.2.3.6.2.6-.1.1-.3-.1-.5-.3-.3-.2-.5-.6-.5-.6M222.6 266.1s.2.6.2 1.1c0 .5 0 .9-.2.9s-.3-.6-.3-.9c0-.4.3-1.1.3-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M221.8 267.1s.5.2.7.4c.2.2.3.5.1.5-.2 0-.3-.3-.4-.4-.1-.2-.4-.5-.4-.5M218.9 267.3s.5.1.7.2c.2.1.2.8.2.9 0 .1-.3 0-.5-.3-.1-.3-.4-.8-.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M217.7 258.2s-2.6.6-3.1 2.2c-.5 1.7-.5 3.6-.5 3.6l-.4-2.1.5-1.4.8-1.3 1.2-.7 1-.3h.5zM225.9 268.3s.3-.6-.5-2.7-2.3-4.8-2.3-4.8l1.2 1.4 1 1.6.5 1.5.3 1.3v1.3l-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.5 264.9s.9.6 1 .9c.1.3.1.4-.1.5-.2.1-.6-.3-.7-.5-.1-.2-.2-.9-.2-.9M224.7 275.2s.4-.8 1-1.1c.6-.3 1-.3 1.2-.1.2.2-.4.6-.8.7-.4.2-1.4.5-1.4.5M231.1 277.7s.6-.3 1.1-.8c.4-.4.5-.8.3-.9-.2-.2-.7.1-.9.5-.3.3-.5 1.2-.5 1.2M230.4 277.1s.2-.8.4-1.1c.2-.3.5-.4.8-.3.2.1.1.5-.1.7-.1.2-1.1.7-1.1.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.2 272.2s-4-5.8-10.2-6.1c-5-.2-6.6 4.2-6.4 5.6.2 1.3 2.1 4.2 8.7 4.7s7.7-3.1 8-3.3c.2-.3-.1-.9-.1-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m241.2 272.2.2-.1s-1-1.5-2.8-3c-1.8-1.5-4.4-3.1-7.6-3.2h-.4c-2.3 0-3.8 1-4.8 2.2-.5.6-.8 1.2-1.1 1.8-.2.6-.3 1.1-.3 1.6v.3c.2 1.5 2.2 4.4 8.9 4.9h1.2c2.8 0 4.5-.8 5.5-1.7.5-.4.8-.9 1.1-1.2.1-.2.2-.3.3-.4l.1-.1-.1-.1.1.1-.1-.1.1.1c.1 0 .1-.1.2-.2v-.2c0-.2-.1-.3-.1-.5 0-.1-.1-.2-.1-.2h-.3l-.2.1s.1.1.1.2.1.2.1.3v.1c-.1 0-.1.1-.1.1 0 .1-.1.2-.2.3-.3.4-.7 1.1-1.7 1.8-1 .6-2.4 1.1-4.7 1.1h-1.2c-6.6-.5-8.4-3.4-8.5-4.5v-.2c0-.3.1-.8.3-1.4.3-.8.9-1.8 1.8-2.5s2.1-1.2 3.7-1.2h.4c3.1.1 5.6 1.6 7.3 3.1.9.7 1.6 1.5 2 2 .2.3.4.5.5.6.1.1.1.1.1.2v.1l.3-.2-.2.1.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3c8487",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.5 268.2s1.7 1.3 2.4 2.3c.7 1 .9 1.7.4 1.9-.4.1-4-3.2-7-3.9-3-.7-5.5-.1-6.1 1.4-.6 1.4-.4 3.5 1 4.4 1.3.9 7.7 1.9 7.7 1.9s2.9-.4 3-.4c.1 0 1.8-1 1.8-1l.4-1 .5-1.3.2-.5-1.5-1.7-2.8-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.4 269c0 .4-.4.6-.8.6s-.7-.2-.7-.6c0-.4.3-.7.7-.7.4 0 .8.3.8.7M227.7 270.3c0-.4.4-.4.8-.4s.8.3.8.7c0 .4-.7.9-1 .7-.5-.2-.6-.6-.6-1M231.6 272.5c0-.5.4-.9.9-.9s.9.4.9.9-.7 1-1.2 1c-.4-.1-.6-.6-.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.7 273.3c0-.4.4-.5.8-.5s.8.4.8.8-.5.7-.8.7c-.4 0-.8-.5-.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234 274.8c0-.3.2-.6.5-.6s.8.2.8.5-.3.7-.7.7c-.3 0-.6-.3-.6-.6M236.4 273c0-.4.2-.4.7-.4.4 0 .8.2.8.7 0 .4-.5.7-.9.7-.5-.1-.6-.6-.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.1 268.7c0 .3-.1.5-.5.5-.3 0-.7-.2-.7-.5s.2-.4.5-.4c.3-.1.7 0 .7.4M229.2 270.2c0 .4-.6.6-.9.6-.3 0-.6-.2-.6-.6 0-.4.3-.5.6-.5.4 0 .9.1.9.5M230.1 273.3c0 .3-.1.6-.5.6s-.9-.2-.9-.6c0-.3.1-.5.5-.5.4-.1.9.2.9.5M233.2 272.2c0 .3-.6.7-1 .7-.3 0-.5-.6-.5-.9 0-.3.3-.6.6-.6.4 0 .9.5.9.8M237.9 273.2c0 .3-.6.3-.9.3-.3 0-.6-.4-.6-.7 0-.3.1-.7.9-.6.3.1.6.7.6 1M235.1 274.6c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.5.6-.5c.4 0 .6.2.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.6 272.7s.6-.2 1.1-.2c.5 0 .5.2.5.3 0 .1-.4.2-.6.2-.1 0-1-.3-1-.3M232.9 275s.5-.3.9-.4c.4-.1.7 0 .7.3 0 .2-.2.3-.6.3-.4 0-1-.2-1-.2M231.1 271s1.1.5 1.4.9c.2.4.3.6.1.7-.2.1-.5-.2-.6-.4-.2-.2-.9-1.2-.9-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M230.8 272.4s.9-.2 1.2-.2c.4 0 .5 0 .6.2 0 .2-.1.3-.4.2-.3 0-1.4-.2-1.4-.2M228.1 272.5s.9.1 1.2.4c.2.2.2.5.1.6-.1.1-.5.1-.7-.1-.1-.2-.6-.9-.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228 273.8s.4-.5.7-.6c.3-.1.7-.1.8.1.1.2-.3.4-.5.5h-1M227.2 269.7s.6 0 .9.3c.3.3.4.5.3.6-.1.1-.4.1-.7 0-.3-.4-.5-.9-.5-.9M229.3 267.4s.9.3 1.3.7c.3.4.3.7.1.8-.2.1-.5-.1-.7-.3-.3-.3-.7-1.2-.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.1 274.2s-1.9 1.6-6.3 1.5c-4.3-.2-8.3-2-9.2-4l.4 1 1 1.3 3 1.6 3.4.8 2.7.2 2.5-.4s1.9-.9 2-.9c.1 0 .3-.5.3-.5l.2-.6zM240.6 272.1s-.7-.9-1.7-1.9c-1-.9-5-3.5-5-3.5l3.2 1.4 2.1 1.8 1.5 1.7-.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.8 268.3s1.1.4 1.3.7c.2.3.4.5.4.5s-.3.7-.5.4c-.3-.3-.3-.3-.6-.7-.3-.4-.6-.9-.6-.9M244.1 266.5s1 .4 1.4.9c.4.5.3.9.1 1-.2 0-.8-.5-.9-.8-.2-.2-.6-1.1-.6-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.1 266.3s1 .7 1.1 1c.2.3.5.7.2.8-.3.1-.8-.4-.9-.7-.2-.2-.4-1.1-.4-1.1M250.6 267.6s.8.3.8.9c.1.6-.1 1.1-.1 1.1s-.5-.4-.5-.6.1-.2 0-.5-.2-.9-.2-.9M252 268.1s.6.6.7 1c.1.4.2.7-.2.7-.3 0-.5-.3-.5-.7v-1M242.2 280.1s.5.2.9.1c.4-.2.8-.6.7-.8-.1-.3-.3-.5-.6-.2s-.2.5-.4.6c-.3.1-.6.3-.6.3M247.6 281.5s.7-.1 1.2-.6.7-.9.4-1c-.3-.1-.8 0-.9.4 0 .4-.7 1.2-.7 1.2M252 281.7s.5-.3 1-.7c.4-.4.6-.6.4-.9-.3-.3-.5-.1-.6.1-.1.1 0 .1-.2.6l-.6.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M253.4 281.7s.6-.7.7-1.1c.1-.4.2-.8-.1-.8-.3 0-.6.4-.6.7v1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M239.9 274.5c0-2 2.8-6.5 6-6.4 1.3 0 3.9.7 6 1.7 1.8.8 2.3 1.7 3.5 1.9 1.2.3 2.9.1 2.9.1l4-.4-3.1 4.6-1.1 1s-1 1.9-3.8 3-7.6.3-9.8-.2c-2.1-.7-4.7-2.7-4.6-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M239.9 274.5h.2c0-.4.2-1.1.5-1.7.4-1 1.2-2.1 2.1-3 .9-.9 2-1.5 3.1-1.5.6 0 1.6.2 2.7.5s2.2.7 3.3 1.2c.9.4 1.4.8 1.9 1.1.5.4 1 .7 1.6.8.5.1 1.1.2 1.6.2.8 0 1.4-.1 1.4-.1l3.5-.4-2.8 4.2-1.1 1c0 .1-1 1.9-3.7 2.9-1 .4-2.3.5-3.6.5-2.3 0-4.7-.4-6.1-.8-1-.2-2.2-.9-3-1.7-.9-.9-1.5-2-1.5-3.2v-.1H239.7v.1c0 1.4.7 2.6 1.6 3.5.9.9 2.1 1.6 3.2 1.8 1.4.3 3.8.8 6.2.8 1.3 0 2.6-.1 3.7-.6 2.9-1.1 3.9-3.1 3.9-3.1l-.2-.1.1.2 1.1-1 3.4-5-4.4.5h-.1c-.2 0-.7.1-1.2.1s-1.1 0-1.5-.2c-.5-.1-.9-.4-1.5-.7-.5-.4-1.1-.8-2-1.2-1.1-.5-2.2-.9-3.3-1.2-1.1-.3-2.1-.5-2.8-.5-.8 0-1.6.3-2.4.8-1.1.7-2 1.8-2.7 2.9-.7 1.1-1.1 2.2-1.1 3h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3c8487",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259.2 275.1c-.3.3-.7.3-1.1.3-.4 0-9.3-5.4-12-5.2-2.8.2-5.4 1.4-5.4 4.2-.1 2.8.6 2.8 1.2 3.6.6.8 6 2 6 2l3.3-.1 2.6-.3 2.3-1.3 1.3-1 .9-1.1.9-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.2 273.7c0 .6-.2.9-.7.9-.5 0-.9-.2-.9-.8 0-.6.3-.8.9-.8.4 0 .7.1.7.7M246.1 271.2c0-.5.4-.7.9-.7s.9.2.9.6c0 .5-.4.8-.9.8-.5.1-.9-.3-.9-.7M251.4 272.6c0-.4.3-.7.8-.7.4 0 .8.3.8.7 0 .4-.3.7-.8.7-.4 0-.8-.3-.8-.7M252.5 275.9c0-.5.4-.9.8-.9.5 0 .9.2.9.7 0 .5-.2 1-.6 1-.5 0-1.1-.3-1.1-.8M249.9 278c0-.4.4-.8.9-.8s.9.4.9.8-.3.7-.8.7c-.6 0-1-.3-1-.7M245.1 277.1c0-.4.3-.8.8-.8.4 0 .8.3.8.8 0 .4-.3.8-.8.8s-.8-.4-.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.2 273.5c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8s.4-.6.8-.6.8.2.8.6M247.7 271c0 .4-.1.7-.6.7-.4 0-1-.3-1-.7 0-.4.4-.8.8-.8.5.1.8.4.8.8M252.9 272.4c0 .4-.3.6-.8.6-.4 0-.7-.3-.7-.6 0-.4.3-.7.7-.7.4 0 .8.3.8.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M250.2 274.6c0 .6-.2.9-.8.9-.5 0-.9-.3-.9-.8 0-.6.3-.8.8-.8.5.1.9.1.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.4 276.9c0 .4-.4.8-.8.8s-.8-.3-.8-.8c0-.4.5-.6 1-.6s.6.2.6.6M250 274.5c0 .4-.4.8-.8.8s-.8-.3-.8-.8c0-.4.4-.8.8-.8s.8.3.8.8M254.2 275.6c0 .5-.3.9-.8.9s-.9-.4-.9-.9.1-.6.6-.6c.5-.1 1.1.1 1.1.6M251.5 277.8c0 .4-.3.7-.8.7s-.9-.3-.9-.7c0-.5.4-.6.9-.6.4-.1.8.1.8.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.8 275.1s1.3-.1 1.6.1c.2.2.2.6.1.7-.1.1-.6.1-.8 0-.1-.2-.9-.8-.9-.8M250.5 270.9s1 .3 1.4.7c.4.4.3.9.3.9-.1.1-.4.2-.7-.2-.3-.3-1-1.4-1-1.4M247.5 272.9s1.2.6 1.4 1c.3.4.3.7.2.8-.1.2-.7 0-.8-.2 0-.2-.8-1.6-.8-1.6M247 273.8s1.3.2 1.6.4c.3.3.6.3.5.5 0 .2-.2.3-.4.3s-.8-.3-.9-.4l-.8-.8M245.5 269.9s1.4.2 1.6.4c.3.2.3.8 0 1-.3.2-.6-.2-.8-.4-.1-.2-.8-1-.8-1M242.5 272s1.3.6 1.6 1.1c.2.3.4.6 0 .7-.4.1-.7-.5-.7-.7 0-.1-.9-1.1-.9-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.3 273.6s.8-.2 1.2-.2.9-.1.9.2c0 .3-.5.4-.7.3-.3-.1-1.4-.3-1.4-.3M249.1 278.1s.9-.5 1.3-.5c.4.1.6.1.6.3 0 .3-.5.2-.7.2h-1.2M244.3 277.4s.3-.5.7-.6c.4-.1.5 0 .6.1.1.2-.3.5-.5.5h-.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M258.1 276.5s-1.3 1.6-3.2 2.4c-1.9.8-3.2 1-5.8.9-2.6-.2-3.8-.6-5.6-1.5-1.7-.9-3.1-2.2-3.4-2.7-.3-.6.3.9.3.9l1.6 2.1 1.9.8 2.8.7 2.6.3h2l2.4-.4 1.5-.6 1-.6.8-.7 1.1-1.6zM255.6 271.8s-.7.2-2.3-.7c-1.6-1-3.5-2.2-7.1-2.3-3.6 0-4.7 2.4-5 2.6-.2.2 1.6-2.1 1.6-2.1l1.6-.9 1.3-.2h1.2l1.6.4 1.4.5 1.7.6 1.5.8 1.8.9.7.4zM260.4 272.8h-2.7c-.6 0-.6.2-.7.3l-.2.4-.6-1.4 2.9-.4 1.6.6-.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#3c8487",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M256.6 287.5c.1.4.5.7.9.7h1.3l2.8-.2 1-1.1.6-2.6s.8-.9.8-1l2.6-1.5 2.3-.7 1.5-.2 2-.7 1.5-.8.7-1 .6-1.5-.6-2-1.6-2.1-2.7-1.1H268l-2.5.9-4.4 1s-2.4 1.1-3.4 2.9c-1 1.9-1 2.4-1.2 4.9-.1 2.9.1 6.1.1 6.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m256.6 287.5-.2.1c.1.2.2.4.4.6.2.2.4.3.7.3H258.9l2.9-.2 1.1-1.3.6-2.6h-.2l.2.1s.2-.2.4-.5l.3-.3.1-.1v-.1h-.3l.2.1v-.1h-.2l.2.1-.2-.1.1.1-.2-.1.1.1-.1-.1v.1l-.1-.1v.1s.1 0 .2-.1c.3-.2.9-.5 1.5-.8.5-.3 1-.5 1-.5l-.1-.2v.2l2.3-.6 1.5-.2 2.1-.7 1.6-.8.7-1 .7-1.6-.7-2.1-1.6-2.2-2.8-1.1H268l-2.5.9-4.4 1s-.6.3-1.4.8c-.7.5-1.6 1.3-2.2 2.2-.5.9-.8 1.6-.9 2.3-.1.7-.2 1.4-.3 2.7-.1 1-.1 2.1-.1 3.1v2.7l.4-.1h.2v-2.7c0-1 0-2.1.1-3 .1-1.3.1-2 .3-2.6.1-.6.4-1.2.9-2.1.5-.9 1.3-1.6 2-2.1.4-.2.7-.4.9-.6.1-.1.2-.1.3-.1h.1l-.1-.2v.2l4.4-1 2.5-.9h2.1l2.6 1 1.5 2 .6 1.9-.6 1.4-.6.9-1.4.8-2 .7-1.5.2-2.3.7s-.7.4-1.3.7c-.3.2-.7.4-.9.5-.1.1-.2.1-.3.2 0 0-.1 0-.1.1v.1h.2l-.2-.1v.1h.2l-.2-.1h.1l-.1-.1h.1l-.1-.1s-.1.1-.1.2c-.2.3-.6.7-.6.7l-.6 2.6-.9 1-2.8.2v.2-.2h-1.2c-.2 0-.3-.1-.4-.2-.1-.1-.2-.3-.3-.4l-.5.1h.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M257.7 286.5c.8 0 .2-1.4 1.2-3 .9-1.6 2.1-3.7 2.4-3.7.3 0 .3.3.7.2.3-.1.9-.6 1-.8 0-.1 0-1.1.8-1.7.7-.6 1.8-1.4 2.2-1.6.5-.1.7-.2.8 0 .1.2-.3.6.1.6.3.1 1.1.1 1.3-.4.2-.5.1-.7.1-.7s.5-.5 1.5-.3c.9.2 1.1.2 1.2.5.1.4-.4.4-.3.7.1.3-.1.2 0 .4s.2.8.9.7c.6 0 .9-.4.9-.4l.2-.3s.2-.4-.1-.6c-.2-.2-.2-.3.1-.2.3.1 1.2 1.5 1.6.9.3-.6.4-1.3.2-1.5-.2-.2-1.5-2.2-1.5-2.2l-2.4-.8-3.2.3-3.1 1.8-3.3 1.6s-.2 2.4-.7 1.9c-.5-.4-1.3-1.6-1.5-1.2-.2.4-.7 2.1-1 3-.3.9-1.1 3.5-1 4.5.1 1 .6 2.3.9 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#94bcbd",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M260.6 282.7c-.2 0-.6.3-.7.4-.1.1-.3.4-.2.7.1.3.6.6.6.6h.4l.8-.2s.3-.3.3-.6c0-.4-.2-.5-.3-.5-.1 0-.9-.4-.9-.4M265.6 278.6c-.4-.2-.6.1-.7.3-.1.1 0 .5 0 .5s.1.6.3.7c.2.1.8.3 1 .1.2-.2.4-.3.4-.7 0-.4-.6-.6-.6-.6l-.4-.3zM269.6 279.6c0-.2-.4-.3-.7-.2-.3 0-.6.4-.5.9.1.5.6.5 1 .4.4-.1.3-.6.3-.7 0-.1-.1-.4-.1-.4M258 280.4c0 .2.4.7 1 .7s.9-.5.9-.8c0-.3-.3.3-.7.4-.4.1-.7.2-.8 0-.2-.3-.4-.3-.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.8 283.6s.1.5-.3.8c-.4.3-.6.2-.8.2-.2 0-.4 0-.6-.3-.2-.2-.3-.5-.3-.5s.4.7 1 .5c.7-.2 1-.7 1-.7M272.5 276.9s0 .5-.4.7c-.4.2-.6.3-.8.2-.2 0-.5-.1-.6-.3-.5-.7-.2-1.2-.2-1.2s.3 1.3 1 1.2c.7 0 1-.6 1-.6M263 279.2s-.3 1-1 1c-.6 0-.6-.2-.6-.3.1-.1.3.1.6 0 .3 0 1-.7 1-.7M264.8 279s-.1.7.2 1c.2.3.5.4.8.4.3 0 .5-.1.7-.3.2-.3.1-.6.1-.6s0 .1-.2.4c-.2.2-.4.2-.6.2s-.6 0-.7-.3c-.1-.3-.3-.8-.3-.8M268.2 275.6s.2.5-.2 1c-.4.4-1.2.2-1.2.2s.6.2.9-.2c.4-.4.5-1 .5-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#275650",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M257.4 288.1s4.2-.1 4.6-.7c.3-.6-.4-2.8 2.2-4.6 2.5-1.8 4.5-1.8 5.9-1.9 1.4-.1 4.3-1 4.8-3.6.3-1.6-1.8-1.7-2.6-3.2-.8-1.5-2.9-.9-3-.9-.1 0-2.4-.1-3.5 1-.6.6-.6 1.4-.9 1.8-.3.4-3.1 0-3.4.4-.3.4.1 1.4-.1 1.6-.2.2-.9-.6-.9-.6l.2-2.2 3.6-2.1 4-2.2s2.7.1 2.8.1c.1 0 2.7 1.4 2.8 1.4.1 0 1.4 1.6 1.4 1.6s.3.6.4 1.9c.1.6 0 1.1-.1 1.6-.7 2.3-2.9 3.9-5.3 4-2.4.1-4.6 1.2-5.7 2-1.1.8-1.6 4.3-1.7 4.7 0 .4-5.2.1-5.2.1l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259.2 279.9c-.2.2-.5.2-.6-.1-.2-.7.2-1.7.2-1.7s0 1.1.1 1.2c.1.2.3.1.4.3 0 0 0 .1-.1.3M261.8 279.3c-.2-.1-.2-.7 0-1s1.3-1.2 1.3-1.2-.4.9-.5 1.2c-.1.4-.5 1.1-.8 1M260.8 283.6c-.2 0-.2-.3-.2-.8s.8-1.3.8-1.3-.2.7-.3 1c0 .2.1.4.1.7 0 .3-.3.4-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M262.7 282.4s-.4.4-.8.7c-.4.2-.9.6-1.2.5-.3-.1.2-.6.3-.7.8-.3 1.7-.5 1.7-.5M266.3 277.3s-.5.4-.7 1c-.2.6-.3 1-.1 1.1.2.1.6-.6.6-.9.1-.3.2-1.2.2-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#272425",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M267.7 279.1s-.3-.3-.9-.5c-.6-.2-.9 0-.9.2-.1.2-.5.4-.3.6.2.1.5-.2.7-.3.2 0 .4-.2.7-.1.2 0 .7.1.7.1M266.9 275.5c.2.2.5-.2.8-.5.3-.3.5-.9.5-.9s-.6.3-.9.5c-.2.2-.5.8-.4.9M272.4 275.4s-.7.3-1 .6c-.2.3-.6.7-.3.8.3.2.5-.2.7-.4.2-.2.6-1 .6-1M270.8 279.1s-.2.5-.7.8c-.4.3-1 .4-1.1.3-.1-.2.1-.5.2-.6.2-.1.3-.1.7-.2.5-.1.9-.3.9-.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.5-1.7-.9 1.7l1.1-.1.7-3z",
    transform: "matrix(1.9509 0 0 2.4519 460.022 515.695)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9509 0 0 2.4519 458.462 526.852)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.4831 3.1644 -3.0899 7.5216 4397.644 -3748.652)",
    cx: -325.366,
    cy: 635.265,
    r: 0.37,
    fx: -325.366,
    fy: 635.265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e05173",
      stopOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-235 -266.95)",
    d: "M232.7 266.5c-.3 1.9.5 3.5 1.7 3.8 1.3.2 2.5-1.2 2.8-3 .3-1.9-.5-3.5-1.7-3.8h-.3c-1.1 0-2.2 1.3-2.5 3",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#b)",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-5 2.45 6.8 2.9L5-2.45l-6.8-2.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.5-1.75H.4L-1 1.85l1.3-.2.7-3.2-.6-.3v.1h.1l-.1.1.4.2-.6 2.9-.9.1 1.3-3.2-.1-.1-.1.1z",
    transform: "matrix(1.9509 0 0 2.4519 460.022 515.818)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.9 259.3c-.5-.1-.9.3-1 .8-.1.5.3 1 .8 1.1.5.1.9-.3 1-.8.1-.6-.3-1.1-.8-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.9 259.3c0-.1 0-.1 0 0-.6-.1-1 .3-1.1.8v.1c0 .5.4.9.9 1h.1c.5 0 1-.4 1-.9v-.1c0-.5-.4-1-.9-.9.4.1.7.5.7.9v.1c-.1.4-.4.7-.8.7h-.1c-.4 0-.7-.4-.7-.8v-.1c0-.4.4-.7.8-.7l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.3 259.4s.2.1 0 0c-.4 0-1.1.3-1.1.8s.4.8.8.8-.2.1-.2.1l-.5-.2-.2-.3-.2-.4.1-.5.3-.4.4-.1h.3l.3.2zM236.5 261.7s-.2 0-.4.3-.6.8-.6.8l.8-1.9.4.2-.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m1.55-1.75-3.4 3.2 1.4.3 2.3-3z",
    transform: "matrix(1.9509 0 0 2.4519 574.052 533.226)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m1.6-1.75-.1-.1-3.5 3.3 1.6.4L2-1.25l-.4-.6h-.1l.1.1-.1.1.3.4-2.3 2.9-1.1-.3 3.2-3v-.1l-.1.1z",
    transform: "matrix(1.9509 0 0 2.4519 573.955 533.226)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M297.3 266.5c-.5-.3-1.3-.1-1.6.5-.3.5-.2 1.2.4 1.5.5.3 1.3.1 1.6-.5.3-.5.1-1.2-.4-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M297.3 266.5c-.1-.2-.3-.2-.5-.2-.4 0-.9.2-1.1.6-.1.2-.2.4-.2.7 0 .4.2.8.6 1 .2.1.4.1.6.1.4 0 .9-.2 1.1-.6.1-.2.2-.4.2-.7-.1-.4-.3-.8-.7-.9.3.3.4.6.4.9 0 .2-.1.4-.2.6-.2.3-.6.6-1 .6-.2 0-.3 0-.5-.1-.3-.2-.5-.5-.5-.8 0-.2 0-.4.2-.6.2-.3.6-.5 1-.5.2-.2.4-.1.6-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M297.6 266.8s.2.3 0 0c-.4-.2-1.5-.2-1.8.4-.3.6 0 1.1.5 1.3.5.2-.2 0-.2 0l-.5-.4-.1-.4v-.6l.4-.4.6-.3h.5l.3.2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M295.5 269s-.2-.2-.6.1c-.4.2-1.1.7-1.1.7l1.9-1.7.4.4-.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-1.3-1.85 1.8 3.9.8-1.1-2.1-3z",
    transform: "matrix(1.9509 0 0 2.4519 412.615 488.847)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-1.3-1.9h-.1L.5 2.2 1.4.9-.7-2.2l-.7.2v.1h.1v.1l.5-.1L1.1.9l-.6.9L-1.2-2l-.1.1v.1z",
    transform: "matrix(1.9509 0 0 2.4519 412.615 488.97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca4a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M209.5 247.9c-.4.4-.5 1.1-.1 1.5.4.5 1.1.6 1.5.2.4-.4.5-1 .1-1.5s-1.1-.6-1.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#e05173",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M216.4 255.8c.9 1.8.7 3.8-.5 4.4-1.2.7-3-.3-3.9-2.1-.9-1.8-.7-3.8.5-4.4 1.2-.6 3 .3 3.9 2.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9509 0 0 2.4519 417.883 502.945)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.7392 -8.0242 7.4452 -.706 -5701.116 -2172.997)",
    cx: -335.226,
    cy: 732.47,
    r: 0.373,
    fx: -335.226,
    fy: 732.47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e05173",
      stopOpacity: 1
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-214.2 -257.2)",
    d: "M212.5 253.7c-1.2.6-1.4 2.6-.5 4.4.9 1.8 2.7 2.8 3.9 2.1 1.2-.6 1.4-2.6.5-4.4-.7-1.4-2-2.3-3.1-2.3-.2 0-.5.1-.8.2",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#d)",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m3.8 3.6-.7-7.9-6.9.7.8 7.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M209.5 247.9c-.3.1-.5.5-.5.8 0 .3.1.6.3.8.2.3.6.4.9.4.3 0 .5-.1.7-.3.3-.2.4-.6.4-.9 0-.3-.1-.6-.3-.8-.2-.3-.6-.4-.9-.4-.2 0-.5.1-.6.4.2-.1.4-.1.6-.1.3 0 .6.1.8.4.2.2.2.4.2.7 0 .3-.1.5-.3.7-.2.1-.4.2-.6.2-.3 0-.6-.1-.8-.4-.2-.2-.2-.4-.2-.7 0-.3.1-.6.3-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M209.9 247.7s.3-.2 0 0c-.3.3-.6 1.2-.2 1.6.4.4 1 .3 1.3 0 .3-.3-.1.2-.1.2l-.5.3-.4-.1-.5-.2-.3-.5-.1-.6.2-.5.2-.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a28b38",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M211.2 250.2s-.2.2-.1.6c.1.4.2 1.2.2 1.2l-1-2.2.5-.2.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M210.1 256.1s.8.2 1.2 0c.4-.2.5-.5.6-.6.1-.1.2-.5.2-.7 0-.2-.6-1.1-.8-1.2-.2-.1-.8 0-.9-.1-.1-.1.1-.3-.1-.4-.2-.1-1.4 1.3-1.2 1.5.2.2.3-.1.4.1.1.2 0 .7 0 .9 0 .1.6.5.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M211.2 253.7c.1.2.5.8.7.8.2.1.7.1.9 0 .2-.1.7-.6.7-.8 0-.2 0-.4-.1-.6-.1-.2 0-.8-.3-.9-.2 0-.3-.1-.4-.2-.1-.1.1-.3-.1-.6-.2-.2-2 .9-1.9 1.1.1.2.3 0 .4.1.1.2 0 .9.1 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M215.4 253.2c.1-.3.1-1.2-.1-1.4-.2-.2-.5-.2-.5-.3 0-.1.2-.2.2-.4s-2.1.1-1.9.3c.1.2.5.1.5.2s-.3.3-.4.5c0 .2.1.8.2.9.1.1 0 .3.2.4.3.1.2.1.4.2s1 0 1.2 0c0-.1.1-.1.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f0e32a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M211.3 254.5c.2.3 0 .9-.2 1-.1.2-1.1-.1-1.1-.3 0-.2-.1-.5 0-.6.1-.2.4-.5.7-.5.3.1.6.3.6.4M211.6 253.3c-.1.2 0 .5.2.6.1.1.8.3 1 .2.2-.1.5-1.1.3-1.3-.1-.2-.5-.2-.6-.2-.2.1-.8.5-.9.7M213.8 252.3c-.1.2-.1.5 0 .6.1.1.5.4.8.4.3 0 .4-.7.4-.9 0-.1-.1-.2-.3-.3-.2-.1-.9.2-.9.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.9 263.5s.3.6.7.7c.4.1.6 0 .7 0 .1 0 .4-.2.6-.3.1-.2.3-1 .3-1.2-.1-.2-.4-.5-.4-.6 0-.1.3-.1.2-.3-.1-.2-1.6-.1-1.6.1 0 .3.3.1.2.3l-.5.5c-.3.2-.2.8-.2.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.1 262.8c-.1.2-.2.8-.1.9.1.1.3.5.5.6.1.1.8.1.9 0 .2-.1.3-.2.3-.4.1-.2.5-.5.4-.7-.1-.2-.1-.2-.1-.4 0-.1.3-.2.3-.4s-1.7-.8-1.8-.6c0 .2.2.2.2.3 0 .2-.6.5-.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.8 265.1c.2-.1.8-.6.8-.9 0-.2-.2-.4-.1-.5.1-.1.2 0 .4-.1.1-.1-1.3-1.3-1.3-1-.1.2.2.4.1.4-.1.1-.4 0-.5 0-.1.1-.4.5-.4.6 0 .1-.2.2-.1.4l.2.4c.1.2.6.7.7.7 0 .1 0 .1.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f0e32a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234.7 263.3c-.1.3-.6.5-.8.5-.2 0-.6-.7-.5-.8.1-.1.2-.3.4-.3s.6 0 .7.1c.2.1.2.4.2.5M235.5 262.8c-.2.1-.3.3-.3.5 0 .1.3.7.5.7s1-.4 1-.6c0-.2-.2-.4-.3-.5 0 0-.7-.2-.9-.1M237.5 263.6c-.2.1-.3.3-.3.3 0 .1 0 .6.2.7.2.1.7-.2.7-.3.1-.1.1-.2 0-.3-.1-.1-.6-.4-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M290.7 269.6s0 .7.3.9c.3.3.5.3.6.3.1.1.4.1.6 0 .2-.1.7-.7.7-.9 0-.1-.2-.6-.1-.7 0-.1.3 0 .3-.2s-1.3-.9-1.4-.7c-.1.2.2.3 0 .3-.1.1-.5.2-.7.2-.1.2-.3.8-.3.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M292.7 270c-.1.1-.5.5-.5.6 0 .1 0 .5.1.6.1.1.6.4.7.4.2 0 .3-.1.5-.2s.7-.2.6-.3c0-.2 0-.2.1-.3.1-.1.3 0 .4-.2.1-.1-1-1.3-1.1-1.2-.1.1.1.2 0 .3 0 .2-.6.2-.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d51e40",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M293.2 273c.2.1.9.1 1.1-.1.2-.1.2-.4.3-.4.1 0 .1.2.3.2.2 0 0-1.6-.2-1.5-.2.1-.1.4-.2.3-.1 0-.2-.3-.4-.3-.1 0-.6.1-.7.1-.1.1-.3 0-.3.1-.1.2-.1.2-.1.3-.1.2-.1.8 0 .9 0 .2-.1.3.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f0e32a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M292.3 270.1c-.2.2-.7.1-.8.1-.2-.1-.2-.9 0-.9.1 0 .3-.2.5-.1s.5.2.5.4-.1.5-.2.5M293.1 270.2c-.2 0-.4.1-.5.2-.1.1-.1.6 0 .7.1.1 1 .2 1.1 0 .1-.1.1-.4 0-.5 0 .1-.5-.4-.6-.4M294 271.8c-.2-.1-.4 0-.5 0-.1.1-.3.4-.3.6 0 .2.6.3.7.3.1 0 .2 0 .2-.2s-.1-.7-.1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M2.4-1.6 3.2.2.2 2l-.5.1-.1-.7L-.9.2l-1.8-.6-.5-.1.4-.9 1.4-.6H.1l1.5-.1z",
    transform: "matrix(1.9509 0 0 2.4519 477.58 405.605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.9 199.7s-5.6-1.1-5.5 3.6c0 1.5.4 2 1.6 2.3 1.2.3 3.6.4 5.6 2.3 2 1.8 2.2 3.1 2.2 4.2s-.5 2.1-.5 2.1l1.3 6.2 1.3 4.6 3.8-2.2 2.2-6.8-2.8-12.2-9.2-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.9 199.7v-.2s-.6-.1-1.3-.1c-.8 0-1.9.1-2.8.6-.9.5-1.6 1.5-1.6 3.1v.1c0 .7.1 1.3.4 1.7.3.4.7.6 1.3.8.6.2 1.5.3 2.5.6s2.1.8 3 1.6c1 .9 1.5 1.7 1.8 2.3.3.7.3 1.2.3 1.8 0 .5-.1 1-.2 1.4-.1.2-.1.3-.2.4v.1l1.3 6.2 1.3 4.8 4-2.3 2.3-6.9-2.9-12.3-9.1-4.1-.1.4-.1.1 8.9 4 2.8 12.1-2.2 6.7-3.6 2.1-1.2-4.4-1.3-6.2h-.2l.1.1s.5-1 .5-2.2c0-.5 0-1.2-.3-1.9s-.9-1.5-1.9-2.4c-1-.9-2.2-1.4-3.1-1.7-1-.3-1.9-.4-2.5-.6-.6-.2-.9-.4-1.1-.7-.2-.3-.3-.8-.3-1.5v-.1c0-1.5.6-2.3 1.4-2.8.8-.5 1.8-.6 2.6-.6h1.5l-.1.1.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M260.5 223.1s1.9-.7 2.5-2.3c.1-.4-2-2.3-2-2.3s1.1.5 1.6 1 .9.7 1.1.6c.2-.1 1.1-2.2.7-2.6-.3-.5-.9-1.5-1.7-2.1-.8-.5-1.9-.5-1.9-.5s1.5-.5 2.2-.1c.7.4.8.9.9.7.1-.2-.2-2.3-.5-3-.3-.7-.7-1-1.6-1.2-.9-.2-1.9-.1-1.9-.1s1.3-.7 2.3-.5c1 .2 1 .7 1.1.6.1-.1-.5-1.9-.7-2.4-.2-.5-1.4-1.4-1.7-1.5-.3-.1-1.4-.1-1.4-.1h-.5s.7-.5 1.7-.4c.9.1 1 .4 1.1.3.1-.1-.1-.2-.7-.6-.6-.4-3.4-1.6-3.4-1.6h-2.6s0-.6.7-.8c.7-.1 1 .1.9-.1 0-.2-2.2-.7-2.2-.7s-1.2 0-1.7.1c-.5 0-2.4.2-2.4.2s.2-.4.5-.7c.3-.2.7-.4 1.1-.5.8-.2-.5-.9-.5-.9l.7-1.1 3.1.3 6.6 3.8 3.1 2.7 2 5-.6 8.6-4.4 3.6s-1.9.3-1.9.2c-.1.2.4-1.6.4-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.8 201.8s-.2-.6-.2-1.4c0-.8.1-.7.1-.7s-2.1-.3-3.6.9-.6 3.3-.6 3.3.7-.7 1.5-1c.9-.3 2.4-.3 2.4-.3.1-.1-.3-.7-.9-.9-.6-.1-1.7-.1-1.7-.1s.6-.5 1.8-.3c1 .2 1.2.5 1.2.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m261.3 223.9-1.4.5.9 6 5.7 9.7 3-.5 1-1.8s.5 0 .8.3c.3.3 1.5 2.2 2.4 2.6.9.4 1.4.2 2.2.9.8.7 3.9 5.2 4 5.4.2.2-.2-1.9-.2-1.9l-.9-2.7-1.2-1.9-.2-.5h1.6l1 .6 1.5 1.3.8.9.4.9.2.8.4 1.3.8 1.8 1 1.7.3-.7-.5-2-1.5-4.9-.9-1.6s1.2.9 1.6 1c.3.1 1.4 1.8 1.4 1.8l.7 1.7.5 1.6.3 1.4.5 1.5.9-.5-.2-1.1-.8-3.3-.3-3.6s.4 0 .9.6 1 1.9 1 1.9l.4 3.3.5 3 1 3.1 1 1.9.7 1.1v-1.6c0-.1-1.2-12.8-1.2-12.8l.2-.5s.2-.1.6.5c.4.6.8 1.6.8 1.6l.4 2 .2 1.4.3 2.6.3 2.8 1.3 3 .7 1.6.4-1.9-.6-13.7.3-.4s.7.6 1 1c.2.4.7.8.7.8l.4 3 .4 8.6.3 2.2 2.5-22.6 1.6-.3.2-.4-1.1-.9-2.6-4-1.7-3.9-3-5.6-5.3-6.4s-3.3-2.8-4.1-3.4c-.8-.6-1.5-1-1.5-1l.3-.8.9-1.4-.1-.1h-.7l-1.8.3-1.8-.5-3.5-2.4-3.7-1.8-2.2-.8-5.3-1.3-5.3-.7h-2.4l-2.2.4s-1.1.5-1.4 1.1c-.3.7-.4 1.1-.3 2.1.1 1 .7 1.5 2.2 2.1 1.5.6 5 2.9 5 2.9l1.7 1.7.6.8.1.6 1.1 8.9-2.2 4.8-1.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M267 237.7s.9 1.6 2.3.4c1.4-1.3-.6-4.8-.6-5 0-.2.6-.3.6-.3l1 1.8s.6 1 .4 2.5c-.2 1.6-1.7 2.9-1.7 2.9l-1.7-.4-.3-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M300.2 258.6 299 255s-.4-2.3-.4-2.8-.2-6.3-.3-7.5c-.1-1.1 0-2.4-.2-2.5-.1-.2-1.3-1.8-1.3-1.8l-.5-.5.4-.3s.4.5.6.2c.1-.3 0-1.5-.5-3.5s-3.1-6.7-3.1-6.7l.3.2.7.7 1.5 1.2 3.2 1.2 1.8.3 1.1 2.3s.8 3.9.8 5.9c-.1 2-.2 3.6-.9 5.6-.8 2-.9 8.3-1.1 9.3-.1 1-.5 2-.5 2l-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M300.2 248.1s.7-.8 1-1.9c.3-1.1.4-9.9-.6-11-1-1.1-3.2-1.9-3.3-1.9-.1.1.9 2.8.9 2.8s.3.4.6 1.1c.2.4.4 1.1.5 1.4.1.8.7 2.5.8 4.8.1 2.5.1 4.7.1 4.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M295.4 253.6s.4-4.1.2-7.2c-.2-3-.5-3.4-.7-4-.3-.5-1.3-2.5-2-5s-1.2-4.5-1.6-5c-.5-.5-1.4-1.6-1.6-1.3-.2.3-.2.9-.2.9l-1.3-.3-.3-.8.4-1.3-.1-.6-.1-.9 1.6 1.3 3.3 2.3 1.7 6.9 1.5 4.3.2 7.2-.2 6.4-.8-2.9zM297.4 233.9s.9.8 1.4 1.1c.5.3 1.5.9 1.3.9-.2.1-1.1-.3-1.6-.6-.6-.3-.9-.7-.9-.7l-.2-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M290.9 252s.6-1.5.6-3.3c-.1-1.9-1-6.3-1.3-6.9s-1.6-1.4-2.8-3.9c-1.2-2.5-1.1-3-1.8-3.9-.8-.9-1.6-1.9-1.6-1.9l.2-2.7 2.9 1.5 1.2.6 1.5 7 1.3 2 .5 2.8.7 6.5.4 5.2-.2.5-1.6-3.5zM287.6 249s.1-2.1-.4-3.9c-.5-1.8-.9-3.2-1.5-3.8-.6-.6-2-2.1-3.3-4-1.3-1.9-3.1-4-3.1-4v-2.6s.9.8 1.6 1.2c.7.3 1.8 1 1.8 1l.8 3 1 2.2 1.4 1.9.9.9.6 3.2.3 1.8.8 2.6-.3 1.3-.6-.8zM285.2 249.1l-.8-.8s.4-.5.2-1.5-.5-2-.9-3c-.5-1-.6-1.6-.9-1.9-.3-.3-2.7-2.6-3.6-3.3-.8-.7-2.1-2-2.9-2.5-.8-.5-1.4-.6-1.4-.6l-.5-3.2s1.1 1.4 1.7 1.7c.6.2 1.7.6 1.7.6l2.3 4 .8 1 2.1 1.7.9 1.7.6 2 .8 2.7.1 1.7-.2-.3zM280.8 248.2s-1.3-1.5-1.5-2.5c-.2-1 .1-1-.3-2.1s-1.8-2.8-2.9-3.7c-1.1-.9-2.8-2.2-2.7-3 .1-.7.3-.8.3-.8l.7.6 3.6 3.8 1.1 2 .8 2.5.6 1.2.5 1.5-.2.5zM293.6 229.6s2.5 3 3.1.2c.3-1.2-.9-3.6-.9-3.6s-2.3-4-3.1-5c-.8-1-4.6-5.8-4.6-5.8l-2.8-1.3.9 1.6s2.1 2.1 4.7 6.7 2.1 7.1 2.1 7.1l.6.1zM279.4 211.2s4.9 4.2 8 8.7c3.1 4.5 4.4 7.5 3.7 8.1-.7.6-2.7-.3-3.5-1.6-.8-1.3-1.5-3.5-4.4-6.9-3-3.4-4.4-3.9-4.4-3.9l-2.1-3.5 2.7-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M276.8 221.2s2.9 2.4 4.7 4.4c1.8 1.9 2.8 3.3 2.8 3.3l1.2 1.2s-.7-1.2-.3-1.7c.4-.4.9-.2.9-.2l-9.2-9.6v2.6zM276.2 221.4s.9 1.8 2.5 3.3c1.5 1.5 3.2 3.1 3.2 3.1l.6 2.3s-4.2-3.2-4.2-2.4c0 .8 1 2.4 1 2.4l-1.3-.7-1.8-2.6-1.1-2.2-1.2-3.1 2.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263.6 231.3s2.2 1.9 3.4 0c1.2-1.9.3-4.1.3-4.1s3.1 4.5 3.9.3c.2-.8-1.9-3.7-1.9-3.7l.7-.7 1.6 2.6s1.5-.7 1.5-2.5-1.5-4.2-1.5-4.2l1.4 1.6s2.8.1 2.9-1.7c0-1.7-2.4-3.6-2.4-3.6s1.9.1 1.9-1-2.6-1.9-2.7-2.6c0-.7.8-1.9 2-1.3 1.2.7 2.9 1.2 3.5-.1.7-1.3 0-1.6 0-1.6s-1.5-.3-1.7-.4c-.2-.1-2.7-1.4-2.7-1.4l-2.2-.8-2.2-.3.8 1.7.6 4.6v2.1l.4 4.6-1.1 3.8-.6.7-.4.5-.9 2-1.3 1.4-1.7 2.2-1.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M279.1 239.9s-.6-1.4-1.7-2.3c-1.2-.9-3.1-1-3.1-1l3.2 3.4 1.6-.1zM283.5 240.7s-1-2.1-2.2-3.3c-1.2-1.3-2-2.9-2.3-2.9-.3 0-.6.1-.6.1l.3 2.6 2.2 2.1s2.1 1.5 2.6 1.4M287.2 240.5s-.5-2.4-1.7-4.7c-1.2-2.3-2.5-3.3-2.5-3.3l.3 2.5 1 2.4 1.6 2.4 1.3.7zM290.2 239.2s.9-5 .1-6.3c-.8-1.4-2.2-1.6-2.2-1.6l-.5.7.5 3.5 1.2 2.7.9 1zM293.2 230.9s.7.4 1.6 2c.9 1.7 2.1 6.6 2.1 6.9 0 .3-.5.2-.6.1-.1-.1-3.1-4.7-3.1-4.7l-.5-4.4.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M272.3 236.6s1.6-.3 1.6-.9-1.9-1.7-1.7-2.6c.1-.4 1.6.1 1.7-.2.1-.3-1.6-3-1.1-3.6.5-.6 1.9 2.8 1.9 2.8s.9 1.6.5 2.5c-.9 3.1-2.9 2-2.9 2M276 233.1c.1-.2 2.5.3 2.5.2.1-.6-2.2-2.3-2.2-2.3s-.5-1-.4-1.2c.2-.2 1.6.2 1.7 0 .1-.2-1.7-2.5-1.7-2.9 0-.4.5-.1.5-.1s1.4 1.4 2.1 2.6c.7 1.2 1.4 2.1 1.2 4-.2 1.8-3.9.3-3.7-.3M286.9 229.4s-.4-1.6-.2-1.8c.2-.2.9-.4.9-.4s-1.3-.8-1.9-.8c-.6 0-.7-.2-.9.1s1.1 1.8 1.1 1.8l1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M279.6 230.7s3.7.9 3.9.7c.2-.3-3-3.2-3-3.2s-.2-.5-.2-.7c0-.2 1.3-.2 1.7.1.4.3 0 .9.1 1.2.1.2 1.3 2 1.5 1.7.2-.3-.2-2.5-.1-2.6.1-.2 1.4 1.2 1.8 1.5.4.2 2.4 1.9 2.6 1.1.2-.8.3-.9.3-1.3-.1-.4.7 2.1-.3 2.4-1 .3-2.1-.3-2.1-.3l-.9-.7-.5-.5s.6 2-.1 2.2c-.6.2-1.4.1-1.4.1l-1.6-.2-1.7-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M228.6 222.5s-3.1.3-5.2-.1c-1.2-.2-1.7-2.1-1.6-5.5v-.4l-.2-.2c-.3-.4-1.1-1.5-.9-2.4.2-1.2 4.1-4.3 4.6-4.5.3-.1.9.1 1.1.2.4-.4 1-.9 1.2-.9.1 0 .3.2.4.4.1.1.1.2.1.3 0 .1-.2.2-.4.4-.4.4-1.1.8-1.1 1.3 0 .2 0 .4-.1.6 0 .4 0 .8-.3 1.2-.1.2-.3.4-.4.6-.4.5-.7 1-.8 1.3 0 .1 0 .2-.1.3-.1.4-.2.7.2.9.4.2 1.7 0 2.8-.5.7-.3 1.1-.7 1.4-.9.1-.1.2-.2.3-.2 0 .2-.7 1.3-1.8 1.8-.4.2-.8.3-1.1.5-.6.3-1.1.6-1.5.5h-.1v.1s-.3.7 0 1.2c.2.4.7.6 1.4.6 2.1.1 3.2-.4 3.3-.5l-.1-.1-1.1 4zm1.2-4.2s-1.2.5-3.2.4c-.6 0-1.1-.2-1.3-.5-.3-.5 0-1 0-1l-.1.1c.4.1 1-.2 1.6-.5.3-.2.7-.3 1.1-.5 1.2-.5 1.9-1.7 1.9-1.9 0-.1 0-.1-.1-.1s-.2 0-.5.2-.7.6-1.3.9c-1.1.5-2.4.6-2.7.5-.2-.1-.2-.3-.1-.7 0-.1 0-.2.1-.3.1-.3.4-.8.8-1.2.2-.2.3-.4.5-.6.3-.4.3-.9.3-1.3v-.5c.1-.4.7-.8 1.1-1.2.3-.2.4-.3.5-.4.1-.2 0-.4-.1-.5-.1-.2-.4-.4-.6-.4-.3 0-1.2.8-1.4 1h.1s-.8-.3-1.2-.2c-.5.2-4.5 3.4-4.7 4.7-.2 1 .6 2.1 1 2.5.1.1.1.2.1.2v.3c0 1.3-.1 5.4 1.8 5.7 2.1.4 5.2.1 5.2.1h.1v-.1l1.3-4.3.1-.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M288.1 228.2s4 2.4 4.4 2c.4-.4-1-6-.8-6.6.2-.5 3.2 6.3 1.7 7.3-1.1.7-1.7.2-1.7.2l-1.9-1-1.7-1.9zM299.1 238.2s.4.3.9.4c.2 0 .6.2.5.2-.1 0-1.1.1-1.1.2-.1 0-.3-.8-.3-.8M295.3 225.1l.6.3c.2.1.5.2.5.3 0 0-.3.2-.5.1-.2 0-.3-.1-.3-.1l-.3-.6zM294.1 223.1s.4.2.9-.2.6-.6.5-.8c0-.2-.9-.2-1.1-.4-.3-.2-.3-.5-.3-.5h-.9l-.3.1 1.2 1.8zM297.6 234.6s1.2.7 1.6.8c.3.1.9.4.8.5-.1.1-1 .2-1.4-.1-.4-.3-.6-.1-.6-.1l-.4-1.1zM291.1 216.6c.1 0 .3.1.5.1s.4-.2.5-.1c.2.2 0 1-.3 1.3-.3.2-.7.4-.8.4-.1 0-1.3-1.8-1.3-1.8l1.4.1zM285.4 211.5h1.2c.4 0 .9.3 1.2.5.4.2.7 2.6.5 3.1-.2.5-2.9-1.6-2.9-1.7-.1-.2-1.2-2-1.2-2l1.2.1zM282.9 210.4s1.9.1 1.8-1.1c-.2-1.2-1.1-1.8-1.1-1.8l-2.3 1.7 1.6 1.2zM277.7 208.1s.5.3 1.1.1c.6-.2 2.1-2.2 3.2-2.5 1.1-.2 1.3-.2 1.5 0 .2.3.1 1.4-.1 1.7-.3.3-3.5 1.7-3.5 1.7s-.7 0-1.2-.2c-.5-.1-1.1-.3-1.1-.3l.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M277.1 204.6c-.5-1.2-1.4-1.6-1.7-1.5-.3.1 1.1 1.2 1.3 2.8.2 1.6.2 2.6.2 2.7 0 .1.7.1.7.1l.1-.6.1-.4v-.4l-.1-.8-.2-.6-.1-.5c0-.1-.1-.3-.3-.8M272.5 202.9c-1.5-1.7-4.2-3-4.4-3s3.1 2 3.9 3.3c.8 1.3.8 3 1.1 3.3.3.2.6-.1.7-.2 0 0 .3-.4.2-.5 0-.1-.2-.8-.2-.8l-.5-.9-.3-.5-.5-.7zM268.1 201.1c-1.9-1.7-5.3-2.5-8.1-2.5s-4.2.2-3.8 1.7c.4 1.5 1.6 2.2 4 2.2 2.3 0 2.9-.3 4.2.1 1.3.4 2.4 1.1 2.9 1.6s-.9-1.2-2.1-2.1c-1.2-.9-2-1.4-2-1.4s-.2-.5 1.4-.3c1.6.2 3.8 1.3 4.4 2.6.6 1.3.5 2.1.5 2.4 0 .3.6-.2.6-.2l.2-.7s.1-.5-.2-1.1c-.3-.6-.4-.8-1.1-1.6-.8-.7-.9-.7-.9-.7M260.4 223.9c1.2 0 3.8-2.3 4.2-5.4.4-3.1-1.6-9.5-2-10.2-.5-.7.7-.3 1.4.4.6.7 2 5.2 2 8.5s-.7 4.3-2.4 5.9c-1.8 1.7-3.2 1.5-3.2 1.5v-.7zM264.5 233.2s.6.7 1.3.5c1.2-.5 3.1-1.3 3.1-3.1 0-1.1-1.5-2.1-1.5-2.5-.1-.4 0-.8 0-.8l1.3.3.4 1.8s.5.5 1 .3 2-1.3 1.8-2.4c-.2-1.1-1.6-2.4-1.8-2.9-.1-.5 0-1 0-1l1.2.2.4 1.5s.3.5 1 .4c.7-.1 1.9-1.4 1.6-2-.3-.6-1.2-2-1.3-2.1-.1-.1 0-.7 0-.7l.5.3s.5.2 1.4-.1c.9-.3 1.8-.9 1.8-1.6 0-.6-.7-1.3-.8-1.6v-.5l.6.1.8.9.2 1.1-.3 1-1.1 1.2-1.1.5h-.3l.7 1.2-.2 1.6-1 .9-1.3.8-.1 1.5-.7 1.6-1.7 1h-.5l-.2 1-1.1 1.5-1.9 1.2-1.4.3-.8-1.1v-.3zM274.7 216.3s3.1.9 3-1.1c-.1-1.1-3-3.7-3.2-4.1-.2-.4-.1-1-.1-1l1.6 1.4s2 .5 2.5-.7c.6-1.1.1-1.9 0-1.9s.5-.1.5-.1l.9.2-.1 1.8-1 4.4s.3 1.7-1.1 1.9c-1.4.2-3-.8-3-.8M277.7 239.9s.1-.9-.6-1.5-2-1.2-2.2-1.3c-.2-.1 2.2 2.8 2.2 2.8h.6zM282.2 240s-1.6-1.9-1.9-2.6c-.3-.7-1.1-2.1-1.8-2.2-.6-.1.6 2.4.6 2.4l2.5 2.3.6.1zM286.5 240s-1.3-2.5-1.7-3.3c-.3-.7-1-2.8-1.8-3.3-.8-.6.1.9.1.9l.8 2.6 1.5 2.3 1.1.8zM289.6 238.1s-.1-2.2-.3-3.7c-.3-1.5-1.4-2.8-1.5-2.7-.1.1.1 2.7.1 2.7l1.7 3.7zM296.1 239.8s-1.1-2.6-1.5-3.8c-.4-1.2-1.5-3.3-1.7-3.3-.1 0 .3 2.4.3 2.4l1.3 3.8 1.6.9zM301.7 233s-1-1-3.2-1.9c-2.2-.8-4.3-.9-4.3-.9l.3.3 1 .8 2.2 1.2 2.9.7 1.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M278.6 234.3s0 1.9 1 3 3.3 3.2 3.7 3.7c.5.4.8 2.7 1.5 4.7.7 1.9.8 3.5 1.1 4.1.3.5.9 1.4.5 1.3-.5-.1-.9-.6-1.2-1.3-.3-.7-.2-.7-.1-1.7 0-1-1.5-5.9-2.2-6.5-.7-.5-3.9-3.2-5.1-5-1.2-1.8-1-2.2-1-2.2l1.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M283.7 246.6c-.7-1.4-.8-2.6-1-3.5-.2-.8-2.9-3.1-3.5-3.4-.5-.2-1.5.1-1.9-.2-.4-.3-2.9-3.2-2.9-3.2s-.4.3-.3.5c.1.1 2.8 3 3.7 3.9.9.9 1.5 3 2.2 4.5.7 1.6.4 1.3.5 2 .1.8.6 1.2 1 1.2.5 0 .6-.2.4-.4-.2-.1-1.2-1.3-1.7-2.8-.5-1.4-1.2-3.9-2-4.8l-.2-.2c.2 0 .5-.1 1-.1.6 0 3.3 2.4 3.5 3.1.2.7 0 1 1.1 3.4s1.6 3 1.6 3h.2c0 .1-1-1.6-1.7-3M279.6 230.7s1.9 1.2 2.5 1.4c.6.2 1 .2 1 .2s.3 3.5 1.7 5.5 2.5 2.7 2.5 2.7 0 3.8 1.1 6.5c1 2.6 1.3 5.8 1 6.3-.2.5-1.1-1.6-1.7-3.4-.6-1.8-1.1-3.8-1.5-5-.4-1.2-1.5-3-2-3.5-.6-.5-.1-.4.2-.1.3.3 1.4 1.6 2 3.6.6 2 .9 4.1 1.3 4.1.3 0 .6-.3.6-.7 0-.4-.5-1.5-.8-3.3-.3-1.9-.6-3.2-1-3.7-.3-.5-.8-.6-2-2.7s-1.7-3.3-1.9-4.2c-.2-1 0-.9-.2-1-.2-.1-.4 0-1.3-.5-.9-.9-1.5-2.2-1.5-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M284.5 230s1.2.9 1.8 1.2c.7.3 1.6.3 1.6.3s-.2 3.3 1.1 5.5 2.6 3.4 2.6 3.4.2.8.6 5.4c.4 4.6.4 4.7.6 6.6.1 1.9.2 8.5-.1 8.3-1-.8-.2-4.4-.7-5.8-.5-1.5-1.3-1.7-2.3-5.9-1-4.2-.3-5.1-1-6.7-.7-1.6-1.6-1.7-1.6-1.7s1.3.2 1.8 1.6c.5 1.3.6 4.8 1.1 6.6 1 3.9 2.3 5.9 2.3 5.9s-.3-4.9-.7-7.7c-.4-2.8-.4-5.1-.9-6.2-.5-1.1-1.6-1.9-2.3-3.4-.7-1.4-.9-4.2-1.3-4.9-.3-.7-.5-.5-1-.7-1.3-.7-1.6-1.8-1.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M288.1 228.2s1 1.2 2.5 2c1.5.9 2.2.6 2.4.8.2.2-.3 3.1 1.2 5.9 1.5 2.7 2.1 2.8 2.1 3.1 0 .4.3 8.4.5 11.1.2 2.7.4 11.9-.7 11.9s-.1-6.7-.7-8.3c-.6-1.6-.5-1.1-1.1-2.4-.5-1.3-.5-6.3-1.4-9.2-.6-2.2-1.3-2.6-1.3-2.6s1.1.6 1.6 2.4c.5 1.8.7 8 1.3 8.9.6 1 1.4 2.2 1.6 3.1.2.9-.1-11.7-.4-12.4-.3-.8-2.8-5.3-3-7.8-.2-2.5-.3-2.8-.5-3-.2-.2-.9 0-2.1-1.2-1.2-1.1-2-2.3-2-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M293.8 229.6c.1-.2.8 1.3 3.1 2.2 2.3.9 4.4.7 4.7 1 .3.2 1.7 3.6 1.8 8.2 0 4.5-.8 4.1-1.5 8-.7 3.9-.7 11.8-1.2 13-.2.4-.4.6-.7 1.4-.2.8.2 2.2-.5 2.2s-.8-1.1-.8-1.7c0-.6.7-2.8.7-4.9 0-2.2-.5-2.4-.8-5-.3-2.6-.3-10.8-.6-11.6-.3-.8-1.7-2.5-1.7-2.5s1.5 1 1.9 2.1c.4 1.1.4 10.2.8 12.1.4 1.9.3-.4.4-1.5s.7-5.5.6-7.9c-.1-2.4-1.1-7.6-1.9-8.5 0 0 .4.5.9 1.6 0 0 .3.3.6.5.4.2.8.3.8.3s-.5 0-.8-.2c-.3-.1-.5-.3-.5-.3.5 1.4 1 3.5 1.1 6.5.1 4.1-.6 13.1 0 13.2.6.1.5-4.9 1.2-9s1.6-4.6 1.3-8c-.3-3.3-1.2-6.9-1.9-7.3-.7-.4-2.7-.3-4.5-1.4-1.6-1.1-2.6-2.2-2.5-2.5M265.2 234.2s.6.3 1.4-.1c.8-.4 2.8-1.9 2.8-2.6v-1.3s0 .3.6.4c.6.1 2.2-1.2 2.3-2 .1-.8.1-2.2-.1-2.5-.2-.3.5.3.8 0 .3-.3 1.9-1.3 1.9-2.4 0-1.1-.9-2-.9-2s.8.1 1.2 0c.5-.1 2-1 2-2-.1-.9-.6-2.4-1.8-2.5 0 0 .9.2 1.8-.1.9-.3 1.2-.8 1.2-1.8s-1.8-3.2-2.1-3.3c-.3-.2 1.9.6 2.5-.3.6-.9.6-1.5.5-2-.2-.5-.6-.6-.6-.6s1 .3 2.3-.4c1.3-.7 2.4-1.5 3-1.5.6 0-1.9 1.3-2 2.1 0 .3.7.8 1.8 1.7.1 0 .1.1.2.2.5.3 2.5.4 2.6.5.2.1-1.9.1-1.7.2 1.4 1 3 2.5 4.6 4.3.1.1.4.3.7.5.5.1 1 .1 1 .2s-1.3 0-1.3 0c1 1.3 1.9 2.6 2.6 3.8.1.1.4.5.7.6.4.2.9.1.9.2.1.2-1.1 0-1 .2 1.5 2.5 2.6 4.8 2.6 4.8s-2.4-4.3-5.4-7.6c-3-3.3-3.7-3.8-3.8-3.5-.2.3 2.2 3.3 3.5 5.3 1.3 2.1 2.4 4.7 2.4 4.7s-3-6.2-7.2-10-4.7-4.5-5.1-4.3c-.5.2-.8 3-.5 3.6.3.6 3.4 2.9 6 6s5.9 8.4 5.9 8.4-2.4-3.8-6.4-8.1c-4-4.2-5.5-5.2-5.8-5.2s-.3.8-.8 1.4c-.5.6-1.4.6-1.5.8 0 .3 3.4 3.4 4.1 3.8.7.4 1 .2 1.6.5.5.3 1.1.8 1.1.8s-.7-.3-1.2-.4c-.5-.2-1-.2-1 0s2.8 3.5 3.2 3.7c.5.2.7.1 1.4.3.6.2 1.5.9 1.5.9s-1-.6-1.6-.7c-.7-.1-1 0-.9.2 0 .2 2.1 2.8 2 2.9-.1.1-3.2-3.7-5.9-6-2.6-2.4-3.8-2.8-4-2.8-.1.1 0 .8-.7 1-.6.2-1.2.3-1.2.6 0 .2 2.4 2.5 4.1 4.3s3.1 3.6 3.1 3.6-1.7-1.7-3.6-3.5c-1.9-1.8-2.8-2.4-3-2.3-.2.1-.2 1 0 1.2.2.2 3.6 4.3 3.5 4.4-.1.1-4.1-4.9-4.3-4.9-.3 0-.4.6-.7.9-.3.3-1.4.3-1.4.7 0 .4 5.6 5.9 5.4 6 0 0-4.6-4-4.8-3.8-.2.2 1.9 4.1 1.8 4.2-.1.1-2.7-4-3-4s-.2.5-.9 1.1c-.7.6-1.5.3-1.6.6 0 .3 3.9 4.6 3.8 4.7-.1.1-3.9-4.1-4.1-3.9 0 .1-.2.2-.1.6.3 1 1.2 2.8 1 3 0 0-1.3-2.5-1.6-2.5-.3.1-.3.6-.9 1-.6.4-1 .3-1.1.5-.1.3.7.7 1 1.3.3.6.6 1.9.6 1.9s-.4-1.1-.9-1.8c-.6-.7-1-1.2-1.5-1.2-.4 0-.7.4-.7.4l-.3-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M301.6 232.8s1.3-.1 1.4-.3c.2-.3-.5-.1-1.6-1.3s-4.1-9.7-7.2-13.9c-5.2-7-10.1-10.1-10.1-10.1s5.8 3.4 10.3 9.9c4.6 6.7 5.7 11.9 7 13.3 1.3 1.4 2.5 1.6 2.5 2-.1.4-.3.7-.8.7-.5.1-1.7.2-1.7.2l.2-.5zM263.2 231s0 .1.3.1c.2 0 1.8-1.5 1.7-2 0 0-.7-.3-1.3-.8-.6-.6-.7-1.5-.7-1.5s.5 1 1 1.3c.4.3 1.1.4 1.4.2.3-.2 2.6-1.9 2.4-2.6 0 0-.7 0-1.4-.5s-.8-1.5-.8-1.5.4.8 1.1 1.2c.7.3 1.4.2 1.6 0 .2-.3 1.7-2.3 1.5-3 0 0-.8.1-1.5-.4s-1-1.7-1-1.7.5 1 1.4 1.2c.9.2 1.6-.4 1.7-1 .1-.6.6-3-.1-3.6 0 0-1.1.4-2-.1-.8-.4-1.1-1.5-1.1-1.5s.7.9 1.6 1.1c.9.1 1.3-.4 1.5-.7.2-.4.2-1.7-.1-2.4-.3-.7-.8-.7-1-1.8 0 0-.3.4-1.5.4s-1.8-1.3-1.8-1.3.9.9 1.9.8c.9-.1 1.3-.8 1.3-1.4 0-.6-.5-1.1-.7-1.7-.3-.6-.3-1.4-.4-1.3-.2.1-.4.6-1.6.5-1.2-.2-1.5-1-1.5-1s.9.6 1.6.6c.7-.1 1.1-.4 1.1-.8s-.3-1.3-1.8-2.6-2.8-2.2-2.8-2.2 2 1.1 3.3 2.2c1.3 1.1 2 2.1 2 2.1s1.4.5 1.6 0c.2-.5.1-1.1-.3-1.9-.4-.8-1.6-2-1.6-2s1.3 1 1.9 2.1c.6 1.1.3 1.8.4 2.1.1.3 2.7 1.3 3.3.9.6-.4.3-1.1-.2-1.9-.5-.8-.9-1.4-.9-1.4s.6.7 1 1.4c.4.8.8 1.4.6 1.7-.2.4-.5.5-.5.7 0 .1.9.6 1.8 1.1.9.5 1.9.9 2 .6.1-.3.2-.9.1-1.7-.1-.9-.6-2.2-.6-2.2s.6 1.3.7 2.2c.1.9-.1 1.6.1 1.9.2.3.9.4.9.4s-.5.4-1.7 0c-1.2-.3-6.1-2.8-6.3-2.6-.2.2 2.3 1.8 3.5 2.9 1.2 1.1 1.7 2.3 1.7 2.3s-.9-.8-1.8-1.3-3.5-1.8-3.7-1.7c-.2.2 1 .4 1.1.6.1.2-.8 1-.8 1.4 0 .3 3.8 3 3.7 3.3-.1.3-1 1-1.1.9-.2 0-2-1.5-2-1.3 0 .2 1.1 1.1 1.1 1.3 0 .2-.7.7-.6 1.1.1.5 2.1 2.1 2.1 2.6 0 .6-1.1 1-.9 1.4.2.4 1.2 1.6 1.2 1.6s-1.1-.7-1.4-1.1c-.4-.4-1.1-1.2-1.2-1.1-.1.1-.8 1.7-.8 2 .1.3.9.9 1.1 1.8.2.9-.1 1.9-.2 1.9s-1.3-1.6-1.6-1.6c-.3 0-.6.1-.8.5-.2.4-.9 1.7-.8 1.9.1.2 1.3.5 1.3 1.5s-.8 1.9-.8 1.9c-.1 0-1.5-1.9-1.7-1.9-.1 0-1.8 1.8-1.8 2 0 .2 1.1 1 .9 1.4-.2.3-1-.1-1.4.1-.4.3-1.2.6-1.4.6-.3-.2-.5-.7-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M284 207.2s.1-.5.4-.8c.2-.3 1.3-1.4.9-1.6-.4-.2-1.6.2-2.5.1-.8-.1-1.3.1-3.7-1.8 0 0-7.4-5.2-18.9-5.8-3.6-.2-5.3 1.1-5.4 1.8 0 .2 1-1.5 4.6-1.4 1.6 0 13.2.9 19.2 5.7.3.2 2.3 2.1 4.2 1.9 1.9-.2 2.2-.4 2.2-.2 0 .3-.6.9-.7 1.3-.3.2-.4.8-.3.8zM264 208.7c-.1-.4-.9-1.4-2.1-2.6-1.5-1.4-6.2-3.3-6.4-3.4-.2-.1 4.8 2.3 6.2 3.7 2.2 2.1 2.3 2.3 2.3 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M264 216.9s-.3-.5-1.3-1.1c-1-.6-2-.9-2-.9s1.6 0 2.3.6c.6.6 1 1.4 1 1.4M263.4 212.6s-.3-.5-1.7-.9-1.7-.4-1.7-.4 1.3-.6 2.3-.1c.9.6 1.1 1.4 1.1 1.4M262.5 209.1s-.3-.6-1.5-1.1c-1.2-.4-2.1-.5-2.1-.5s1.3-.4 2.5.1c1.3.5 1.1 1.5 1.1 1.5M261 206.9s-.4-.5-2.7-1.1c-2.3-.6-3.2-.6-3.2-.6s3.3-.3 4.2.1c.9.4 1.7 1.6 1.7 1.6M256.7 204.4s-1.4-.4-2.8-.5c-1.4-.1-3.5.1-3.5.1s4-.6 5.1-.4c1 .2 1.2.8 1.2.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.6 253.9s.7 1.3 2.1 1.3c1.4 0 2.5 2 2.5 2l-1.6 1.5-3.7.2-1.2-1.9 1.9-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.6 253.9c-.1.1.1.4.5.7.4.3.9.7 1.6.7.6 0 1.3.5 1.7 1 .2.3.4.5.5.7.1.1.1.2.1.2v.1l.1-.1-.1-.1-1.5 1.5-3.6.2-1.1-1.8 1.8-3.1-2 3.1 1.3 2 3.8-.2 1.6-1.6v-.1s-.3-.5-.7-1c-.5-.5-1.1-1.1-1.8-1.1s-1.2-.3-1.5-.6c-.2-.1-.3-.3-.4-.4l-.1-.1h-.2v-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.7 252.6c.1-.2-1.1-2.6-2-3-.9-.4.3.8.1 1.3-.2.5-.3 1.1-.3 1.2.1.1.7 1.1.4 1.6-.3.3 1.8-1.1 1.8-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.7 252.6h.1c0-.1-.1-.4-.2-.6-.2-.4-.5-.9-.8-1.4-.3-.5-.7-.9-1-1-.1-.1-.2-.1-.3-.1h-.1v.1c0 .1 0 .2.1.3.1.1.2.3.2.5.1.2.1.3.1.4v.1c-.2.4-.3.9-.3 1.1v.2s.1.2.3.4c.1.2.2.5.2.7 0 .1 0 .2-.1.3V253.9H242.2c.2-.1.6-.4 1-.6.2-.4.5-.6.5-.7-.1-.1-.4.2-.9.4-.2.1-.4.3-.6.4-.1 0-.2.1-.2.1h-.1v.1-.1.1-.1.1h.1v-.1.1h.1-.1.1-.1.1c.1-.1.1-.3.1-.4 0-.3-.1-.6-.2-.8-.1-.2-.2-.4-.3-.5 0-.2.1-.6.3-1v-.2c0-.2-.1-.5-.2-.7 0-.1-.1-.2-.1-.3 0-.1-.1-.2-.1-.2h-.1v.1h-.1v.1s.1 0 .2.1c.4.2.9.8 1.3 1.4.2.3.4.6.5.9.1.2.2.4.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243 256.3s.6.3 1.2.2c.5-.2 1-.7 1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243 256.4s.4.2.9.2h.3c.6-.2 1-.7 1-.7l-.2-.1c-.1.1-.5.5-.9.6h-.3c-.2 0-.4 0-.6-.1-.1 0-.1 0-.2-.1h-.1l.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.3 255.3s2.1-1.5 1.9-2.3c-.2-.8-.6-.8-.9-.7-.3.1-1.6 1.1-1.6 1.4 0 .2.6 1.6.6 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.3 255.3c.1.1.5-.3 1-.7l.7-.7c.2-.3.3-.5.3-.8v-.1c-.1-.3-.2-.5-.3-.6-.1-.1-.3-.2-.4-.2h-.3c-.1 0-.2.1-.4.2-.2.2-.5.4-.8.6l-.3.3c-.1.1-.1.2-.2.3v.1c0 .1 0 .3.1.4.2.6.5 1.3.6 1.2v.2-.2c.1 0 0-.4-.2-.7-.1-.2-.1-.4-.2-.5-.1-.2-.1-.3-.1-.4l.1-.1c.1-.2.5-.5.8-.7.2-.1.3-.2.4-.3.1-.1.2-.1.3-.2h.2c.1 0 .2 0 .3.1.1.1.2.3.2.5v.1c0 .2-.1.4-.3.6-.3.4-.7.7-1 1-.2.1-.3.3-.4.3-.1.2-.1.3-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.9 256.4s.4 1 1 1c.7 0 1.6-.6 1.7-.9 0-.4-.7-1.1-1.1-1.4-.4-.2-1.5.3-1.5.3l-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.9 256.4c-.1 0 0 .3.2.6s.5.5.9.5.8-.1 1.1-.3c.2-.1.3-.2.4-.3.1-.1.2-.2.2-.4 0-.3-.2-.6-.4-.8-.2-.3-.5-.5-.8-.6h-.3c-.3 0-.6.1-.8.2-.3.1-.4.2-.4.2l-.1 1v-.1l.2-.9h-.1v.1l.1-.1c.2-.1.7-.3 1.1-.3h.2c.2.1.5.3.7.6.2.2.4.5.4.7 0 .1 0 .2-.1.3-.3.3-.9.6-1.4.6-.3 0-.5-.2-.7-.5-.1-.1-.1-.2-.2-.3v-.1l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.8 255c-.1.3-1.4.9-1.9 1-.4 0-1.3-1.1-.9-1.2.4-.2.8-.1 1.1-.3.3-.2.4-.6.6-.6.2 0 .7.1.9.5.1.2.3.3.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.8 255h-.1l-.2.2c-.2.1-.5.3-.8.4-.3.1-.6.2-.7.2-.1 0-.2 0-.3-.1l-.4-.4c-.1-.2-.2-.3-.2-.4.3-.2.8-.1 1.1-.3.2-.1.3-.3.4-.4 0-.1.1-.1.1-.2h.1c.1 0 .3 0 .4.1.2.1.3.2.3.3 0 .1.1.2.2.3 0 .1.1.1.1.2v.2-.1c.1 0 .1-.1.1-.2s0-.2-.1-.3c0-.1-.1-.2-.1-.3-.1-.2-.3-.3-.4-.4-.2-.1-.4-.1-.5-.1-.1 0-.2.1-.2.1-.1.2-.3.4-.5.5-.3.2-.7.1-1.1.3-.1 0-.2.1-.2.2s.1.2.1.4c.1.2.3.4.4.5.2.2.4.3.6.3.3 0 .7-.2 1.1-.4.2-.1.4-.2.5-.3.2 0 .3-.1.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.4 255.9s-2 2.8-2.9 2.6c-.9-.1.3-3.9.3-3.9s.3.2 1 .4 1.4.5 1.6.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.4 255.9c-.1-.1-.2.1-.4.3-.3.4-.7.9-1.2 1.4-.2.2-.5.4-.7.6-.2.1-.4.2-.5.2-.1 0-.1-.1-.2-.2 0-.1-.1-.3-.1-.5 0-.6.2-1.3.3-2 .1-.3.2-.6.2-.8.1-.2.1-.3.1-.3h-.1l-.1.1s.3.2 1 .4c.3.1.7.2.9.3.4.2.6.4.8.5 0-.3-.3-.5-.5-.6-.3-.1-.6-.3-1-.4-.3-.1-.6-.2-.7-.3-.1 0-.1-.1-.2-.1l-.1-.1v.1s-.6 2.1-.6 3.2c0 .2 0 .4.1.5.1.1.2.3.3.3h.1c.3 0 .6-.2.9-.4.7-.7 1.8-2.1 1.7-2.2h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.8 253.9s2.6.5 2.8.9c.1.4-1.3 1-2 1-.8 0-.8-1.9-.8-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.8 253.9v.1s.2 0 .4.1c.4.1.9.2 1.4.3.2.1.4.1.6.2.1 0 .1.1.2.1l.1.1s0 .1-.2.2c-.4.3-1.2.6-1.7.6-.1 0-.2-.1-.3-.2-.1-.2-.2-.6-.3-.9v-.4c-.1-.1-.1-.2-.2-.2v.1-.1h-.1s0 .5.1.9c0 .2.1.5.2.7.1.2.3.3.5.3.4 0 .9-.1 1.3-.3l.6-.3c.1-.1.3-.2.3-.4v-.1c0-.1-.1-.2-.2-.2-.3-.2-1-.4-1.6-.5-.6-.1-1.1-.2-1.1-.2h-.1v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262725",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.2 257.9s.3 1.3 1.5 1.3c1.1.1 2.2-1.2 2.2-1.2l-2.7-1-1 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.2 257.9c-.1 0 0 .3.3.7.2.3.6.7 1.2.7h.1c1.2 0 2.2-1.2 2.2-1.2l.1-.1-2.8-1.1-1.1 1 1-.8 2.7 1v-.1l-.2.2c-.3.3-1.1 1-1.9 1h-.1c-.6 0-.9-.3-1.1-.7-.1-.2-.2-.3-.2-.4l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262725",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232 257.6s.4.9 1.9 1c1.5 0 2.7-1.2 2.7-1.2l-2.4-1.9-2.2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232 257.6s.4 1 1.9 1h.1c1.5 0 2.6-1.2 2.6-1.2l.1-.1-2.5-1.9-2.2 2.2 2.2-2 2.3 1.8c-.2.2-1.3 1.1-2.5 1.1h-.1c-.7 0-1.2-.3-1.5-.5l-.3-.3c0-.1 0-.1-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.2 257.8s.7.5 1.4.6c.8 0 1.7-.2 1.7-.2l-.9.3-.6.1-.6-.1-.6-.2-.4-.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262725",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.9 256.5s.7 1.6 2 1.4c1.4-.2 1.4-1 1.4-1l-1.6-2.2-1.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.9 256.5c-.1 0 .1.4.4.8.3.4.8.7 1.4.7h.2c.7-.1 1.1-.3 1.3-.6.2-.2.2-.5.2-.5l-1.6-2.3-1.9 1.9 1.9-1.7 1.5 2.2h-.1c0 .1-.2.7-1.4.9h-.2c-.6 0-1-.3-1.3-.7-.2-.2-.3-.4-.3-.5.1-.1 0-.2-.1-.2.1 0 .1-.1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234.1 256.8s.8 1 1.6 1c.7 0 1.2-.3 1.2-.3v.1l-.4.2-.6.1-.7-.1-.6-.3-.5-.7zM231.5 258.4s.6.7 1.2.7 1.5-.5 1.5-.5h.1l-.2.1-.6.3-.7.2-.6-.1-.4-.3-.3-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.6 253.8c.6-.1 1.9 1.7 1.9 2.6 0 .9-.4 2.2-1 2.2s-2.1-1.3-2.4-2c-.3-.7-.6-1.1-.4-1.5.2-.4 1.9-1.3 1.9-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.6 253.8v.1c.1 0 .3.1.5.3.3.3.6.6.9 1.1.2.4.4.9.4 1.1 0 .4-.1.9-.3 1.4-.1.2-.2.4-.3.5-.1.1-.2.2-.3.2-.1 0-.3-.1-.6-.2-.7-.4-1.6-1.3-1.8-1.7-.3-.5-.5-.9-.5-1.2 0-.1 0-.1.1-.2 0-.1.2-.2.4-.3.3-.2.7-.4 1-.6.3-.3.6-.4.5-.5v.1-.1c0-.1-.5.1-.9.4-.2.1-.5.3-.7.4-.2.1-.4.3-.4.4-.1.1-.1.2-.1.3 0 .4.3.7.5 1.3.2.4.6.8 1.1 1.3.2.2.5.4.7.5.2.1.5.2.6.3.2 0 .4-.1.5-.3.4-.4.6-1.3.6-2 0-.5-.3-1.1-.7-1.7-.2-.3-.4-.5-.6-.7-.2-.2-.4-.3-.6-.3v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.2 253.9s-1-.8-1.5-.4c-.4.4-.3 1.8 0 2.1.3.3 1.5-.7 1.5-.7v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.2 253.9c.1-.1-.1-.2-.3-.3-.2-.1-.5-.3-.8-.3-.1 0-.3 0-.4.2-.2.2-.3.6-.3 1.1 0 .2 0 .5.1.7 0 .2.1.4.2.5.1.1.1.1.2.1s.3-.1.4-.1c.5-.2 1-.6 1-.6h.1l-.2-1.3h-.1l.1 1.1h.1l-.1-.1-.1.1c-.1.1-.4.3-.6.4-.2.1-.5.2-.6.2h-.1l-.2-.4c0-.2-.1-.4-.1-.7 0-.4.1-.8.2-.9.1-.1.1-.1.3-.1.2 0 .5.1.7.2.1.1.2.1.3.2 0 .1.1.1.2 0h-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231 254.9s-1.4.1-1.4.8c0 .6.7 1.3.8 1.4.1.1 1.4-.6 1.4-.6l-.8-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231 254.9c0-.1-.4-.1-.7 0-.2.1-.4.1-.5.3-.1.1-.3.3-.3.5 0 .3.2.7.4 1 .2.3.4.5.5.6h.1c.1 0 .2 0 .4-.1l1-.5h.1l-.9-1.8h-.1l.7 1.7h.1l-.1-.1s-.3.1-.5.3c-.1.1-.3.1-.4.2-.1.1-.3.1-.3.1-.1-.1-.3-.3-.4-.5-.2-.3-.3-.6-.3-.8 0-.1.1-.2.2-.3.2-.1.5-.2.7-.3.1 0 .2 0 .3-.1h.1l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.6 256.1s-1.4.4-1.4.9.6 1.4 1.1 1.4c.4 0 .8-.9 1-1 .1-.2-.7-1.3-.7-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.6 256.1v-.1s-.4.1-.7.3c-.2.1-.4.2-.5.3-.1.1-.3.3-.3.4 0 .3.2.6.4.9.1.1.2.3.4.4.1.1.3.2.4.2.1 0 .3-.1.4-.2.2-.1.3-.3.4-.5.1-.2.2-.3.2-.4l.1-.1c0-.1 0-.2-.1-.4-.3-.4-.6-.9-.7-.8v-.1h-.1l.1.1c-.1.1 0 .1 0 .2.1.1.2.3.3.5 0 .1.1.2.1.3 0 .1.1.1.1.2-.1.1-.1.1-.2.3-.1.2-.2.4-.3.5-.1.2-.3.3-.4.3-.1 0-.2 0-.3-.1-.2-.1-.3-.3-.5-.6-.1-.2-.2-.5-.2-.6 0-.1.1-.2.2-.3.2-.1.5-.3.7-.4.1 0 .2-.1.3-.1.2-.1.2-.1.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.3 252s-.3-.4-.9-.1c-.6.3-1.3.8-1.1 1.8.1.9.4 1.6.4 1.6l2.2-.7-.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.3 252c.1-.1-.1-.3-.5-.3-.1 0-.3 0-.4.1-.3.1-.6.3-.8.6-.2.3-.4.6-.4 1.1v.2c.1 1 .5 1.6.5 1.6v.1l2.3-.8-.7-2.6.5 2.4-2.1.7v.1l.1-.1c-.1-.1-.3-.7-.4-1.5v-.2c0-.4.1-.7.3-1 .2-.3.5-.4.7-.5.1 0 .2-.1.3-.1.1 0 .2 0 .3.1l.1.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.4 253.6s-1.8.6-1.9 1.3c-.1.7.4 1.4.9 1.6.5.1 2-1.4 2-1.4l-1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.4 253.6c0-.1-.5 0-1 .3-.2.1-.5.3-.7.4-.2.2-.3.3-.4.6v.1c0 .4.1.7.3 1 .2.3.4.5.7.6h.1c.2 0 .4-.1.6-.2.6-.4 1.5-1.2 1.5-1.2l.1-.1-1.1-1.6-.1.1 1 1.5.1-.1-.1-.1-.2.2c-.2.2-.5.5-.9.7-.2.1-.3.2-.5.3-.1.1-.3.1-.3.1-.2 0-.4-.2-.6-.5-.2-.2-.3-.5-.3-.8v-.1c0-.1.1-.3.3-.4.3-.2.6-.4 1-.6.2-.1.3-.1.4-.2.1.1.2.1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234 256.5s-1.8 1.2-2 1.2c-.2 0-.9-.9-.8-1.6.1-.6 1.3-1.1 1.8-1.3.5-.1 1 1.7 1 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234 256.5c-.1-.1-.5.2-1 .5-.2.1-.5.3-.7.4-.1 0-.2.1-.3.1h-.1s-.1-.1-.2-.1c-.2-.3-.5-.8-.5-1.1v-.2c0-.3.4-.5.7-.7.4-.2.8-.4 1-.4h.1c.2.1.3.5.5.9.1.2.1.3.2.5.2.1.2.2.3.1.1 0 0-.5-.2-.9l-.3-.6c-.1-.1-.1-.2-.2-.2s-.1-.1-.2-.1h-.1c-.2.1-.7.3-1.1.5-.4.2-.7.5-.8.9v.2c0 .3.2.7.3 1 .1.1.2.3.3.3.1.1.2.2.3.2.1 0 .1 0 .2-.1.3-.1.7-.4 1.1-.7.4-.1.8-.4.7-.5h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.6 250s-.6-.5-1.7-.4c-1.1.1-1.9 1.5-2 2.2-.1.7 0 2 .4 2.3.4.2 2.7-1.6 2.7-1.6l.6-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.6 250c.1-.1-.5-.5-1.4-.5h-.3c-.6 0-1.1.4-1.4.9-.4.5-.6 1-.7 1.4 0 .2-.1.4-.1.7 0 .3 0 .7.1 1 .1.3.2.6.4.7h.1c.2 0 .4-.1.7-.3.8-.5 1.9-1.4 1.9-1.4l.6-2.6.1.1-.7 2.5h.1l-.1-.1-.3.3c-.3.2-.8.6-1.2.9-.2.1-.4.3-.6.4-.2.1-.3.1-.4.1-.1 0-.2-.3-.3-.5-.1-.3-.1-.6-.1-1 0-.2 0-.5.1-.6.1-.3.3-.9.6-1.3s.8-.8 1.3-.8h.2c.4 0 .8.1 1 .2.1 0 .2.1.3.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.4 255.4c-.7-.1-1.4-1.2-1.3-1.8.1-.7 1.6-1.8 2.4-1.7.8.1.6 2.1.6 2.1s-1 1.5-1.7 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.4 255.4c-.3-.1-.6-.4-.8-.7-.2-.3-.4-.7-.4-1v-.2c0-.1.1-.3.3-.5.2-.3.6-.5.9-.8.3-.2.7-.3 1-.3h.1c.1 0 .2.1.3.2.2.3.3 1 .3 1.4v.4h.1-.1l-.2.2c-.1.2-.4.5-.6.7-.3.3-.6.5-.9.6v.1h.1c.4 0 .9-.4 1.2-.7.3-.3.6-.7.6-.7v-.4c0-.3 0-.7-.1-1.1 0-.2-.1-.3-.2-.5-.1-.1-.2-.2-.4-.3h-.2c-.4 0-1 .3-1.4.6l-.6.6c-.2.2-.3.4-.3.6v.2c0 .4.2.8.4 1.1.3.3.6.6 1 .6l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.8 255.2s-.4.9-1.1 1.3c-.8.4-1.2.1-1.7-.6-.4-.6.2-.9.6-1.2.3-.3 1.3-.6 1.3-.6l.9 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.8 255.2h-.1c-.1.2-.4.9-1.1 1.2-.2.1-.4.2-.6.2-.2 0-.3-.1-.5-.2s-.3-.3-.5-.5c-.1-.1-.1-.3-.1-.3 0-.1.1-.3.2-.4.1-.1.3-.2.4-.4.2-.1.5-.3.8-.4.1 0 .3-.1.4-.1h.2v-.1l-.1.1 1 .9-.9-1.2h-.1l-.6.2c-.3.1-.6.2-.8.4-.1.1-.3.2-.5.4-.1.1-.3.3-.3.5 0 .1.1.3.2.5.2.2.3.4.5.6.2.1.4.2.6.2.2 0 .4-.1.7-.2.9-.4 1.3-1.3 1.2-1.4h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234.6 252.9s-.9.7-.4 1.5.9 1.1 1.5 1.2c.6.1 1-.1 1.5-.7s1.2-.8 1.1-1.6c-.1-.7-.3-1.3-.8-1.5-.4-.2-1.7 0-2.9 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M234.6 252.9c-.1-.1-.6.3-.6 1 0 .2 0 .4.2.6.3.4.5.7.7.9.2.2.5.3.8.3h.3c.5 0 .9-.3 1.3-.8.2-.3.5-.5.7-.7.2-.2.4-.5.4-.9v-.1c-.1-.7-.3-1.3-.8-1.6-.1 0-.3-.1-.4-.1-.7.1-1.7.5-2.6 1.4 1-.8 2-1.1 2.5-1.1.2 0 .3 0 .3.1.4.2.6.7.7 1.4v.1c0 .3-.1.5-.4.7-.2.2-.5.4-.7.7-.4.5-.7.7-1.1.7h-.3c-.3-.1-.5-.1-.7-.3-.2-.2-.4-.4-.7-.8-.1-.2-.1-.3-.1-.5s.1-.5.2-.6l.2-.2.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262725",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237 249.5s-.9-.3-1.6.1c-.7.4-1.1 1.2-1.2 1.9 0 .7.1 1.8.1 1.8s.9-.3 1.5-.8.8-.6.7-.9c0-.2-.3-.3-.3-.9.2-1.1.8-1.2.8-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237 249.5s-1-.2-1.5.2c-.5.3-.9.8-1.1 1.5-.2.6-.1.8-.1.8s-.1-.6.1-1.1c.2-.6.7-1.3 1.2-1.4.6-.2 1.4 0 1.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M6 .4 5.9-4-6-.4-1.3 4z",
    transform: "matrix(1.9509 0 0 2.4519 514.062 507.85)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m247.6 251.9-1-.8s-.7-.5-1.1-.6c-.4-.1-.9 0-.9 0l-.2.2.2.4 1.1 1.3 1.8.9.6.6.4.2-.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M1.3 1.4-2.6.2l.3-.9.7-.6.6-.3.8-.1h.3l.7.1.6.7.5.9.5 1.1.2.6z",
    transform: "matrix(1.9509 0 0 2.4519 482.262 498.777)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.8 5.05h.6l.4-.4-.1-1.4.2-4.6-3.1-3.7-.7 2.1.9 3.7.7 2.3z",
    transform: "matrix(1.9509 0 0 2.4519 485.774 489.828)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M247.5 248.5s-.2.4.1 1.6c.3 1.2.7 3.9 1.8 5.8 1.1 1.8-1-1.5-1-1.5s-1.7-3.8-1.4-6.6c.2-2.8.5.7.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M249.8 250.8s-.7.9-.8 1.5c-.1.6.1 1.8.1 1.8s-.1-.8.6-1c.7-.2.6 1.9.6 2.1 0 .2.4-3.7.4-3.7l-.9-.7zM250.2 258.6s-1.7 0-3.5-.8-2.8-1.5-2.7-1.9c0-.4 3.2.1 3.7.2s1.9.8 1.9.8h.8l1.5-.7.2 1.6-1.9.8zM244.3 257.9s.9.6.4.9c-.4.3-1.5.3-1.9.2-.3-.1 3.4.8 3.4.8l.7-.6c0-.1-2.6-1.3-2.6-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.4 257c.1-.2.2.5 1.4.6 1.2.2 1.8-.2 1.8-.2l.5.3.6.1-.6.9-2.2-.6-1.2-.7-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.65-2.4.3 3.9.6.9.4-2-.1-2z",
    transform: "matrix(1.9509 0 0 2.4519 490.944 494.854)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m247.8 252.1-1-1.7-1.3-2.5.8-1.4 1 1.5s-.3 1-.1 1.9c.1.9.6 2.2.6 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.6 258.4s.4-.7 1.5-.8c1.1-.1 1.9.1 1.9.1l2.1 1.1.4.7-4.1-.5-1.8-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.2 251.2s.1 2.4.2 3.2c.1.8.5 1.5.5 1.8-.1.3-.2.5-.8.7-.5.2-1.6 0-1.6 0s1-.1 1.1-.3c0-.2-.3-1.1-.4-2-.1-.8 0-1.8-.2-1.8-.3 0-.6.4-.6.5 0 .1.3-3 .6-3.3.3-.4 1.2 1.2 1.2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.8 257.6s-.4-.4-.4-.6c0-.3.5 1.3 2.7 1.2 2.2-.1 2.1-.1 2.1-.1h1s-.2 1-.4 1.1c-.2.1-1.7 1.1-1.8 1.2l-.6.3v-.2h-.1l-.2-1.7-1.9-.7-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M247.8 252.1s-2.6-2.7-3.4-4.4c-.9-1.8-.3-4.2-.3-4.2l2.4 3.2s-.3.6-.2 1.6c0 .9 1.5 3.8 1.5 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.1 261.8c-.1-.2-.2-.8.3-1.4 1.5-1.9 5.4-3.3 5.4-3.3v2.3l-5 2.4h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.4 260c.2-.2 1.1-.8 1.1-1.1 0-.3-.6-.4-1.7-.6-1.1-.2-2-.7-2-.7s1.4 1.1 1.9 1.3c.5.2.5.4.4.6-.1.1.3.5.3.5M253 260.6s-.7-1.1-.9-1.7c-.2-.7-.2-1.7-.3-1.7 0 0-.5.3-.8.5-.3.1-1.5.5-1.5.6-.1 0 1.6 0 1.6.5 0 .6-2.4.8-2.4.9 0 0 1.9-.4 1.8 0-.1.5-.9.5-2 .9-1 .4-1.5.6-1.8.9-.4.2-.6.4-.6.4s.4.3 1.2.2c.7 0 2.3-.4 2.3-.4l3.1-1.2.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M253 260.6s-.9-.3-1.5-3.9-.4-4.5-.4-4.5l1.4 1 1.3 2.4-.8 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M253.5 254.6s-.7 2-.7 3.2c0 1.2-.1 1.9.2 2.8.3.8 1.5 1.8 1.5 1.8l.5-.5.2-1.6.1-2.7-1.8-3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M255.5 257.3s.3 5-.9 5.2c-.6.1-1.5-1.9-1.6-2 0-.1 1.1 1.8 1.5 1.7.8-.3.6-5.2.6-5.2l.4.3zM253 260.6s-.2-.1-.6-.7c0 0 0 .5-2.7 1.5-2.7.9-3.6.4-3.6.4s.9.7 3.6-.1c2.7-.8 2.5-1 2.8-1 .4-.1.5-.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M248 254.1s.4.4.9 1.3c.5 1 .8 1.7.8 1.7l.1-.1s-.3-.9-.8-1.7c-.4-.7-1.7-2.5-1.7-2.5l.7 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.4 260.4s.3-.9 0-1.1c-.3-.2-.5 0-2.4-.2-1.8-.2-3.4-.7-3.4-.7s1.3.8 2.4 1.1l2.8.7.4.1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.4 260.4s0-.2-.2-.5c-.2-.2-.6.1-2.8-.5-2.2-.6-2.8-1-2.8-1s.8.7 2.8 1.2c2 .5 3 .8 3 .8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M247.4 253.8s-1.7.1-2.2.5c-.5.4-1.3 1.6-1.3 1.6l1.1.1s-.1-1 .4-1.5 1.3-.6 2-.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M244.2 250.6s.7.9 1.4 1.2c.7.3 1.4.6 1.7.9.3.3.7 1.4.7 1.4s-2.4-1.1-2.9-1.6c-.4-.5-.9-1.9-.9-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.6 251.1s-.2-.4-.9-.7c-.7-.3-1.1-.3-1.3-.1-.2.1-.1.2-.1.2l.9 1.3.5-.1s-1.3-.8-1-1.1c.5-.5 1.9.5 1.9.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m4.05-6.3 6.4 8.9-11.7 3.1-6.2.6-3-2.2 1-3.4z",
    transform: "matrix(1.9509 0 0 2.4519 512.209 478.917)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263.1 268.7s.7-.3 1.2-.6 1.6-1 1.6-1l.4 1.8-1.4 1.1h-1.2l-.7-.5.1-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263.1 268.7c0 .1.8-.2 1.3-.5s1.6-1 1.6-1l-.1-.1h-.1l.3 1.8-1.3 1h-1.2l-.6-.5.1-.7h-.1l-.2.8v.1l.7.5H264.9l1.4-1.1v-.1l-.3-1.8-.1-.1h-.1l-.6.4c-.3.2-.7.5-1 .6l-.8.4c-.2.2-.4.2-.3.3h-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.1 268.9h.9c.9 0 .9-.3 1.1-.2.1.1.4 1 .4 1l-.3.6-1.2.7-1-.6-.1-1.4.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.1 268.9v.1H262.1c.4 0 .6-.1.7-.1.1 0 .1-.1.2-.1 0 0 .1.1.1.2.1.1.1.3.2.5 0 .2.1.3.1.3h.1-.1l-.3.5-1.2.6-.9-.5-.1-1.3h.2v-.2h-.3l-.1.1.1 1.4.1.1 1 .6h.1l1.2-.7.3-.6v-.1s-.1-.2-.1-.5c0-.1-.1-.3-.1-.3s0-.1-.1-.1l-.1-.1H262.8c-.1 0-.1.1-.3.1-.1 0-.3.1-.5.1h-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M270.8 268.3s-.3-.4-.7-.8c-.5-.4-1.7-1.5-1.7-1.5v3.9h1.8l.9-1.2-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M270.8 268.3c.1-.1-.2-.5-.7-.9-.2-.2-.7-.6-1-.9-.4-.3-.7-.6-.7-.6h-.1l-.1.1v4h2l.9-1.2v-.1l-.3-.4.1.3-.8 1.1h-1.7V266h-.1l-.1.1s1.3 1.1 1.7 1.5c.2.2.4.4.5.6 0 .1.1.1.1.2.2 0 .2 0 .3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.1 268.9s-.3-.4-1-.3c-.8.1-1.6.7-1.7 1.2-.1.5 0 2.1.4 2.4.4.3.9.4 1.8.2.8-.2 5.1-2.8 5.1-2.8s-.5.1-1.1.2c-.6.1-1.1-.1-1.1-.1s-.6.6-1.3.8c-.7.1-.8-.3-1-.6-.1-.4-.1-1-.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.1 268.9c.1-.1-.2-.4-.8-.4h-.2c-.4 0-.8.2-1.1.5-.3.2-.6.5-.6.9v.5c0 .3 0 .8.1 1.1.1.4.2.7.4.8.3.2.6.3 1.1.3.2 0 .5 0 .7-.1.2-.1.7-.3 1.2-.5 1.5-.8 3.9-2.3 3.9-2.3s.1-.1 0-.1l-.1-.1s-.5.1-1.1.2h-.3c-.2 0-.4 0-.5-.1H263.5c-.1.1-.6.6-1.2.7h-.2c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.4 0-.1-.1-.4-.1-.6-.1 0-.1-.2-.2-.2h-.1v.4c0 .2 0 .4.1.6.1.1.1.3.3.5.1.1.3.3.6.3h.2c.7-.1 1.3-.8 1.3-.8l-.1-.1v.1s.4.2.8.2h.4c.6-.1 1.1-.2 1.1-.2v-.2s-.3.2-.7.4c-.6.4-1.6.9-2.4 1.4-.4.2-.8.5-1.2.6-.3.2-.6.3-.7.3-.3.1-.5.1-.7.1-.4 0-.7-.1-1-.3-.1-.1-.2-.4-.3-.7-.1-.3-.1-.8-.1-1.1v-.5c0-.2.2-.5.5-.7.3-.2.7-.4 1-.4h.2c.3 0 .5.1.6.1.1 0 .1.1.1.1l.1-.1h-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262725",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M256.9 273.7s-.6-1.1.1-1.5c.8-.4 1.2 0 1.7 0s.3-1.2.2-1.4c-.1-.2-.3-.8-.5-.9-.2-.1-2.8.1-2.7 1.9 0 1.5 1.2 1.9 1.2 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263.9 270.3s-.6.2-.9.4c-.2.2-1.1.5-1.1.5l.3 1.3 1.8.5 1.1-.9v-1.3l-1.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263.9 270.3c0-.1-.2 0-.4 0-.2.1-.4.2-.5.3-.1.1-.4.2-.6.3l-.4.2-.1.1.3 1.3.1.1 1.8.5h.1l1.1-.9V270.8s0-.1-.1-.1l-1.3-.4v.1l1.3.4v1.2l-1.1.9-1.7-.4-.3-1.2h-.1v.1s.2-.1.5-.2c.2-.1.5-.2.6-.3.1-.1.3-.2.5-.3.2-.1.3-.1.3-.1v-.2.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m272.3 269.4-.6-.6c-.3-.4-.8-.5-.9-.4-.1.1-1 1.2-1 1.2l-.1.8 1 .5.7.1.9-.6v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M272.3 269.4c.1-.1 0-.1-.1-.3-.1-.1-.3-.3-.4-.5-.3-.3-.6-.4-.8-.4h-.2s-.1 0-.1.1c-.3.3-.9 1.1-.9 1.1v.1l-.1.8v.1l1 .5.7.1h.1l.9-.6v-.1l-.1-1v.1h-.1l.1 1-.8.5-.6-.1-.9-.5.1-.8h-.1l.1.1.4-.6c.1-.1.2-.3.3-.4l.1-.1c.1 0 .4.1.7.4.4.3.6.5.7.5h-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266.1 268.7s-.8.4-1.2.7c-.4.3-1 .7-1 .8 0 .1.9 1.1.9 1.1l.9.1 2-1.4-.1-1.3h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266.1 268.7c0-.1-.9.3-1.3.6-.2.2-.4.3-.6.5-.1.1-.2.1-.3.2l-.1.1v.2c0 .1.1.2.2.3.3.3.7.8.7.8h.1l.9.1h.1l2-1.4v-.1l-.1-1.3c0-.1 0-.1-.1-.1h-1.5v.2h1.4l.1 1.1-1.9 1.3-.9-.1v.1l.1-.1-.5-.5c-.1-.1-.2-.3-.3-.4l-.1-.1s0-.1.1-.1c.2-.2.6-.4.9-.7.2-.2.5-.3.7-.5.3.1.5 0 .4-.1v.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M273.7 270.4s-.1-.3-.5-.6c-.3-.3-.7-.5-.9-.4-.2 0-1 1.2-1 1.2l-.1.3.7.8 1.3.3.9-.9-.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M273.7 270.4c.1 0-.1-.4-.4-.7-.3-.3-.7-.4-.9-.4h-.1c-.1 0-.1 0-.2.1-.2.1-.4.4-.6.7-.2.3-.3.5-.3.5l-.1.3v.1l.7.8 1.3.3h.1l.9-.9v-.1l-.4-.7.3.7-.8.8-1.2-.3-.7-.8.1-.3h-.1l.1.1.4-.6c.1-.1.2-.3.3-.4l.1-.1c.2 0 .5.1.8.4.1.1.3.3.3.4l.1.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m270.4 271.8.9.2s0 .2.2.5c.3.2.3 0 .3 0s.1.9 1.1 1.6c0 0 1.1.4 1.7 0 .6-.3.5.1.5.1l1.6-2s0-.4-.4-.4c0 0 .3-1.2-.8-1.5-1-.3-1.9.1-1.9.1s-.8 1.5-1.3 1.3c-.1 0-.4-.2-.6-.4-.4-.5-.6-.7-.6-.7s-.3.1-.7-.2c-.4-.3-.7-.9-.7-.9s-.6-.1-.8-.3c-.2-.2-.4-.6-.4-.6l-1.5 1.1s0 .5-.9 1.1c-.9.6-1.4.6-1.4.6s-.2 1.3-1.2 1.1c-1-.2-1.6-1.3-1.6-1.3s-.7-.1-1.1.5c-.5.6-.7.8-.7 1.4 0 .6.4 1.4.7 1.7.3.3 1.3 1 2.4.5 1.1-.6.8-1.6.8-1.6s0 .1.7-.4 1.5-1.2 2-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m270.4 271.9.9.2v-.1h-.1c0 .1 0 .3.3.5.1.1.2.1.3.1.1 0 .1 0 .1-.1v-.1h-.2s.1.9 1.1 1.7c0 0 .6.2 1.1.2.2 0 .5 0 .7-.1.2-.1.3-.1.3-.1s0 .1.1.1h.1l1.6-2v-.1s0-.1-.1-.2-.2-.3-.4-.3v.1h.1v-.4c0-.2 0-.5-.2-.7-.1-.2-.3-.4-.7-.5-.3-.1-.6-.1-.8-.1-.7 0-1.1.2-1.1.2h-.1s0 .1-.1.2c-.1.2-.3.4-.5.7l-.3.3c-.1.1-.2.1-.2.1-.1 0-.4-.2-.5-.4-.2-.2-.3-.4-.4-.5 0-.1-.1-.1-.1-.1s-.1-.1-.1 0h-.1c-.1 0-.3 0-.5-.2-.2-.1-.3-.3-.5-.5-.1-.1-.1-.2-.2-.2 0-.1-.1-.1-.1-.1h-.2c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.2-.1-.1-.2-.3-.3-.4-.1-.1-.1-.2-.1-.2h-.2l-1.5 1.1v.1s-.1.4-.9 1c-.4.3-.8.5-1 .5-.1 0-.2 0-.3.1h-.1s-.1 0-.1.1-.1.4-.2.6c-.2.2-.3.4-.7.4h-.2c-.5-.1-.8-.4-1.1-.7-.1-.1-.2-.3-.3-.4l-.1-.1h-.2c-.2 0-.7.1-1.1.5-.2.3-.4.5-.5.7-.1.2-.2.4-.2.8 0 .3.1.7.2 1 .1.3.3.6.5.8.2.2.8.7 1.6.7.3 0 .6-.1.9-.2.7-.4.9-.9.9-1.3 0-.2-.1-.4-.1-.4l-.1-.1h-.1v.1h.2c.1 0 .2-.1.6-.4.7-.5 1.5-1.2 1.9-1.4.1 0 .1-.1.1-.1l-.1-.1c-.6.2-1.3.9-2 1.4-.3.2-.4.3-.5.3h-.1v.1-.1.1-.1.1l.1-.1h-.1v.1l.1-.1-.1.1h.1v-.1l-.1.1h.1-.1.1-.1.1-.2s.1.2.1.3c0 .3-.1.8-.8 1.1-.3.2-.6.2-.8.2-.7 0-1.3-.5-1.5-.7-.1-.1-.3-.4-.4-.7-.1-.3-.2-.7-.2-.9 0-.3 0-.5.1-.7.1-.2.3-.4.5-.7.3-.4.7-.5.9-.5h.1v-.1l-.1.1s.2.3.5.6.7.6 1.2.8h.2c.5 0 .7-.3.9-.6.2-.3.2-.6.2-.6h-.1v.1s.6 0 1.4-.6c.9-.6.9-1.1 1-1.2h-.1l.1.1 1.5-1.1-.1-.1h-.1s.2.4.4.7c.1.1.3.2.5.3.2 0 .3.1.3.1v-.1h-.1s.3.6.8.9c.2.2.5.2.6.2h.2v-.1l-.1.1s.1.2.6.7c.2.2.5.4.6.4h.1c.2 0 .3-.1.5-.2.4-.4.8-1.1.8-1.1h-.1v.1c.1 0 .5-.2 1-.2.2 0 .5 0 .7.1.3.1.5.2.6.4.1.2.1.4.1.6v.4h.1c.2 0 .2.1.3.2v.1h.1l-.1-.1-1.6 2 .1.1h.1V273.8c0-.1-.1-.1-.2-.1s-.2 0-.4.1c-.1.1-.3.1-.6.1s-.5 0-.7-.1c-.1 0-.2 0-.2-.1h-.1v.1l.1-.1c-.5-.4-.7-.7-.9-1-.1-.1-.1-.3-.1-.4v-.1c0-.1-.1-.1-.1-.1s-.1 0-.1.1l-.2-.1c-.2-.2-.2-.3-.2-.3 0-.1 0-.1-.1-.1l-.9-.2s-.1 0-.1.1c.4.2.4.3.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M268.7 263.8v2.5s.3 2.3-.2 3c-.5.7-2.3.6-2.5-.1-.3-.6-.1-2.6-.1-2.6l2.8-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M268.7 263.8h-.1v4c0 .6-.1 1.2-.3 1.5-.2.3-.7.4-1.1.4-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.4-.3 0-.1-.1-.4-.1-.6v-2h-.1l.1.1 2.8-3h-.1.1l-3 2.8v2c0 .3.1.5.1.7.1.2.3.3.5.4.3.1.6.1.9.1.5 0 1-.1 1.3-.5.3-.4.3-1 .3-1.6 0-.8-.1-1.5-.1-1.5h-.1.1v-2.8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262725",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261 277.8s-.8-1.2-.4-1.9c.5-.7.8-.3 1-.3.2 0 .3-.5 0-1.3-.4-.8-.9-1.2-1.1-1.2-.3 0-1.8 1.1-1.5 2.6.3 1.7 2 2.1 2 2.1M275.5 276.4s2.8 1.2 3-1.7c.1-1.5-1.3-2.5-1.7-2.5-.3 0-.5.2-1 .8-.5.6-.9 1-.7 1.3.2.2 1-.2 1.4.6.7 1.5-1 1.5-1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec747",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266.6 271.6s-.4.7.8.8c.3 0 .6-.1.7-.3.3-.3.2-.6.2-.6s-.1.9.9 1c1.2 0 1.1-1.1 1.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M266.5 271.5s-.1.1-.1.3c0 .1 0 .3.2.4.2.1.4.2.8.2h.1c.3 0 .5-.1.7-.3.2-.3.3-.5.3-.6v-.1l-.1-.1s-.1 0-.1.1v.1c0 .1 0 .4.2.6.2.2.4.4.9.4h.1c.5 0 .8-.2.9-.5.2-.3.2-.5.2-.7v-.1c0-.1-.1-.1-.1-.1s-.1 0-.1.1 0 .3-.1.6c-.1.2-.3.4-.8.4h-.1c-.4 0-.6-.2-.7-.3-.1-.2-.1-.4-.1-.5h-.2c0 .1 0 .3-.2.5-.1.1-.3.2-.5.2h-.1c-.3 0-.5-.1-.6-.2-.1-.1-.1-.2-.1-.2v-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4c443d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261 277.8s-2.2-.5-2.2-2.6c0-1.4 1.6-2.1 1.6-2.1s-1.5.8-1.5 2c0 2.2 2.1 2.7 2.1 2.7M257 273.7s-1.3-.3-1.4-2.1c-.1-1.8 2.8-1.7 2.8-1.7s-2.9.1-2.7 1.9c.2 1.7 1.3 1.9 1.3 1.9M275.5 276.4s.6.3 1.2.2c.6 0 1.4-.2 1.7-1.3.3-1.1.2-1.6-.6-2.5-.5-.6-.9-.6-.9-.6s.5.1.9.7.9 1.3.6 2.5-1.5 1.2-2 1.2c-.5-.1-.9-.2-.9-.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m8.5 6.65-1.8 1.3-4-1.1-8.2-8.2-3-3 .2-3.6z",
    transform: "matrix(1.9509 0 0 2.4519 545.277 509.443)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M292.8 263.6s-4.2-3.3-9.6-7.3c-5.4-4-12.2-9.1-12.2-9.1l.3 4.4 13.9 12.8 4.6 2.2 2.3-.7 1.2-1.2-.5-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#784126",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M271.2 253.3s4.8 5.5 8.5 8.3c3.7 2.8 7.2 5.8 7.9 5.4.7-.4.5-.9.5-.9L271 252.2l.2 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m5.25 6.65-1.9-.8-10.4-10.6.5-1.9 1.5.2 12.1 11.8z",
    transform: "matrix(1.9509 0 0 2.4519 538.546 514.592)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M292.8 263.6s-1.3 3-4 2.3c-2.7-.7-17.6-14.8-17.6-14.8v1.5s15.1 13.8 18 14.4c2.9.6 5.3-2 5-2.2-.2-.3-1.4-1.2-1.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#784126",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M269.5 255.5s4.8 6.2 7.4 8.4c2.5 2.3 4.7 4.1 5.8 3.8 1-.2-.6-1.4-.6-1.4l-7.3-7.2-3.7-3.7c-.1.1-1.6-.5-1.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M270.7 255.5s12.2 12.4 13.2 12.7c2 .6 5-1.5 5-1.5l-1.1-.6-.1.4s-.5 1.3-3.1.7c-2.6-.6-13.3-12.1-13.3-12.1l-.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m4.4 4-1.2.9-1.1-.4-.8-.4L-3.2-1l-.9-1.7-.3-2.2z",
    transform: "matrix(1.9509 0 0 2.4519 534.547 517.902)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M283.3 267.6s-1.1 1.6-2.5 1.3c-1.4-.3-2.3-1.4-2.3-1.4l-8.5-8.3-.2-1.3s9.3 9.8 11 10.3c1.2.3 2.1-1.2 2.1-1.2l.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M278.6 267.3s-.4 1.2-1.7 1.1c-1.3-.2-1.6-.7-1.6-.7l-5.2-6.2-.1-1.7s5.4 7.5 6.7 7.9c1.3.4 1.6-.9 1.6-.9l.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a57231",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M273 251.1s5 4.3 5.4 4.5c.4.2 2.2.3 2.3.5.1.3-1.1 0-1.2.3-.1.3 2.5 2.4 3 2.5.4 0 2.5 0 2.5.3s-1.5 0-1.5.3 2.3 2.2 2.7 2.2c.4 0 3.1 0 3.1.3s-2.2-.1-2.1.4c0 .5 3.7 2.7 3.5 3.1-.1.3-4.4-2.8-4.5-2.7-.1.2-.3 1.2-.5 1.3-.3.2 0-1.3-.2-1.9-.2-.6-2.6-2.5-2.9-2.3-.3.2-.1 1.3-.3 1.3-.3 0 0-1.4-.2-1.8-.3-.5-2.5-2.4-2.8-2.4-.3 0-.1 1-.3 1.2-.2.2-.2-1.2-.5-1.6-.4-.4-5.7-5.2-5.5-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M264.4 265.1s0 1.9-.8 2.2c-.9.3-2.5-3.5-2.5-3.5l-.4-3.5 2.5 2.3 1.2 2.5zM271.1 264.1v-1c-.1-.5-.2-1.2-.2-1.2l-.2-2-.5-1.3-.4-.8h-.6l-1.3.9-.4 1.3.7 2.4.6 2.2 1 .3 1.3-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M269.4 267.4c.3-.1-.3-2.7-.3-2.7l-1.6-3.9-.4-1.4-1.3-.5-.8 1 .2 1.5s1.2 2.5 1.8 3.4c.6 1 1.9 2.8 2.4 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M268 259.2c.5.3 1 1.4 1.1 2.1 0 0 1 2.8.9 3.1-.1.3-.8.3-.8.3s1.4 1.4 1.8 1.3c.4-.2.2-1.6.1-1.9-.1-.3-.6-.1-.8-.4-.2-.3-.7-2.2-.7-3.3 0-1.1-.1-1.9.1-2.2.1-.3 1.2 2.4 1.2 3.8l.4.5s-.3-1.9-.4-2.5c-.2-.6-.6-1.6-.6-1.8 0-.2.2-.7.2-1.2v-.8s.6.4.8.3c.2 0 .5-.3.7-1.6.1-1.2-.1-4.8-.1-4.8l-5.4 7.1 1.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M268 258.6s-.2 1.9.5 3.9.9 2 1 2.3c.1.3.1 2.3-.1 2.6 0 0-1.4-3.5-1.9-5.3-.5-1.7-.6-2.4-.8-2.5-.2-.1-.6-.2-.6-.2l1.9-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M267.5 268.8c.2 0 .1-.8.1-.8l-.2-1.8-1.9-3.9-2.1-1.9-1.1-1.7-.2 3.2s1.5 3.2 2.5 4.1c1 1 2.6 2.9 2.9 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259.7 260s.3.9.3 1.4v1.1s.8 1.6 1.5 2.8c.7 1.2 1.4 2.5 1.9 2.2.6-.3.8-1.2.8-1.3 0-.1-.7 1-1 .9-.3-.2-1.9-5.2-1.9-5.3 0-.1-.4-.3-.8-.7-.2-.3-.8-1.1-.8-1.1M265.4 264.4s-1.1-1.8-1.4-2.5c-.3-.8-.9-1.4-1.1-1.4-.2 0-.4-1.6-.4-1.6s.6 1 1.3 1.4c.7.3 1.2.6 1.5.5 0 0 .2.8.2 1.6 0 .9-.1 2-.1 2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#583d25",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.9 261.8s.4 1.1 1.1 2.2c.7 1.1 1.9 2.3 1.9 2.3s-1.3-1.3-2-2.2c-.7-1-1.1-2.3-1.1-2.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M265.6 260.5s.3-.9.6-1c.3 0 .9-.2.9-.2s-.5-.1-1-.6c-.4-.5-.6-.5-1-1.1 0 0 .3 1.1.4 1.6.1.4.1 1.3.1 1.3M265.3 260.8s1.6 3.3 1.9 4.4c.4 1.1.3 2.8.3 2.8s-.2-1.2-.5-2.1c-.3-1-1.7-3.7-1.9-4-.1-.3.2-1.1.2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m267.4 258.7.4-4.8-.4-1.7-2.2-4.8s-.1.7-.6.7-2-.8-2.5-1.4c0 0 .3 1.1.2 2.2-.1 1.1-.3 1.7-.3 1.7l4.2 7.9 1.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#814529",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259 261.9s.7.8 1 .7c.4-.1.2-1.6-.2-2.5-.5-.8-5.6-7.7-6.4-8.1-.7-.4 5.6 9.9 5.6 9.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#814529",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M262.5 259c.1.3.5 2.5-.4 2.7-1.2.3-6.9-7.5-7.7-8.6 0 0-3.5-2.2-3.6-2.8-.1-.6 3.8.8 3.8.8l7.5 7.2c0 .1.3.4.4.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#583d25",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M262.5 259c0 .2.1.8.1 1.3 0 .6-.1 1.2-.6 1.3h-.1c-.3 0-.9-.5-1.6-1.2-2.1-2.2-5.4-6.6-6-7.4l-.6-.3c-.5-.3-1.3-.8-1.9-1.3-.6-.5-1.1-.9-1.2-1.1 0 0 0-.1.1-.1h.2c.4 0 1.3.2 2.1.5.8.2 1.4.4 1.4.4l7.5 7.2s.1.1.1.2c.4.2.4.4.5.5-.1-.3-.4-.7-.4-.7l-7.6-7.2s-2.6-.9-3.5-.9h-.2c-.1 0-.1.1-.1.1 0 .2.3.4.6.7 1 .9 3 2.1 3 2.1.4.5 2 2.7 3.6 4.7.8 1 1.6 2 2.4 2.7.7.7 1.3 1.2 1.7 1.2h.1c.5-.1.6-.8.6-1.4 0-.5-.1-1.1-.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259 261.9s-.6-1.1-.7-1.9c0-.8-.3-1.2-.4-1.5-.1-.3-4.2-6.2-4.6-6.6-.4-.4-1.8-1.2-1.8-1.2s.2.9.2 1.4v.5s1.3 2.5 3.2 4.6c1.9 2.2 4.1 4.7 4.1 4.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M265.3 260.8c.6-.3.3-2.2.1-2.8-.2-.6-3.6-7.6-3.6-7.6l-1 .4-1.9-1.5-1.1-1.2s.4 1.7.3 2.5c0 .8-.1 1.3-.1 1.3l2.7 4.7 4.6 4.2zM269.1 256.6l.8-1-.4-3.5-2.2-7.6s-.6.1-1.1-.2c-.6-.3-1.1-1-1.1-1l.5 4.5 2.3 6.4.1 1.9 1.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M262.1 258.4s-2.2-2.4-3-3.6c-.7-1.2-1.3-2.4-1.3-2.4s-.6.3-1.4 0c-.8-.3-1.8-1.4-1.8-1.4s-.6 1.2 2.6 4.5c3.7 3.6 4.9 2.9 4.9 2.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#814529",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M267.5 259.2c.9-.4.9-4.3 0-7s-2.3-5-2.3-5 1.8 4.3 2.2 6c.4 1.7 0 3-.3 2.9-.3-.1-.3-1-1-2.7-.7-1.7-1.2-2.1-1.2-2.1s2.6 7 1.8 6.9c-.7-.1-4.3-7.9-4.5-8.1-.2-.2-.3.3-.3.3s3.3 9.7 5.6 8.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m269.6 240.2 1.6 3.4.5 3.5.1 3s.1 5.9-.6 6c-.7.1-1.1-.6-1.1-.7 0-.1-1.4-6.6-1.4-6.6l-1.4-6.8.5-.5.2-1 1.1-.1.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#814529",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M265.3 260.8c.6-.1 0-1.7 0-1.7s-.5.8-.9.2c-.4-.5-1.1-2.5-1.1-2.5l-.4-1.2s-.5 1.3-1 1.3c-.6 0-3.6-5.2-3.6-5.2l-.4.5c-.1.2 4.2 9.1 7.4 8.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263.3 256.9s.5-1.3.3-2.4c-.2-1.2-1.8-4.1-1.8-4.1s-.5.1-1.1-.1c-.6-.2-1.8-1-1.8-1s.8 2.2 1.8 3.7c.9 1.6 2.6 3.9 2.6 3.9M265.8 255.1s-.4-2.7-1.6-5.3c-1.3-2.5-2.1-3.3-2.1-3.3s.1.6.1 1.6v1.2s1.1.4 2 1.9c.8 1.6 1.6 3.9 1.6 3.9M269.2 250.4s-.2-2.9-.6-4.6c-.5-1.7-.9-3.9-.9-3.9s0-.2.3-.3c.1-.1.3-.1.5 0 .6.2.9 1.8.9 1.8s-.1-2.4-.1-2.5-.2-.4-.2-.4-.2.1-.5.1-.6-.1-.6-.1.2.7-.1 1.1c-.2.3-.4-.2-.6-.3l-.1.3s.2.8.3 1.6c0 .7-.1 1.3-.1 1.3s.5 1.8.9 2.8c.3 1 .9 3.1.9 3.1M271.8 250.1s.5-4.2-.4-7c-1-2.7-1.8-3.4-1.8-3.4l-.4.5s1.5 2.3 1.9 4.5c.4 2.2.7 5.4.7 5.4M267.5 252.2s-.5-3.3-1.1-5.4c-.6-2.1-.8-2.9-.8-2.9l-.9-.8s.5 2.3.5 2.9c-.1.6-.1 1.1-.1 1.1s.4 1.1 1 2.1c.7.9 1.4 3 1.4 3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M269.8 257.5c.8 0 .1-4.8-.2-6-.3-1.2-2.3-7-2.3-7s2.4 8.2 2.2 8.6c-.3.6-1.2-2.5-1.4-2.5-.2 0 1.8 5.5 1.1 5.6-.7.1-1-1.2-1-1.2l.1 1.2c-.2.1.2 1.3 1.5 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M270.8 255.1c.6 0-.2-4.5-.6-6.5-.4-2-1.6-6-1.6-6s1.2 2.8 1.8 6c.7 3.2 1.1 7.3.5 7.4-.6.1-.9-.6-.9-.6l-.1-.7c0-.2.3.4.9.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#32281e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M263 260.4c.1.3.1 1.9-.7 1.8-.8-.1-2.3-1.5-2.6-2.4 0 0 1.8 2 2.4 2 .6 0 .6-2 .5-2.6l.4 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M267.3 238.8s1.1.7 1.9.2c.9-.5 1.4-1.7 1.4-2.4s0-1.2-.6-1.9c-.5-.7.8.6.8 1.9 0 1.3.1 3.5-1.9 3.9-2 .5-1.1-.1-1.1-.1l-.5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M265.7 234.9s1.3 2.1 1.8 4 .4 2.6.1 2.6c-.3 0-.4-.2-.5-.7-.1-.4-1.4-5.9-1.4-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#242626",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M-9.5-2.85-1 9.45l10.5-12-6.7-6.9z",
    transform: "matrix(1.9509 0 0 2.4519 493.188 461.631)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-4.45-2.35-.5 1.9 1 3.3 1.8 1.8 2.1 1.4.4-1.6.5-1.8.5-.1 1.3.5.9-1.3 1.4-2.5-.3-.9-.3-.7-2.2-3.7-.7 1.4-.7.4-1.2-.7-1.5 1.9-1.9-.8z",
    transform: "matrix(1.9509 0 0 2.4519 504.21 442.016)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#583b21",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M258.4 238.4s.4-.3.5-1.2c.2-1 .2-4-.1-5.1-.3-1.2-1-3.5-1.2-3.3-.2.2 1.2 2.6 1 5.5-.2 2.9-.1 3.7-.7 4-.6.2.5.1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#583b21",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M258.8 233.4s1.4 2 2.1 1.3c.7-.7.3-3.3-.1-4.3s-.9-2.4-.9-2.4l.4-.4s.5 1.7.7 2.7c.3 1 1 4.2.1 4.7-.9.6-2.3-1.1-2.3-1.1v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.3 234.8s.5-.7 1.1-.8c.6-.1.8.2.8.2l.6 1.7 1 1.7.8.8-.5.5-.7.1s-2-1-2-1.1c0-.1-.6-.7-.6-.7l-.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M257.6 252.3c-.7.3-2.2-.4-3-1.2-.9-.7-5.4-5.4-5.4-5.4l-.6-2.6 1.8.5 3.1-1.3.6-1.1 3.7-1.9 2-1.1 4.5-.1 1.1-2.2s1.5 2.6 1.8 3.7c.3 1.1.2 4.3-.2 4.5-.4.2-1.8-1-2.1-1.1-.2-.1 1.1 4.6 0 4.8-1.1.2-2.9-1.7-2.9-1.7s.7 4.2-.1 4.2c-.9 0-3.1-1-4-2.1-.2 0 .9 3.5-.3 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M256.8 246.8s.7 1.1.9 1.4c.2.3 0 2.3-.2 2.7-.3.8-1.3-.9-1.9-2.4 0 0-1.6-2.7-1.7-3.1 0-.3 2.9 1.4 2.9 1.4M265.5 236.5s1.6 6.5.8 6.7c-.8.2-2.9-2.1-3.2-2.4-.2-.3-3.3-5.1-3.3-5.1l-.6-.6.2-.3 1.3.5 4.8 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.3 249c-.3.2-1-.8-1.3-1.1-.3-.3-1.4-1.6-2.4-2.6-1-1.1-1.8-1.8-1.8-2 0-.2-.6-.9-.6-.9l.6-.7.7-.1s4.3 3.4 4.6 4c.2.5.4 3.3.2 3.4M260.8 249.1c-.2.2-3.1-1.9-4.2-3.6-1.2-1.7-2.4-3.2-2.7-4-.3-.8-.5-1.5-.5-1.5l.9.2c-.2 0 6.8 8.6 6.5 8.9M261.8 246.1c-.2.2-1.4-.7-2.2-1.7-.8-1-.4-2.2-.4-2.2s2.7 3.7 2.6 3.9M263.4 245.7c-.4.2-2-1.8-3.4-4-1-1.6-1.3-1.9-1.5-2-.4-.2-1.1-.3-1.1-.3l-.1-.2.7-.2.5-.6.8-1.1 3.4 6.8c.1-.1.9 1.5.7 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.6 251.1c0 .3 0 .5-.9.4-.9-.1-5.7-2.7-7.9-6.2s-2.5-4-2.5-4l1-1.1 7.6 8.7 2.7 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.6 251.1c.1.4-.4.5-.9.4-.5-.1-2.4-.8-5.5-4.2-3.1-3.4-4.3-5.8-4.3-5.9l-.2-1.5.9-.4 5.3 8 4.7 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259.7 247.6s-1.6-1.1-2.6-2.3c-1-1.2-3.1-4-3-4.6 0-.6.9-.6.9-.6v-1.4l.3-.5 1.5.6 1.9 2.3.7.9s1.2 2.9 1 3.2c-.2.3-1.9-1.6-2.2-1.4-.3.3 1.8 3.6 1.5 3.8M256.8 246.8s.5.8.3 1.3c-.2.6-.4.8-1.2-.3-.8-1.2-1.7-2.5-1.8-2.4-.1.1.1 1.8-.3 1.8s-1.6-1.5-2.4-2.6c-.8-1.2-2-3.1-2-3.1s.1-.4 0-1.7c0-1.3-.2-2-.2-2s.1.4.3.7c.1.3.3.5.3.5l2.8 3.4.8-.6 1.7 3.3 1.7 1.7zM245.9 241.9s2.2 3.9 4.3 6c2 2.2 4.4 3.1 4.4 3.1l-6.7-7.9-2-1.2zM262.9 244.2c-.1.1-1.5-1.4-2.3-2.7-.9-1.3-1.5-3.2-1.5-4 .1-.8.3-2.8.3-2.8s2.3 2.4 2.7 3.5c.4 1.1 1.4 2.6 1.2 2.8-.2.2-1.7-1-1.9-.7-.3.3 1.7 3.8 1.5 3.9M265.5 241.8c-.3.1-1.4-1.2-1.7-2.1-.3-.9-.4-2.5-.4-2.5l-1-2.4.1-2.7 1-.2 1.5 2.1s.6 1.2.6 3c-.1 1.9.2 4.6-.1 4.8M247.5 248.3c-2.1-2.5-3.3-4.9-3.3-4.9l-.7-2.3.4.3s.6 2.6 3.8 5.7c3.2 3.1 3.9 3.4 3.9 3.4s.6 1.7.3 2.3c-.1 0-2.4-2-4.4-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M250.9 251.9s-2.7-2.4-4.8-5.1c-2.1-2.7-3.5-5.3-3.5-5.3l.9-.9s1.8 4.2 3.1 5.8c1.2 1.7 4.3 5.5 4.3 5.5M254.6 251.1s-3.1-3.1-4.7-4.9c-1.6-1.8-2.5-3.5-2.5-3.5l1.3.5s.5 1.4 1.7 2.8c1.1 1.4 4.2 5.1 4.2 5.1M254 245.5s-1.7-2.1-2.5-3.4c-.8-1.3-1.6-3-1.6-3s2.3 2.6 3 2.8c.7.2.6 0 .6 0s-.3.9 0 1.7c.2.8.5 1.9.5 1.9M254.7 237s.3 1.5.1 2.3c-.2.9-.6.9-.6.9s.9 1.3 1.4 1.8c.5.5 1.8 1.4 1.8 1.4s-1-1.4-1.5-2.2c-.4-.7-1-1.6-.8-2.3.3-.7 1.7.5 2.1.8.4.3 2 2.3 2 2.3s-.6-2-1.4-2.8c-.8-.6-3.1-2.2-3.1-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M261.6 241.5s-.9-2.1-1.4-3.4c-.5-1.3-1.3-4.1-1.3-4.1s.1 1.3 0 2.2c-.1.9-.4 2.4-.8 2.6-.4.2-.5.2-1.3 0s.5.4.5.4.8 0 1.1-.4c.3-.4.4-1.2.8-1.1.4.1.7 1.4 1 1.9.4.5 1.4 1.9 1.4 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#262525",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M258.9 233.9s1.6 1.9 2.4 1c.7-.8.3-3.2.3-3.2s1 .4 1.3.1c.3-.3.2-1.2.2-1.2s1.8 2.6 2.6 4.3c.9 1.7 1.3 4.7 1.3 4.7s-1.5-2.4-2.2-4.7c-.7-2.1-1.7-3-1.9-2.8-.2.2-.5 1.6-.2 2.4.2.7.8 1.7 1.2 2.8.4 1.1.9 2.7.9 2.7s-.9-1.3-1.3-2c-.5-.7-1-1-1.3-1.3-.3-.3-.8-.9-1.3-1.1-.5-.2-1.5-.7-1.5-.3 0 .4-.2-.8-.2-.8l-.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#1d1d1d",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M253.4 241.8s.9 1.8 1.6 2.8c.7.9 1.7 2.3 1.7 2.3s-1.6-1.4-2.2-2.3c-.5-1-1.1-2.8-1.1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M264.1 242.3c-.2.1-1-.2-1.1.1-.1.3.4 1.4 1 1.9.6.6.8.6.9.5.1-.1-.1-.6-.2-1.2s0-1.2-.1-1.4c.1-.1-.5.1-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m244.7 230.7-.9.6-1.1 2.3.3 4.2s1.1 1.5 1.7 2.4c.6.9 2.8 3.4 3.3 3.2.6-.1 1.1-1.8 1.2-2.7.1-.9.1-2.6.1-2.6s.5.9 1.4 1.9c.9 1 1.7 1.9 2.1 1.8.4-.1 1.7-2.6 1.7-2.9 0-.3-3.1-8-3.1-8l-1.4-.7-5.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.8 237.1s.5 2 .9 2.9c.3 1 0 1.8.2 1.8s1.8-2.2 1.8-3.2 0-2-.4-5.1c-.4-3.1.1-3.9.1-3.9l-.9-.8-1.6 3.3-.1 5zM246.3 235.4s.4 3 .6 4c.2 1 .8 2.6 1.1 2.6.3 0 1.3-2.6 1.3-3.5 0 0-.7-1.3-.6-4.4 0-3.2-.3-3.5-.3-3.5l-2.1 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#453d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242 229.2s-2.5 3.6-2.4 5.6c0 2 .4 1.5.9 3.3.6 1.8.9 4.4.9 4.7 0 .2.4-.1.5-.4 0-.2.1-13.2.1-13.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242 229.6s-2.2 3.4-2 5.2c.2 1.9.4 1.8 1.1 3.5.6 1.7.7 4.4.7 4.4s.7-.2 1.5-.8c.8-.6 1.5-1.7 1.5-1.7s-.3-.6-.8-1.7-.6-1.5-.6-1.5l-.6-.9.2-3.2.6-2.3v-.9l-1.6-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M253.8 235.4s-1.1-.2-1.5-.5c-.4-.3-.6-.9-.6-.9l.3-.6 1.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#c9a46a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.4 230s-1.6 3.4-1.4 5.7c.2 2.3 1.5 5.3 1.6 5.3.1 0 .1-.2.1-.8 0-.5-.1-7-.1-7l.8-2.3v-1.2l-1 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.2 230.8s.2 1 .1 1.4c-.1.4-1 .9-1.3 1.6-.3.7-.8 2.2-.8 2.2s.4-.9.9-1.4c.5-.6.7-.9.8-.6.1.3.3 1.7.2 1.9-.1.2-.5.6-.8 1.6-.3 1 0 1.9 0 1.9s.2-1.1.3-1.7c.1-.5.6-.8.6-.8l.9 1.9s0-.9.1-1.6c.1-.7.9-1.6 1.1-1.6.2 0 .6-.1-.3-.6-.3-.2-.1-3.4.1-3.6.2-.1 1.5-.2 1.3-.6-.1-.4-1.2-1.6-1.3-1.8 0-.1-1.9 1.8-1.9 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M253.6 237.7s-.8-.1-1.2-.2c-.4-.1-.5-.5-.5-.5l.1-.5 1 .5.6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243.6 238c0 .3-.3.7-.4 1.2-.2.6-.3 1.3-.3 1.3s-.2-1.6-.3-2.6c-.1-1.1-.2-1.8-.3-1.9-.1-.1-.5.5-.5.5s0-1.2.2-1.8c.2-.6.4-1.4.2-1.6-.2-.1-.6.2-.8.6-.2.3-.6 1-.6 1s.2-1 .5-1.5c.3-.4 1.4-1.8 1.7-2.3.2-.5.2-1.1.2-1.1h.8s.9.7.9 1.3c0 .3-.8.7-.8.7 0 .1-.7-.1-.8 2.7-.4 2.6.3 2.4.3 3.5M251 231.1s.2 1.5 0 1.9c-.2.4-.6.8-.9 1.4-.3.6-.3 2-.3 2s.2-.7.4-1.1c.3-.4.5-.8.6-.8.1 0 .4.5.6 1.3.2.8.6 2.1.6 2.1s-.2-1 .1-1c.3 0 .4-.1.7.2.3.3.7.6.7.6s0-.4-.5-.9-.8-.5-.9-1.2c-.2-.7-.2-1.4-.2-1.7.1-.3.4.2.7.5.3.3 1.2 1.1 1.2 1.1s-.4-.6-.5-.8c-.1-.2 0-1.6 0-2.4 0-.8 0-1.5.3-1.7.3-.2.3-1.2.2-1.4-.1-.2-2.8 1.9-2.8 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#242626",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259.7 228.1s.1 1.7.3 2.6c.2 1 .9 3.1.9 3.1s-.9-1.6-1.3-2.9c-.4-1.4-.7-2.8-1.1-2.9-.3-.1-.7.6-.7 1.2s.4 2.7.8 3.4c0 0-.7-1-1-1.9-.3-.9-.6-1.7-.6-1.7s-.3.8-.2 1.6c.1.9.8 2.1.8 2.1s-.5-.4-.8-.8c-.3-.4-.6-.6-.6-.6s0 1.2.4 1.7c.3.5.9 1.3.9 1.3s-.7-.6-1-.9c-.3-.3-.4-.5-.4-.5s.1 1.7.5 2.6c.4.9 1.2 2.4 1.2 2.4s-.9-.8-1.6-2.2c-.6-1.5-1-5.9-.8-6.5 0 0 .5-.8.9-1.5.5-.6 1-3.8 1-3.8s.7 2.9 1.2 3.4c.7.6 1.2.8 1.2.8M252.8 227.2s.4.8.6 1.1c.2.3.5.8.5.8s-.9.9-1.8 1.7c-1 .7-2.2 1.6-2.5 1.1s-.3-.8-.3-.8 1.1-.6 1.9-1.5c.8-.8 1.1-1.3 1.3-1.7.2-.5.3-.7.3-.7M244.1 230s.1 1.8.9 1.8c.7 0 3-2.3 3.1-2.4.2-.1.3-.7.3-.8 0-.2-.1-.6-.1-.6s-2.4 2.5-3.3 2.5c-.6.1-.9-.5-.9-.5M244.2 227.7s-.3 1.3-.3 1.6c0 .4.2.6.2.6s-1.7.6-2 .1c-.3-.5-.1-1.3-.1-1.3s.8 0 1.2-.1c.4-.1 1-.9 1-.9M260.4 225.1s.7 1.9 1.2 2.6c.5.7 1.2 2.3 1.2 2.3s-1.2-1.3-1.5-1.6c-.4-.3-.9-.8-.9-.8s.2-.5.2-.9c-.2-.4-.2-1.6-.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.7 228.7s.6.1 1 .1.7-.2.7-.2l.6-1s-.3 1.2-.1 2c.2.8.7.9.9.9.2 0 1.1-.2 1.8-.9s1.7-1.5 1.7-1.5-.2 1.1.1 2.1c.4 1 1 1 1.8.4s1.6-1.8 2.1-2.3c.3-.3.6-.8.6-.8l.9-.7.8-4.3-.4-.6-1.1.5-1.3-.5-.4-.6-.8 1.3-.8.5-.4.1-.9.2-.4-.8-.2-.6-.5-.2-1.9 2-1.1-.1-1.1 1.7-.8 1.1-.8 1.9v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.1 224.3s.2 1.1-.4 2.9c-.5 1.8-1.3 3.1-1.3 3.1s1.9-1.2 2.9-3.3c.9-2.1.7-4.6.7-4.6l-1.9 1.9zM253.5 222.4s.2.3 0 1.9c-.2 1.6-.6 3.2-.6 3.2s.2.4.5.9.9 1.5 1.4 1.3c.5-.2 1.2-.7 1.7-1.8s.9-2.1 1.1-2.3c.2-.2.3.1.3.2.1.1.2 1 .7 1.4.5.4 1.1 1 1.4.8.3-.2.6-.7.5-1 0-.3-1-3.2-1-3.2l-1.2-3.2-.8-1.2-2.3.2-1.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M257.4 219.4s.6 1.4.7 2.8c0 1.5-.3 3-.3 3s.1-1.8-.1-2.9c-.2-1.1-.5-1.8-.5-2.1 0-.3.2-.8.2-.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M260.5 225.2s.1 1.3 0 1.9c-.1.6-1-.4-1.6-2.4-.5-2-.4-2.5-.9-3.4-.4-1-.7-1.8-.7-1.8l1.1-.2 2.1 5.9zM254.9 228.9s2.2-1.2 2.4-4.9c.1-1.7-1-4.6-1-4.6s0 3-.8 4.9c-.8 1.9-1.5 3.2-1.5 3.2s.5-.2.8-.5c.3-.3.6-.9.6-.9s.1.6-.1 1.3c-.1.8-.4 1.5-.4 1.5M253 222.4s-.1.8-1 1.6c-.9.7-2.5 1.6-2.5 1.6s1.2-1.1 1.6-2.1c.4-1 .1-1.6.1-1.6s-.2.5-.7.9c-.5.4-1.3.5-1.3.5s.1-.5.5-1c.1-.1.1-.4.1-.6.3-.8.9-1.9.9-1.9s.5 1.2 1 1.7c.8.4 1.3.9 1.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#242626",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M259.8 218.1s.5 1.3.7 3.2c.2 1.8 0 4 0 4s-1.1-1.7-1.4-2.4c-.3-.7-.3-1.8-.5-2.3-.2-.3-.6-.6-.8-.8-.2-.1-.8-.1-.8-.1s.6-.3.7-.9c.1-.6 0-.9 0-.9s.4.2 1.1.3c.6 0 1-.1 1-.1M254.9 225.9s1.2-1.7 1.5-3.7c.3-2 0-2.7 0-2.7s-.5-.1-.9-.5-1-1.4-1-1.4.2 1.1 0 2.3c-.2 1.3-1.4 2.5-1.4 2.5s.6.2 1.2-.1c1.2-.7 1.1-2 1.1-2s.3.2.2 1.8c-.1 1.7-.7 3.8-.7 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241 228.7c-.3 0 .8-1.6 1.5-2.7s1.7-2.7 1.7-2.7.2.2.6.2c.4 0 1.5-.5 1.9-1.3.4-.8.8-1.7.8-2 0-.3-.1 1.4.7 2.3.8.9.8.8 1.1.8 0 0 0 1.2-.3 2.2-.3 1.1-.6 2.6-.6 2.6s.1-2-.2-2.6c-.3-.6-.5 0-.8.8s-.9 1.3-.9 1.3.5-.9.8-1.8c.3-.9.2-1 .1-1s-.2 0-.6.3c-.3.4-.7.5-.7.5s.4-.3.5-.8c.1-.5.5-1.2.8-1.4.2-.3.4-.6.4-.8 0-.2 0-.6-.2-.6s-.4.2-1.1.9c-.7.7-.9.8-1 1l-.7 2.1c-.5 1.5-.8 2.1-.9 2.2-.1.1-.4.3-.4.3s.3-.8.6-1.9c.4-1.1.9-2.5.8-2.7-.1-.2-.5-.2-.6 0-.1.2-.9 1.1-1.6 2.2-.7 1.1-.7 2.5-.9 2.5-.1.1-.6.1-.8.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#805028",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M260.5 216.9c0 .1.1.9-.7 1.2-.8.3-1.8-.1-1.9-.1-.1-.1-.1-1.1-.1-1.1h2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a77131",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M244.8 219.5s-.1.8-.6 1.7c-.4.9-1.2 1.7-1.1 1.8.1.1.5.6 1.2.5.6 0 .9-3.9.9-3.9l-.1-.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.8 217.3s-.3 5.1-1.7 5.1-2.1-2.6-2.1-2.6-.1 3.5-2 3.5c-.8 0-1.7-2.7-1.5-3.2 0 0-.3 1.8-1.2 2.5-1.7 1.4-2.8.7-2.9.5-.1-.2 1.5-1.7 1.7-3.7 0 0 .3.1.7-.5.4-.6.6-1.3 1.1-1.1.4.1 2.5-.8 2.5-.8l1.1-1.4s.1.4.9-.1 1.1-1.4 1.1-1.4l2.1 1.8.2 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a77131",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M249.1 212.5s1.3 2 2.2 3c.1.1.5-.4.5-.4.3.4.4.7.3.9-.3.8-1 1.9-.5 3 0 0-.2-.6.1-1.5.3-.8.6-1.1.7-1.1.2 0 .5 4.7.8 4.7.3 0 .7-2.1.7-3.6s.3-.3.4 0c.1.3 1.4 2.4 2.5 2 1.1-.3.9-2.2.9-2.7 0-.4-.8-3-.8-3l-4.9-3.1s-.1.4-.4 1.3c0 1.1-2.5.5-2.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M256.1 212s.3.3.8 1.5.5 5.1-.1 5.1-1.9-.7-2.1-1.3c-.2-.5.1-2.5-.3-3s-.9-1.8-.9-2.2c0-.4.1-1.6.1-1.6l1.1-.4 1.4 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m255.7 210.8 2.1 3.1 1.8 2.7s.9.3.9.4c0 .1-1.1 1.2-2.5.4-.7-.4-.3-1.6-1.3-3.6-.9-2-2.5-2.9-2.5-2.9l.6-.6.9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#242626",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.6 209.1s1.9 1.2 2.5 2.6c.6 1.3 1 2.1 1.8 3.4.8 1.3 1.6 1.7 1.6 1.8 0 .1-.6.2-1-.1-.4-.3-.8-.6-1.1-1.2-.3-.6-1.5-2.8-1.9-3.3s-1.8-1.6-1.9-1.5c0 .1.4.4 1.2 1.7.8 1.3 1 2.4.9 2.5-.1 0-.2-.5-.9-1.6-.7-1.2-2.2-2.7-2.3-2.4-.1.2.7 1.6 1.2 2.4.4.8 1.1 2.6 1 2.6-.1 0-.6-1-1.4-2.3-.8-1.3-1-1.1-1.3-1.5-.3-.4-1.1-1.4-1.1-1.4s.7.2 1.5-.2c.8-.8 1.2-1.5 1.2-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M249.9 212.5s1.2.3 1.8.2c.6-.1.9-.1.9-.1s.4.5.4 1.1c0 .6-.4 1.7-.6 1.8-.2 0-.2-1-.4-1.4-.4-.3-2.1-1.6-2.1-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a77131",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M250.5 215.6s.4 1.3.1 3.1c-.3 1.8-1.3 3.7-1.6 3.7-.3 0-.2-2-.3-3.1v-.3c0-.2-.4 1.4-.4 1.2 0-.1.3-1.9.3-2 0-.4-.1-.7-.1-.7l1.3-1.6.7-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M248.2 217c-.4.4-.9.3-1.4.5-.5.2-.7.9-.7.9s.4-.3.6-.2c.2.1.4.1 0 .9-.4.9-1.8 2.4-1.7 2.4.1 0 1.6-1.3 2.1-2s.4-1.2.6-1.4c.1-.3.7-.6.8-.6.1 0 .4 0 .5.6.1.5.3 2 .4 2.1.1.1.5-1.4.6-2.1.2-.7.1-2.3.1-2.3s-.1 0-.5-.1-1.2-.7-1.2-.7.3 1.4-.2 2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.6 207.8s.5 1.2-.5 2.1c-.3.3-.6.4-1.1.5-.5 0-1.4-.4-1.4-.4l-3.1-1.3-1.6-.5-.8-.2.1-.9 2.4.1 2.4.9 1 .3.9.2h.7l.6-.2s.3-.1.3-.2c.1-.3.1-.4.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M254.6 207.8c.1.2-.2.9-.4 1-.2.1-.6.3-1.6.1-.9-.2-1.9-.8-2.9-1.1-1-.3-1.8-.6-2.6-.5-.8 0-.4-.3-.4-.3s1.8-.2 3.5.4c1.6.6 2.3 1 3.1 1 1.1-.1 1.3-.6 1.3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.1 206.8s.4.1.7 0c.3-.1.5-.2.5-.2s.1.4-.2.6c-.2.1-.8.1-.9.1-.1-.1-.1-.5-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M252.2 210.7s1.1 1.1.8 2l-2.1-1-3.4-1.4-1.9-.6-.2-.3s.4-.3.5-.6c.2-.3.1-.6.1-.6l2.3.3 2.4.7 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M249.9 212.2s1.9 2.5 1.5 3.3l-4.5-2.9-1.6 2.6-3.7-1.8s3-2.3 3.4-2.8c.3-.4.4-.6.4-.6l1.7.3 2.7.8.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M248.8 208.5s1.6.4 2.6.9 2.5.6 2.5.6-.6.6-1.7.6c-.3 0-1.1-.6-1.6-1s-2-.8-2-.8l.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246 207.6s1.1.2 1.9.6c.7.3.7.2.9.2.2-.1.2-.2.2-.2s.1.7-.4.7-.8-.2-1.5-.5-1.2 0-1.2 0l.1-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M252.4 212s.8.5.6.6c-.1.1-.6.3-1.3.3-.7 0-1.1 0-1.6-.3-.5-.2-.8-1.1-2-1.6s-1.4-.5-2.2-.8c-.8-.2-1-.2-1-.2l.8-.3 2.6.5 2.2.6 1.3.6.6.6zM248 213.6l.5 2.1-.3 1.2-.7.4-.6-.3-.2-.4s.3-.5 0-.9-1.6-.9-1.6-.9.5-1 1.1-1.2c.6-.2.3-1 .3-1l1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.4 209.4s.4.3 1.3.4c.4 0 1 .2 1.7.4.2.1.8-.2.9-.2l-.5.3c.8.2 1.7.5 2 .7.9.4 1.6 1.1 1.6 1.1s-.5-.3-1.6-.7c-.8-.3-1.7-.6-2.4-.8-1.6-.3-3.1-.2-3.4-.3-.3-.1.1-.1.3-.3.1-.2.1-.6.1-.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.2 215s.5.5 0 .7c-.5.2-1.9.2-2.6-.6 0 0-.2-.7-.4-1-.3-.3-1.3-1-1.9-1.3-.6-.4.2-.4.2-.4s2.1.8 2.9 1.2c.8.5 1.8 1.4 1.8 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M251.3 215.1s-1-1.4-4-2.6c-.1 0 1-.2.9-.2h-1.5c-.2-.1-.4-.2-.7-.2-1.5-.5-1.6-.4-1.8-.6-.1-.2-.3 0-.4.3-.2.3-.6.8-.6.8s1.1-.3 2-.1c.9.2.8.5.8.9-.1.3-1.1 1.6-1 1.6.1 0 .7-1.2 1.5-1 .8.2 1.1.6 1.1.6s0-.5-.2-.6c-.2-.2-1-1-.8-1 .2 0 1.2.2 2.6.9 1.4.5 1.6.8 2.1 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M246.5 212.8s2.2.6 2.1 3c-.1 2.4-1.8 1.9-2 1.1-.1-.9.2.4.8.3.7-.1.8-.8.8-1.7 0-.9-.2-1.3-.8-1.8-.4-.6-.9-.9-.9-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#674222",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.9 207.1s.2.2-.4 1.9c-.6 1.7-1 2.3-1.9 3.3-1.8 2-2.6 2-2.4 2.8.2.8.9.6 1.1.6.2 0 3.4-4.8 3.4-4.8l.7-2.9-.2-.8-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d1ab6e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M244.9 203.7s.9 1.4.6 4.1c-.3 2.7-3.8 5-3.8 5l-5.1 3.5-2.1-.1h-.6c-.3-.1-.6-.4-.7-.4-.1 0-.4-.9-.4-.9l.7-.8 1.9-1.8 1.2-1.7s.5-1 .6-1.9c.1-.9-.2-1.4-.2-1.4l.4.7.2 1.4-.2 1.6 1.3-.9 1.8-.8s.5-.1.8-1.1c.3-1 .6-2.4.6-3.1 0-.6-.1-1.4-.1-1.4s.1 0 .2.1.6.9.6 1.3c0 .5.3 2.2.3 2.2l.8-.8s.6-.8.8-1.2c.2-.6.4-1.2.4-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M245.5 216.9s.3.3.2 1.3c-.1 1-.9 1.5-1.3 1.5v-1.3l-1.1-.9-1.2-.4.2-.2c.1-.1 1.4-.7 1.4-.7l1.8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M244.6 216.9s.3.3.9.2c.6-.1.8-1 .5-1.4-.3-.4-.2.9-.5 1-.4.1-.8-.9-1.3-1-.5-.1-1.3.2-1.5.6-.2.3.8.1.8.1l.5.1.4.1.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.2 213.3s.7.2 1.4.1 2.5-.8 2.5-.8.8-.5 1.4-1c.6-.6 2.5-1.8 2.7-4.1.2-2.4-.3-3.7-.3-3.7s2.8 3 .3 6.6c-1.6 2.3-3 3-3 3s2.7-.8 2.9-.1c.2.6-.1 1.7-.2 1.8 0 0 1.5.4 1.8 1.1.1.5-1.7-.5-3.2-.2-1.4.3-2 1.2-2 1.2s-.3-.4-1.5-.4c-1.3 0-1.8.6-2.5.6s-3-.5-3.4-1.1c0 0 .5-.7 1.5-1.7.7-1.6 1.6-1.3 1.6-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243 206.9s1.1-1.1 1.5-1.9c.4-.8.4-1.4.4-1.4s.1.9-.5 1.8c-.6 1-1.3 1.6-1.3 1.6l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M242.7 204.6s.9 3.5-.1 4.9c-.9 1.4-5.1 3.3-5.1 3.3s3.1-1.7 4.1-3.7c1-2 .9-3.6.9-3.6l.2-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#242626",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M238.6 213.4s1.3 0 2.1-.5c.8-.4 1.8-1.4 1.8-1.4s-1 .9-1.3.9c-.3 0-.5-.5-.4-.8 0 0-.2.7-.8 1.1-.6.4-1.4.7-1.4.7M241.7 209s1.1-1.2 1.1-3.6c0-2.4-.9-2-.9-2s.8.6.6 2.4c-.2 1.9-.8 3.2-.8 3.2M243 209.3s1.3-.3 1.7-1c.4-.7.4-2.1.4-2.1s-.1 1.3-.5 1.8c-.3.3-1.6 1.3-1.6 1.3M242.3 216.9s.6-1.2 1.5-.9c.8.3.8 1 .8 1s-.3-.5-1-.6c-.6 0-1.3.5-1.3.5M239.9 214.7s1.8-.4 2.9-.8c1.1-.3 2.3-.9 2.3-.9s-.9 1.1-2.3 1.9c-1.3.8-2.5.8-2.5.8s2.5-1.1 2.8-1.6c.1.1-2.3.7-3.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237 211.8c.9.8.9 2.1.2 3-.6.7-1.7.9-2.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#e06b28",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.9 212.1c.8.7.8 1.9.1 2.6-.6.6-1.5.8-2.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#010101",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.1 213.1c.4 0 .7.4.6.8 0 .4-.4.7-.8.6-.2 0-.4-.2-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#d3d1c9",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.2 214c0 .1-.1.2-.3.2-.1 0-.2-.1-.2-.3 0-.1.1-.2.3-.2.1.1.2.2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M237.5 210.5s1.2-1.2 1.5-2.8c.3-1.6.1-2.5.1-2.5l.7.7.3 1.2-.4 2s.9 0 1.3-.6 1.2-3.4.9-5c0 0 .4.7-.1 3s-.9 2.6-2.6 3.5c-.9.5-2 1.4-3 3.4-.5.9-1.7 2.2-1.9 2.4 0 0 .9-1.2 1.3-2.2.7-1.4 1.4-2.2 1.4-2.2l.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#86492a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.9 211.5s.5-1.6.5-2.5c0-.9-.6-1.9-.6-1.9s.8-.1.8 1.8c.2 1.9-.3 2-.7 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4b2e1e",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M239.4 209.4s.6-1.4.5-2.4c0-.9-.8-1.9-.8-1.9s1 .2 1 1.9c.1 1.8-.2 1.9-.7 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a16d32",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M233.7 215.9s-.4-.6-.4-1c.1-.5 0-.5 1.1-1.7s1.7-1.9 2-2.5c.3-.6 1.2-2.3.5-3.6 0 0 .5 1.9-.6 3.4s-1.7 2.3-2.7 3c-.9.7-1 1-1 1.4 0 .4.1.8.3.9.3.1.8.1.8.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#642",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M244.4 219.7s.2 0 .4-.3.2-.8-.2-1.3-.8-.8-1.4-.9c-.6-.2-1.6-.3-1.6-.3s.3.6 1.1 1c.3.2.9 0 1.3.3.3.5.4 1.5.4 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#642",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M244.4 219.7s1.2-.4 1.3-1.6c0-.7-.1-1-.1-1s.2.4.7.5l.4-.2c0 .1-.7 2.4-2.3 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#b38036",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M235.8 219.4s.2.1.7.6l.7.7 3-.8 1-.9-.8-1.3h-2.1l-2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec643",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m243 218.4-.6-.8s-.1-.3-.6-.5c-.4-.2-2.2-.2-2.2-.2l-1.3.3s-.4.3-1 .2c-.6-.1-2.1-.7-2.1-.7l-1.5-.6s-1.1-.5-1.3-.4c-.2.1-1.1 1.1-1.1 1.1s-.2.5.2.5c.3 0-.5.2-.5.2s-2.3 1.2-2.6 3.5c-.4 2.2 3.7 5.5 5.2 3.8 0 0-2.2-1.6-1.8-3 .4-1.4 1.4-2.2 3.2-2.3 1.7-.1 1.8-.3 2.6-.8s2.2-.8 3.2.2c1 1.1-4 2.1-4 2.1l.6.8c0-.1 6.2-2.2 5.6-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m243 218.4.1-.1-.6-.8-.1.1.1-.1s-.1-.4-.6-.6c-.1-.1-.3-.1-.5-.1-.6-.1-1.4-.1-1.7-.1h-.1l-1.3.3s-.2.2-.6.2h-.3c-.3-.1-.8-.3-1.3-.4-.4-.2-.8-.3-.8-.3v.1l.1-.1-1.5-.6s-.2-.1-.5-.2-.6-.2-.8-.2h-.1c-.1 0-.2.1-.3.2-.4.3-.9.9-.9.9v.3c0 .1 0 .2.1.3.1.1.2.2.3.2v-.1.1-.1.1l.1-.1-.1.1.1-.1-.1.1.1-.1h-.1v.1l.1-.1h-.1.1l-.1-.1v.1h.1l-.1-.1.1.1-.1-.1.1.1v-.1h-.1c-.1 0-.2.1-.3.1h-.2s-.6.3-1.2.9c-.6.6-1.3 1.5-1.5 2.6v.3c0 .9.6 2 1.5 2.8.8.8 1.9 1.4 2.8 1.4.4 0 .9-.2 1.2-.5l.1-.1-.1-.1-.1-.1c-.2-.1-.6-.5-1-.9-.4-.5-.7-1-.7-1.5v-.3c.2-.7.6-1.2 1.1-1.6.5-.4 1.2-.6 2-.7.9-.1 1.3-.1 1.7-.3.4-.1.6-.3 1-.6s.9-.5 1.5-.5c.5 0 1.1.2 1.6.7.1.1.1.2.1.2 0 .1 0 .2-.1.2-.2.2-.5.4-.9.5-.6.3-1.3.5-1.9.6-.3.1-.6.1-.7.2-.2 0-.3.1-.3.1h-.2l.7 1.1h.1s1.4-.5 2.8-1.1c.7-.3 1.4-.7 2-1 .3-.2.5-.3.7-.5.2-.2.3-.4.3-.6v-.2l-.7.1-.1.1v.1c0 .1-.1.2-.2.4-.2.3-.7.6-1.3.9-.8.5-1.9.9-2.7 1.2-.4.2-.8.3-1 .4-.3.1-.4.1-.4.1v.1l.1-.1-.6-.8-.1.1v.1s1-.2 2.1-.5c.5-.2 1-.4 1.4-.6.2-.1.4-.2.5-.4.1-.1.2-.3.2-.5s-.1-.3-.2-.4c-.5-.6-1.2-.8-1.8-.8-.6 0-1.2.2-1.6.5-.4.3-.6.4-.9.6-.3.1-.8.2-1.6.3-.9.1-1.6.3-2.2.7-.6.4-.9 1-1.2 1.7 0 .1-.1.3-.1.4 0 .7.5 1.4.9 1.9l.9.9.1-.1-.1-.1c-.3.3-.6.4-1 .4-.8 0-1.8-.5-2.6-1.3s-1.4-1.7-1.4-2.5v-.3c.2-1.1.8-1.9 1.4-2.5.3-.3.6-.5.8-.6.1-.1.2-.1.3-.2h.1l-.1-.1v.2s.1 0 .3-.1H231.2v-.2l-.1-.1h-.2v-.2h-.1l.1.1.5-.5.4-.4.2-.2c.1 0 .4.1.7.2.1 0 .3.1.3.1.1 0 .1.1.1.1l1.5.6s1.5.6 2.1.7h.3c.5 0 .8-.3.8-.3l-.1-.1v.1l1.3-.3v-.1.1H240.2c.2 0 .4 0 .6.1.2 0 .3.1.4.1.2.1.3.2.4.3l.1.1.6.8.7-.2-.1.1.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f9f2d8",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.5 223.7s-2.5-.6-2.3-2.9c.2-2.3 2.3-3.1 2.6-3.2.4-.1.3-1.3.7-1.4.4-.1 1.2 0 1.6.3.4.3 1.1.7 1.1.7s-4.4 2-4.4 4.5c0 1.6.7 2 .7 2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f7e8ad",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M243 218.2s-.3.2-.4 0c-.5-.9-1.6-1.1-2.4-1.1-1.1 0-1.9.4-2.7.4-.8 0-.6-.1-1.5-.2-.9 0-2.8-1.5-3.3-1.3-.4.1-.6.7-.5.9 0 .3-.8.3-.9.1-.1-.2.7-1.4 1.4-1.4 2.1 0 3.7 1.4 4.7 1.4s1.4-.6 2.7-.6c1.4.1 2.9.7 2.9 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#4e3a2b",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.2 219.8s1-.2 1.8-.5 1.8-.6 1.8-.6-.9.6-1.6.9c-.6.3-1.7.5-1.7.5l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec643",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M232.6 225c-.2.1-1.1 0-2.5-.9s-1.8-2.5-1.8-2.5-.3-1.5 1.1-3.1c1.4-1.5 1.7-1.1 1.8-1 .1.1-.1.1-.1.1l-1.3 1-.6 1.1-.6 1v1.1l.6 1.1 2 1.3 1.4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#82522a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m231.9 216.3-.1-.2.1.2-.1-.2.1.2-.1-.2-.1.2.1.1v-.2l-.1.2.1-.2h-.2s0 .1.1.2l.1-.2h-.2.2l-.2-.1v.1h.2l-.2-.1.2.1-.1-.1.2.1-.1-.1s0 .1-.1.1c-.1.1-.2.2-.3.4-.1.2-.2.3-.2.5v.1c0 .2.2.4.3.4.2.1.3.1.5.1.3 0 .6-.1.7-.1.1 0 .2-.2.1-.3 0-.1-.1-.2-.3-.1 0 0-.3.1-.5.1h-.3c-.1 0-.1 0-.1-.1 0 0 0-.1.1-.2s.2-.3.3-.4c-.2-.2-.1-.2-.1-.3l.1-.1v-.1s0-.1-.1-.2l-.1-.1h-.1c-.1 0-.2.2-.1.3 0 .2.2.3.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec643",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236.1 218.5s-3 .8-3.1.9c-.2.2.9 0 1.9-.1.6 0 1.1.1 1.1.1s.4 0 .7-.2c1.1-.4 3.5-1.3 3.8-.3.2.9-3.3 1.6-3.3 1.6v.3l2.8-.7 1.5-.8.5-.8-1.4-1h-2.1l-.9.3-1.5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M231.7 222.8c.2.6.7 1.5 1.3 1.8 0 0 .1 0 .1.1s-.4.3-1.4.1c-.9-.2-2.4-.6-3.3-3.3v.6l.5 1 .9 1 1.5.9 1 .2.8-.2.4-.3-.9-.8-1.1-1.8c.1 0 .1.2.2.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca48",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.3-.35-.1 1-.5-.1.1-1.2z",
    transform: "matrix(1.9509 0 0 2.4519 470.947 484.434)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#f3ca48",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.8.35-.9-1.1-.7.1 1 1.4z",
    transform: "matrix(1.9509 0 0 2.4519 462.558 415.045)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#7d6d31",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M241.6 251.6s-.6-.4-1.4-.7c-.8-.4-1.9-.5-1.9-.5v.2h.2c.3.1 1.1.2 1.7.5.4.2.7.3.9.5.1.1.2.1.3.2.1 0 .1.1.1.1l.1-.3zM241.5 249.1h-1.1c-.4 0-.8 0-1.1.1-.7.2-1.1.5-1.1.5l.1.2c.1-.1.5-.3 1-.4.2-.1.7-.1 1-.1h1.1l.1-.3zM241.3 247s-1.4.6-2 1.1c-.6.4-1.3 1-1.3 1l.2.2s.2-.1.4-.3c.2-.2.6-.4.9-.6.3-.2.8-.5 1.2-.7l.8-.4-.2-.3zM239.9 244.8s0 .6-.3.9c-.1.1-.3.3-.5.6-.4.4-.9.9-1.3 1.4-.4.4-.7.8-.7.8l.2.2 1.2-1.2c.3-.3.6-.7.9-.9.2-.3.4-.5.5-.6.3-.5.3-1 .3-1.1h-.3zM238.2 243.8c0 .1.1.4.1.7 0 .3 0 .7-.2 1.1-.2.5-.5 1.2-.8 1.7-.1.3-.3.5-.4.7-.1.2-.2.3-.2.3l.2.1s1-1.8 1.3-2.8c.2-.4.2-.9.2-1.2 0-.4-.1-.7-.1-.7l-.1.1zM236.5 243.6V244.5c0 .5 0 1-.2 1.4-.1.4-.3 1-.5 1.4-.2.5-.3.8-.3.8l.2.1s.5-1.4.8-2.2c.2-.4.2-1 .2-1.5v-.9h-.2zM235.3 243.6v.9c0 .5-.1 1.2-.2 1.6-.2.8-.4 2-.4 2h.2s0-.3.1-.7c.1-.4.2-.9.3-1.3.2-.8.2-2.5.2-2.6h-.2zM233.9 243.8v1.3c0 .4 0 .8-.1 1-.2.8-.3 2-.3 2h.3s0-.3.1-.7c0-.4.1-.9.2-1.3.1-.3.1-.7.1-1.1 0-.7-.1-1.3-.1-1.3l-.2.1zM232.8 244v.1c0 .3 0 1-.2 1.8-.1.5-.3 1.1-.4 1.5-.1.5-.2.8-.2.8l.2.1s.4-1.3.7-2.3c.2-.8.2-1.5.2-1.8v-.2h-.3zM231.6 244v.5c0 .5-.1 1.1-.3 1.7-.2.4-.7.9-1.1 1.2-.2.2-.4.3-.5.4-.1 0-.1.1-.2.1h-.1l.1.2s1.4-.8 1.9-1.8c.3-.6.4-1.3.4-1.8v-.6l-.2.1zM230.8 243.7s0 .1-.1.2c-.1.3-.4 1-.8 1.5-.3.3-.7.6-1 .9-.2.1-.3.2-.4.3-.1.1-.2.1-.2.1l.1.2s1.2-.7 1.7-1.4c.6-.7.9-1.7.9-1.8h-.2zM229.6 243.1l-.1.1c-.1.1-.2.3-.3.5-.1.2-.3.4-.4.5-.2.1-.5.3-.8.5-.3.2-.5.3-.5.3l.1.2s.2-.1.5-.3c.3-.2.6-.4.8-.5.2-.2.4-.5.6-.7.1-.3.3-.5.3-.5l-.2-.1zM229 242.4l-.2.2c-.2.2-.5.5-.7.8l-.4.4c-.1.1-.2.2-.3.2l.1.2c.2 0 .3-.2.5-.3.6-.5 1.3-1.3 1.3-1.3l-.3-.2zM228.8 241.9s-.1.1-.2.1c-.2.1-.4.3-.7.5-.3.2-.5.3-.7.3v.3c.2 0 .3-.1.5-.2.6-.3 1.2-.8 1.2-.8l-.1-.2zM228.5 241.4s-.3.2-.6.3c-.2.1-.3.2-.5.2-.1.1-.3.1-.3.1v.3c.1 0 .3-.1.4-.1.5-.2 1.1-.6 1.1-.6l-.1-.2zM228.3 240.3c-.1.1-.3.3-.5.4-.2.2-.5.3-.7.3v.3c.4 0 .7-.2.9-.4.3-.2.4-.4.4-.4l-.1-.2zM228.4 238.5s-.2.2-.5.4c-.2.2-.5.5-.6.8 0 0 0 .1-.1.1v.2c.1 0 .2-.1.3-.1.1-.1.1-.1.1-.2.1-.2.3-.5.6-.7l.3-.3.1-.1-.2-.1zM236.9 228.3H238.1v-.2.3-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1l-.1.1v-.1l-.1.1.1-.1v.1l.1-.1h-.1v-.1l.1.1v-.1l.1.1v-.1.1-.3.1-.1H237v.3zM237 227.5c.3 0 .4-.1.6-.2.3-.1.5-.4.8-.5.1-.1.3-.2.3-.2.1-.1.2-.1.3-.1v-.3c-.2 0-.3.1-.5.2-.3.1-.5.3-.8.5-.3.2-.5.3-.7.3v.3zM236.8 226.3c.2 0 .4-.1.6-.2.3-.2.6-.4 1-.6.3-.2.6-.3.8-.3v-.3c-.2 0-.4.1-.6.2l-.9.6c-.3.2-.6.4-.8.4l-.1.2zM236.4 225.2c.3-.2.7-.5 1.2-.9s.9-.7 1.3-.9l-.1-.2c-.3.2-.8.6-1.3 1s-.9.7-1.2.9l.1.1zM235.6 223.9c.6-.4 2.1-1.5 2.6-1.8l-.1-.2c-.6.4-2 1.4-2.6 1.8l.1.2zM234.4 222.7c.4-.3.9-.7 1.5-1s1-.6 1.2-.8l-.1-.2c-.2.2-.7.5-1.2.8-.5.3-1.1.7-1.5 1.1l.1.1zM233.6 221.9s.6-.4 1.2-.9c.3-.2.6-.5.9-.6.3-.2.5-.3.6-.4l-.1-.2c-.1.1-.3.2-.6.4-.8.6-2.2 1.5-2.2 1.5l.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m235.6 219.5.2.1c.3.3 1.2 1 2 2s1.4 2.2 1.4 3.3v.3c-.2 1.5-.9 2.8-2 4.1-1.6 1.8-3.8 3.5-5.6 5.1-.9.8-1.8 1.6-2.4 2.5-.6.9-1 1.8-1 2.8v.1c0 .9.3 1.9.9 2.7.6.8 1.4 1.4 2.5 1.5h.6c1.4 0 3-.5 4.5-.5 1.3 0 2.5.3 3.5 1.5 1 1.1 1.3 2.9 1.3 4.6 0 1.2-.2 2.4-.3 3.3-.1.4-.2.8-.2 1.1-.1.3-.1.4-.1.4l.2.1s.6-2.3.6-4.8c0-1.7-.3-3.6-1.4-4.8-1.1-1.2-2.4-1.6-3.7-1.6-1.5 0-3.1.5-4.5.5h-.5c-1-.1-1.8-.7-2.4-1.4-.5-.8-.8-1.7-.9-2.6v-.1c0-1.2.6-2.4 1.6-3.5 1.4-1.6 3.6-3.2 5.6-4.9 1.9-1.7 3.5-3.6 3.8-6v-.4c0-1.4-.9-2.8-1.8-3.9-.9-1-1.8-1.7-1.8-1.7l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#eec643",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m235.7 219.2.3.3s-.3-.1-.4-.1c-.1-.1.1-.2.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#85472a",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M236 219.4s-.4.1-.5.1c-.1 0 .2-.2.2-.2l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#907c35",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M240.7 254.5s.3 0 .5-.2c.1-.2-.1.3-.1.3l-.2.1-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.3-.05 0-.25l-.3.1.5.4z",
    transform: "matrix(1.9509 0 0 2.4519 455.34 416.516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.2.05 0-.15h-.2l.2.3z",
    transform: "matrix(1.9509 0 0 2.4519 457.096 418.232)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.15 0-.2-.2-.1.1.2.3z",
    transform: "matrix(1.9509 0 0 2.4519 459.34 421.297)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.15.1-.1-.3-.2.1.3.3z",
    transform: "matrix(1.9509 0 0 2.4519 460.9 424.24)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.05.2-.1-.4v.4z",
    transform: "matrix(1.9509 0 0 2.4519 462.07 426.937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.1.25v-.4l-.2-.1.1.5z",
    transform: "matrix(1.9509 0 0 2.4519 462.168 429.756)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.05.15.1-.3-.1-.1v.5z",
    transform: "matrix(1.9509 0 0 2.4519 462.266 431.718)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M227.2 240.1s0-.3.1-.6-.2.1-.2.1v.4l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m227.1 240.9-.1.1.1.4.1-.1c-.1-.1-.1-.3-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#777433",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.1.1 0-.3h-.1v.6z",
    transform: "matrix(1.9509 0 0 2.4519 443.05 466.167)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.05.15v-.3h-.1v.3z",
    transform: "matrix(1.9509 0 0 2.4519 443.147 468.006)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M.1.1 0-.2l-.1.1.1.3z",
    transform: "matrix(1.9509 0 0 2.4519 443.635 470.826)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.1.2-.2-.4.1.4z",
    transform: "matrix(1.9509 0 0 2.4519 444.22 473.523)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m.15.05-.2-.2h-.1l.2.3z",
    transform: "matrix(1.9509 0 0 2.4519 445.488 477.568)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M229.7 248.1s-.2-.1-.4-.3c-.2-.2-.1.2-.1.2l.3.2.2-.1zM237.5 248.7s-.2-.1-.3-.2c0 0 .1 0 .2.3.1.2.1-.1.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "m238.2 249.2-.3-.3c-.1-.1-.1.2-.1.2l.2.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#a5ab72",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M238.3 249.5c-.1-.1-.2.2-.2.2l.2.2c.1 0 .1-.3 0-.4M238.3 250.6v-.4c0-.1-.1 0-.1 0l.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-.05.1.1-.2h-.1v.2z",
    transform: "matrix(1.9509 0 0 2.4519 464.217 489.215)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(1.9509 0 0 2.4519 0 -127.683)",
    d: "M226 210.1s.4-.1.1.4c-.3.5.2-.5.2-.5l-.2-.1-.1.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9509 0 0 2.4519 566.834 543.28)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.6974 3.2143 -6.2355 5.3864 4920.01 -2273.503)",
    cx: -356.53,
    cy: 634.793,
    r: 0.371,
    fx: -356.53,
    fy: 634.793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e05173",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-290.55 -273.65)",
    d: "M289.5 272c-1.5 1.3-2.2 3-1.6 3.8.6.8 2.3.4 3.8-.9s2.2-3 1.6-3.8c-.2-.3-.5-.4-.9-.4-.9 0-2 .5-2.9 1.3",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#f)",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "m-6.15-.55 5.6 6.8 6.7-5.8-5.6-6.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMex);
export default __webpack_public_path__ + "static/media/flag-mex.1162dbf94bae3924b4701377722638e9.svg";
export { ForwardRef as ReactComponent };